import { auditBlockRu } from './auditLocales'

const ru = {
  iconPicker: {
    title: 'Выберите иконку',
    titlePhoto: 'Выберите фотографию',
    searchPlaceholder: 'Поиск иконок...',
    background: 'Фон',
    customColor: 'Свой цвет',
    colors: {
      teal: 'Бирюзовый',
      blue: 'Синий',
      indigo: 'Индиго',
      violet: 'Фиолетовый',
      fuchsia: 'Фуксия',
      pink: 'Розовый',
      red: 'Красный',
      amber: 'Янтарный',
      emerald: 'Изумрудный',
      cyan: 'Голубой',
      slate: 'Графитовый',
      deepCyan: 'Тёмно-голубой',
      purple: 'Пурпурный'
    },
    tabIcons: 'Иконки',
    tabPhoto: 'Своё фото',
    photoDrop: 'Перетащите изображение или',
    photoReplace: 'Замените изображение или',
    photoDropAction: 'выберите файл',
    photoRemove: 'Удалить',
    photoHint: 'PNG, JPG, SVG · до {{size}} МБ · минимум {{pixels}}×{{pixels}}',
    photoTypeError: 'Принимаются только PNG, JPG или SVG.',
    photoSizeError: 'Файл больше {{size}} МБ.',
    photoDimensionError: 'Изображение меньше {{size}}×{{size}}.',
    select: 'Выбрать',
    emptyTitle: 'Иконки не найдены',
    emptyDescription: 'Попробуйте другой запрос.'
  },
  agents: {
    scopes: {
      app: {
        core: 'Core',
        crm: 'CRM',
        hrm: 'HRM',
        notification: 'Уведомления',
        squad: 'Squad'
      },
      action: {
        read: 'Чтение',
        write: 'Запись',
        manage: 'Управление',
        provision: 'Провижининг',
        invoke: 'Вызов'
      },
      gatedHint: 'Подключите инструменты {{app}}, чтобы выдать этот доступ.',
      gatedConnect: 'Подключить инструменты'
    }
  },
  tickets: {
    create: 'Создать тикет',
    submitTab: 'Отправить тикет',
    myTicketsTab: 'Мои тикеты',
    cancel: 'Отмена',
    submit: 'Отправить',
    successCreate: 'Тикет успешно создан',
    ticket: 'Тикет',
    example: 'Ошибка входа в систему.',
    description: 'Описание',
    example_description:
      'При попытке входа появляется сообщение об ошибке. Требуется срочная проверка.',
    attachments: 'Вложения',
    dragAndDrop: 'Перетащите файлы сюда или',
    selectFile: 'выберите',
    uploadHint: 'Поддерживается одиночная и массовая загрузка.',
    status: 'Статус',
    statusFilter: 'Фильтр',
    open: 'Открытые',
    closed: 'Закрытые',
    createdOn: 'Создан',
    startDate: 'Дата начала',
    dueDate: 'Срок',
    noComments: 'Комментариев пока нет',
    commentPlaceholder: 'Добавить ответ...',
    commentAdded: 'Комментарий успешно добавлен',
    closedChatReadOnly:
      'Этот тикет закрыт. Переписка доступна только для чтения.',
    commentFromClickup: 'Поддержка',
    commentsLoadError: 'Не удалось загрузить комментарии',
    noTickets: 'Тикетов пока нет. Отправьте тикет на первой вкладке.',
    listError: 'Не удалось загрузить тикеты',
    retry: 'Повторить',
    originalRequest: 'Исходный запрос',
    detailsLoadError: 'Не удалось загрузить детали тикета',
    priority: {
      label: 'Приоритет',
      urgent: 'Срочный',
      high: 'Высокий',
      normal: 'Обычный',
      low: 'Низкий'
    },
    opened: 'Открыт',
    activity: 'Переписка',
    emoji: 'Эмодзи',
    hasUpdate: 'Есть обновление'
  },
  common: {
    retry: 'Повторить',
    backToLogin: 'Вернуться к входу',
    comingSoon: 'Скоро',
    cancel: 'Отмена',
    edit: 'Изменить',
    delete: 'Удалить'
  },
  errors: {
    somethingWentWrong: 'Что-то пошло не так. Пожалуйста, попробуйте снова.'
  },
  not_found: {
    title: 'Страница не найдена',
    back_home: 'Вернуться на главную'
  },
  ui: {
    loading: 'Загрузка',
    loadError: 'Не удалось загрузить',
    loadErrorDescription: 'Проверьте соединение и попробуйте снова.',
    retry: 'Повторить',
    breadcrumb: 'Навигационная цепочка',
    tableEmpty: 'Нет данных',
    noValue: '—'
  },
  placeholders: {
    name: 'Введите название',
    description: 'Введите описание',
    email: 'пользователь@пример.com',
    fullName: 'Введите полное имя',
    appName: 'Введите название приложения',
    teamName: 'Введите название команды',
    roleName: 'Введите название роли',
    functionName: 'Введите название функции',
    displayName: 'Введите отображаемое имя',
    connectionName: 'Введите название подключения',
    credentialName: 'Введите название учётных данных',
    webhookName: 'Введите название вебхука',
    webhookUrl: 'https://пример.com/webhook',
    clientId: 'Введите ID клиента',
    clientSecret: 'Введите секрет клиента',
    abbreviation: 'напр. ИНЖ',
    scope: 'openid profile email',
    issuerUrl: 'https://издатель.пример.com/',
    jwksUrl: 'https://пример.com/.well-known/jwks.json',
    authorizeUrl: 'https://пример.com/authorize',
    tokenUrl: 'https://пример.com/token'
  },
  audit: auditBlockRu,
  welcome_back: 'С возвращением',
  sign_in: 'Войти',
  sign_up: 'Зарегистрироваться',
  welcome_to_skalx: 'Добро пожаловать в Skalx',
  sign_up_to_create: 'Зарегистрируйтесь, чтобы создать аккаунт',
  auth_hero_title: 'Один аккаунт для всех приложений Skalx',
  auth_hero_subtitle:
    'Управляйте организациями, командами и доступом из единой защищённой учётной записи.',
  auth_hero_feature_sso: 'Единый вход во все приложения',
  auth_hero_feature_orgs: 'Организации, команды и роли в одном месте',
  auth_hero_feature_security: 'Безопасность, сессии и аудит встроены',
  next: 'Далее',
  have_account: 'Уже есть аккаунт?',
  have_questions: 'Есть вопросы?',
  contact_us: 'Свяжитесь с нами',
  company_name: 'Название компании',
  domain: 'Домен',
  email: 'Электронная почта',
  phone_number: 'Номер телефона',
  password: 'Пароль',
  input_placeholder_password: 'Введите пароль',
  i_agree: 'Я согласен с',
  terms_and_conditions: 'Условиями и положениями',
  terms_title: 'Условия и положения',
  terms_updated: 'Дата вступления в силу: 29 января 2026',
  terms_intro:
    'Эти Условия регулируют доступ к аккаунту EBS и использование сервиса. Создавая аккаунт или используя сервис, вы соглашаетесь с этими Условиями.',
  terms_section_acceptance_title: 'Принятие',
  terms_section_acceptance_body:
    'Вы должны быть вправе заключать договор и использовать сервис только в рамках закона.',
  terms_section_account_title: 'Безопасность аккаунта',
  terms_section_account_body:
    'Вы несете ответственность за сохранность учетных данных и действия в вашем аккаунте.',
  terms_section_use_title: 'Допустимое использование',
  terms_section_use_body:
    'Не используйте сервис неправомерно, не мешайте его работе и не получайте доступ несанкционированным способом.',
  terms_section_privacy_title: 'Конфиденциальность',
  terms_section_privacy_body:
    'Мы обрабатываем персональные данные в соответствии с применимым законодательством и нашей практикой защиты данных.',
  terms_section_availability_title: 'Доступность',
  terms_section_availability_body:
    'Сервис предоставляется «как есть» и может быть изменен, прерван или прекращен без предварительного уведомления.',
  terms_section_changes_title: 'Изменения и прекращение',
  terms_section_changes_body:
    'Мы можем обновлять эти Условия или ограничить доступ при нарушениях или угрозах безопасности.',
  terms_contact: 'Вопросы по Условиям? Свяжитесь с нами по адресу',
  password_repeat: 'Повторите пароль',
  passwords_must_match: 'Пароли должны совпадать',
  created_by: 'Создано',
  brand: {
    visitWebsite: 'Перейти на skalx.ai'
  },
  required_field_error: 'Это обязательное поле',
  form_validation_error: 'Пожалуйста, исправьте ошибки в форме',
  first_name: 'Имя',
  last_name: 'Фамилия',
  registration_success: 'Регистрация успешно завершена',
  back: 'Назад',
  continue: 'Продолжить',
  registration_check_email:
    'Проверьте почту — мы отправили ссылку для подтверждения',
  registration_email_sent_title: 'Проверьте почту',
  registration_email_sent_description:
    'Мы отправили ссылку для подтверждения на {{email}}. Откройте её, чтобы задать пароль и завершить регистрацию.',
  registration_confirm_title: 'Задайте пароль',
  registration_confirm_description:
    'Придумайте пароль, чтобы завершить регистрацию',
  registration_confirm_missing_token_title: 'Неверная ссылка подтверждения',
  registration_confirm_missing_token_description:
    'В ссылке нет токена подтверждения. Откройте последнее письмо или начните регистрацию заново.',
  registration_token: 'Токен подтверждения',
  registration_token_placeholder: 'Вставьте токен из письма',
  invalid_domain_format:
    'Домен должен начинаться с буквы, заканчиваться буквой или цифрой и содержать только строчные латинские буквы, цифры и одиночные дефисы',
  password_min_length: 'Пароль должен содержать минимум 8 символов',
  password_policy:
    'Пароль должен быть не менее 10 символов, содержать одну заглавную букву, одну цифру и один специальный символ из этого списка (!@#$%^&*()_+)',
  registration: 'Регистрация',
  sign_in_your_account: 'Войдите в свой аккаунт',
  do_not_have_account: 'Нет аккаунта?',
  forgot_password: 'Забыли пароль?',
  submit: 'Отправить',
  enter_email_send_new_one: 'Введите свою почту, и мы отправим вам новый',
  check_email_instruction:
    'Проверьте почту — мы отправили ссылку для сброса пароля. Если письма нет, проверьте папку «Спам».',
  reset_password_again: 'Попробовать снова или указать другой email',
  reset_password_missing_token_title: 'Неверная ссылка для сброса',
  reset_password_missing_token_description:
    'В этой ссылке нет токена сброса. Запросите новое письмо для сброса пароля, чтобы продолжить.',
  reset_password_request_new_link: 'Запросить новую ссылку',
  invitation_title: 'Присоединиться к {{organization}}',
  invitation_subtitle: 'Настройте аккаунт, чтобы принять приглашение',
  invitation_email_hint: 'Приглашение отправлено на {{email}}',
  invitation_accept: 'Принять приглашение',
  invitation_accepted: 'Приглашение принято — войдите, чтобы продолжить',
  invitation_existing_account:
    'У вас уже есть аккаунт. Войдите — рабочее пространство будет вас ждать.',
  invitation_sign_in_to_join: 'Войти и присоединиться',
  invitation_missing_token_title: 'Ссылка приглашения недействительна',
  invitation_missing_token_description:
    'В ссылке нет токена приглашения. Откройте последнее приглашение из письма.',
  invitation_invalid_title: 'Этим приглашением больше нельзя воспользоваться',
  invitation_invalid_description:
    'Возможно, оно истекло, было отозвано или уже принято. Попросите администратора рабочего пространства отправить новое.',
  login_success: 'Вход выполнен успешно',
  auth: {
    signInWithGoogle: 'Войти через Google',
    signUpWithGoogle: 'Зарегистрироваться через Google',
    signUpWithApple: 'Зарегистрироваться через Apple',
    signInWithApple: 'Войти через Apple',
    signInWithPasskey: 'Войти с помощью passkey',
    signInWithCustomProvider: 'Войти через {{name}}',
    passkeyRecommendation: {
      title: 'Защитите аккаунт с помощью passkey',
      description:
        'Используйте отпечаток пальца, распознавание лица или блокировку экрана для быстрого и безопасного входа.',
      setup: 'Настроить passkey',
      later: 'Позже',
      dontAsk: 'Больше не спрашивать',
      nameLabel: 'Название passkey',
      namePlaceholder: 'например, Мой ноутбук',
      success: 'Passkey добавлен! Теперь вы можете входить с его помощью.',
      alreadyRegistered: 'На этом устройстве уже настроен passkey'
    },
    signInWithEntraid: 'Войти через Microsoft',
    or: 'или продолжить с',
    resendCooldownHint: 'Подождите немного перед повторной отправкой.',
    resendInSeconds_one: 'Можно отправить снова через {{count}} секунду.',
    resendInSeconds_few: 'Можно отправить снова через {{count}} секунды.',
    resendInSeconds_many: 'Можно отправить снова через {{count}} секунд.',
    resendInSeconds_other: 'Можно отправить снова через {{count}} секунды.',
    passwordSignInUnavailable: 'Вход по паролю сейчас недоступен.',
    mfaRequired: 'Требуется дополнительная проверка. Проверьте почту.',
    mfa: {
      otpTitle: 'Подтвердите вашу личность',
      otpDescription:
        'Мы отправили код подтверждения на вашу почту. Введите его ниже, чтобы продолжить.',
      otpLabel: 'Код подтверждения',
      otpRequired: 'Введите код подтверждения',
      codeExpired: 'Код истёк. Запросите новый.',
      codeExpiresIn: 'Код истекает через {{time}}',
      keepMeLoggedIn: 'Оставаться в системе на этом устройстве',
      resendOtp: 'Отправить код повторно',
      otpSent: 'Новый код отправлен на вашу почту',
      moreOptions: 'Другие варианты',
      useBackupCode: 'Использовать резервный код',
      backupCodeTitle: 'Резервный код',
      backupCodeDescription:
        'Введите один из ваших кодов восстановления для входа.',
      backupCodeLabel: 'Резервный код',
      backupCodeRequired: 'Введите резервный код',
      tokenExpired: 'Сессия истекла. Пожалуйста, войдите снова.',
      setupTitle: 'Настройка двухфакторной аутентификации',
      setupDescription:
        'Ваше рабочее пространство требует двухфакторную аутентификацию. Мы отправили код подтверждения на вашу почту.'
    },
    emailOtp: {
      title: 'Вход по email',
      subtitle: 'Введите email — мы отправим одноразовый код.',
      emailLabel: 'Email',
      emailPlaceholder: 'you@example.com',
      emailRequired: 'Введите email',
      emailInvalid: 'Введите корректный email',
      submit: 'Продолжить',
      codeTitle: 'Введите код подтверждения',
      codeSubtitle:
        'Мы отправили код на <email>{{email}}</email>. Введите его, чтобы войти.',
      codeLabel: 'Код подтверждения',
      codeRequired: 'Введите код',
      codeExpired: 'Срок действия кода истёк. Запросите новый.',
      codeExpiresIn: 'Код действителен ещё {{time}}',
      codeSent: 'Новый код отправлен на вашу почту',
      resend: 'Отправить код',
      shortLabel: 'Email',
      useOtpInstead: 'Войти по одноразовому коду',
      usePasswordInstead: 'Войти с паролем',
      backToSignIn: 'Назад ко входу',
      tokenExpired: 'Срок сессии входа истёк. Попробуйте снова.',
      linkSentTitle: 'Проверьте почту',
      linkSentSubtitle:
        'Мы отправили ссылку для входа на <email>{{email}}</email>. Кликните по кнопке в письме, чтобы войти.',
      linkResend: 'Отправить письмо ещё раз',
      or: 'или',
      enterCodeInstead: 'Ввести код вручную',
      useLinkInstead: 'Войти по ссылке из письма',
      linkCallback: {
        verifying: 'Выполняется вход…',
        subtitle: 'Подождите, пока мы проверим ссылку для входа.',
        errorTitle: 'Ссылка для входа недействительна или истекла',
        errorBody:
          'Эту ссылку больше нельзя использовать. Запросите новый код или введите 6-значный код из письма.',
        backToSignIn: 'Назад ко входу'
      }
    },
    qrSignIn: {
      title: 'Вход по QR-коду',
      subtitle:
        'Откройте мобильное приложение Skalx на устройстве, где вы уже вошли, и отсканируйте этот код.',
      useQrInstead: 'Войти по QR-коду',
      refresh: 'Обновить',
      heroTitle: 'Войти с QR-кодом',
      heroDescription:
        'Отсканируйте код с помощью камеры на телефоне, чтобы мгновенно войти в систему.',
      waiting: 'Ожидаем сканирования. Код истекает через {{seconds}} с.',
      scanned: 'Код отсканирован. Подтвердите вход на телефоне.',
      tryAgain: 'Попробовать снова',
      cancel: 'Отменить вход по QR',
      deniedToast: 'Вход по QR был отменён на телефоне.',
      canceledToast: 'Вход по QR отменён.',
      expired: {
        title: 'Код истёк',
        description:
          'Этот QR-код больше не активен. Создайте новый код, чтобы продолжить.'
      },
      denied: {
        title: 'Вход отменён',
        description:
          'Запрос был отклонён на телефоне. Начните заново, если это были вы.'
      },
      canceled: {
        title: 'Вход по QR отменён',
        description:
          'Начните заново, когда будете готовы сканировать новый код.'
      },
      error: {
        title: 'Вход по QR недоступен',
        description:
          'Не удалось начать или продолжить вход по QR. Попробуйте ещё раз.'
      },
      approved: {
        title: 'Подтверждено',
        description: 'Завершаем вход...'
      }
    },
    noLoginMethodsEnabled:
      'Для этой организации не включены методы входа. Обратитесь к администратору.',
    googleCallbackMissingParams: 'Неверный ответ при входе. Попробуйте снова.',
    googleNotLinkedToOrg:
      'Вход через Google не привязан к этой организации. Подключите Google в профиле или войдите другим способом.',
    register: {
      accountTitle: 'Создайте аккаунт',
      accountSubtitle:
        'Начните с личного аккаунта. После входа можно добавить или присоединиться к пространствам.',
      switchToWorkspaceFlow: 'Регистрация с созданием пространства за один шаг',
      switchToAccountFlow: 'Регистрация только аккаунта (пространство позже)',
      accountContinuesToWorkspaceSetup:
        'Продолжите, создав первое рабочее пространство. Когда API будет готов, этот шаг можно будет пропустить.',
      accountLinkShort: 'Регистрация (только аккаунт)'
    },
    onboarding: {
      title: 'Завершите настройку',
      description: 'Создайте первую организацию, чтобы начать.',
      tokenReady: 'Вы можете продолжить на следующем шаге.',
      createOrganization: 'Создать организацию',
      missingToken: 'Недействительная или отсутствующая ссылка. Войдите снова.'
    },
    appleCallbackMissingParams:
      'Некорректный ответ входа через Apple. Попробуйте ещё раз.',
    appleNotLinkedToOrg:
      'Вход через Apple не привязан к этой организации. Привяжите его в настройках профиля.'
  },
  email_sent_success: 'Электронное письмо успешно отправлено',
  password_reset_success: 'Сброс пароля прошёл успешно',
  reset_password: 'Сбросить пароль',
  enter_new_password: 'Введите новый пароль',
  logout: 'Выйти',
  menu: {
    organizations: 'Организации',
    home: 'Главная',
    account: 'Аккаунт',
    workspaces: 'Рабочие пространства',
    billing: 'Оплата'
  },
  shell: {
    menu: {
      home: 'Главная',
      overview: 'Обзор',
      users: 'Пользователи',
      roles: 'Роли',
      organization: 'Организация',
      ssoSaml: 'SSO и SAML',
      authentication: 'Аутентификация',
      apps: 'Приложения',
      agents: 'Агенты',
      domains: 'Домены',
      publicAccess: 'Публичный доступ',
      aiConnectors: 'AI-коннекторы',
      auditLog: 'Журнал аудита',
      companyGraph: 'Граф компании',
      workspaceSettings: 'Настройки пространства',
      billing: 'Оплата',
      createWorkspace: 'Создать пространство',
      comingSoon: 'Скоро',
      groups: {
        gettingStarted: 'Начало работы',
        workspace: 'Рабочее пространство',
        identity: 'Идентификация',
        applications: 'Приложения',
        developers: 'Разработчики',
        compliance: 'Соответствие',
        settings: 'Настройки'
      },
      tags: {
        ai: 'AI',
        preview: 'Предпросмотр'
      }
    },
    welcome: {
      greeting: 'Добро пожаловать в'
    },
    switcher: {
      switchWorkspace: 'Переключить пространство',
      accountSettings: 'Настройки аккаунта',
      createWorkspace: 'Создать пространство',
      signOut: 'Выйти',
      ariaLabel: 'Активное пространство',
      noWorkspace: 'Нет пространства',
      noWorkspaceMeta: 'Создайте, чтобы начать'
    },
    user: {
      accountSettings: 'Настройки аккаунта',
      signOut: 'Выйти',
      fallback: 'Пользователь'
    },
    topbar: {
      searchPlaceholder: 'Поиск…',
      docs: 'Документация',
      openWorkspace: 'Открыть рабочее пространство — {{url}}',
      language: 'Язык',
      theme: 'Тема',
      themeMode: {
        light: 'Светлая',
        dark: 'Тёмная',
        system: 'Системная'
      }
    },
    sidebar: {
      expand: 'Развернуть',
      collapse: 'Свернуть'
    },
    gettingStarted: {
      title: 'Начало работы',
      progress: '{{done}}/{{total}}',
      encouragement: 'Так держать!',
      more: 'Действия с чеклистом',
      learnMore: 'Подробнее',
      hideForDays: 'Скрыть на {{days}} дней',
      dismiss: 'Скрыть навсегда',
      errors: {
        generic:
          'Шаг не удалось завершить. Откройте его страницу и попробуйте снова.',
        code_expired:
          'Срок действия кода подтверждения истёк. Запросите новый.',
        code_invalid: 'Код подтверждения не принят.',
        m365_admin_consent_required:
          'Подключение должен разрешить администратор Microsoft 365.',
        domain_not_verified: 'Домен ещё не подтверждён.',
        import_parse_failed: 'Не удалось прочитать загруженный файл.',
        provisioning_failed:
          'Не удалось подготовить пространство. Повторите в настройках пространства.'
      },
      dismissModal: {
        title: 'Скрыть чеклист?',
        subtitle: 'Расскажите почему — и он больше не появится.',
        reasons: {
          already_set_up: 'Уже настроил по-своему',
          not_relevant: 'Не относится к моей роли',
          later: 'Сделаю позже',
          not_interested: 'Не интересно'
        }
      },
      items: {
        invite_users: {
          title: 'Пригласите команду',
          description:
            'Отправьте приглашения коллегам — воркспейс оживает, когда в нём есть кто-то кроме вас.',
          cta: 'Пригласить'
        },
        roles: {
          title: 'Роли и права',
          description:
            'Опишите, кому что можно: соберите роли из прав вместо того, чтобы выдавать их каждому вручную.',
          cta: 'Настроить'
        },
        authentication: {
          title: 'Настройте вход',
          description:
            'Подключите SSO или свой провайдер, чтобы команда входила рабочим аккаунтом.',
          cta: 'Настроить'
        },
        workspace_settings: {
          title: 'Проверьте настройки',
          description:
            'Название, логотип, домены и часовой пояс — то, что видит каждый участник воркспейса.',
          cta: 'Проверить'
        },
        profile: {
          title: 'Заполните профиль',
          description:
            'Имя и фото — то, по чему коллеги узнают вас в списках, упоминаниях и журнале действий.',
          cta: 'Заполнить'
        },
        security: {
          title: 'Защитите аккаунт',
          description:
            'Добавьте passkey или двухфакторную аутентификацию — одного пароля для входа мало.',
          cta: 'Защитить'
        },
        apps: {
          title: 'Посмотрите приложения',
          description:
            'Приложения этого воркспейса — то, в чём вы и будете работать каждый день. Осмотритесь.',
          cta: 'Посмотреть'
        }
      }
    },
    footer: {
      ariaLabel: 'Подвал сайта',
      brand: 'Skalx',
      poweredBy: 'Powered by',
      versionTooltip: 'Версия сборки приложения',
      status: {
        operational: 'Все системы работают',
        tooltip: 'Статус в реальном времени — status.skalx.ai'
      },
      links: {
        docs: 'Документация',
        status: 'Статус',
        changelog: 'Что нового',
        privacy: 'Приватность',
        support: 'Поддержка'
      }
    },
    account: {
      profile: 'Профиль',
      authentication: 'Аутентификация',
      security: 'Безопасность',
      notifications: 'Уведомления',
      activity: 'Активность',
      audit: 'Аудит',
      sessions: 'Сессии и устройства'
    }
  },
  organization: {
    pageTitle: 'Организация',
    pageSubtitle: 'Подразделения, отделы и команды — схема, дерево и таблица.',
    types: {
      division: 'Подразделение',
      department: 'Отдел',
      team: 'Команда'
    },
    views: {
      chart: 'Схема',
      tree: 'Дерево',
      browse: 'Таблица'
    },
    toolbar: {
      searchPlaceholder: 'Найти команду или сотрудника…',
      types: {
        all: 'Тип',
        divisions: 'Подразделения',
        departments: 'Отделы',
        teams: 'Команды'
      }
    },
    kpis: {
      divisions: 'Подразделения',
      departments: 'Отделы',
      teams: 'Команды',
      membersAssigned: 'Назначено сотрудников',
      openPositions: 'Открытые позиции',
      of: 'из {{total}}'
    },
    actions: {
      export: 'Экспорт',
      newDivision: 'Новое подразделение',
      viewDetails: 'Подробнее',
      edit: 'Изменить',
      delete: 'Удалить',
      more: 'Действия',
      addShort: 'Добавить',
      add: {
        division: 'Добавить подразделение',
        department: 'Добавить отдел',
        team: 'Добавить команду'
      }
    },
    tree: {
      columns: {
        name: 'Название',
        lead: 'Руководитель',
        headcount: 'Состав',
        subUnits: 'Подразделения'
      },
      empty: 'Подразделений, отделов или команд пока нет.',
      expand: 'Развернуть',
      collapse: 'Свернуть',
      leadVacant: 'Руководитель не назначен',
      subUnitsCount_one: '{{count}} подразделение',
      subUnitsCount_few: '{{count}} подразделения',
      subUnitsCount_many: '{{count}} подразделений',
      subUnitsCount_other: '{{count}} подразделений'
    },
    browse: {
      columns: {
        name: 'Название',
        type: 'Тип',
        parent: 'Родитель',
        lead: 'Руководитель',
        headcount: 'Состав',
        openPositions: 'Открытые позиции',
        created: 'Создано'
      },
      workspaceRoot: 'Рабочее пространство',
      total_one: '{{count}} единица',
      total_few: '{{count}} единицы',
      total_many: '{{count}} единиц',
      total_other: '{{count}} единиц'
    },
    detail: {
      inParent: 'в {{parent}}',
      stats: {
        headcount: 'Состав',
        budgeted: 'По бюджету',
        open: 'Открытые',
        subUnits: 'Подразделения'
      },
      lead: {
        title: 'Руководитель',
        none: 'Руководитель не назначен',
        change: 'Сменить руководителя',
        assign: 'Назначить руководителя'
      },
      subUnits: {
        departmentPlural: 'Отделы',
        teamPlural: 'Команды',
        divisionPlural: 'Подразделения'
      },
      members: {
        title: 'Сотрудники',
        empty: 'Прямых сотрудников пока нет.',
        showAll: 'Показать всех {{count}} сотрудников →',
        add: 'Добавить сотрудника',
        remove: 'Убрать из команды',
        addModal: {
          title: 'Добавить сотрудника в {{team}}',
          userLabel: 'Пользователь',
          userPlaceholder: 'Найдите коллегу',
          userRequired: 'Выберите пользователя',
          submit: 'Добавить',
          cancel: 'Отмена',
          noCandidates: 'Все уже состоят в этой команде.'
        },
        removeConfirm: {
          title: 'Убрать сотрудника?',
          content:
            'Убрать {{name}} из «{{team}}»? Учётная запись и другие команды сохранятся.',
          confirm: 'Убрать',
          cancel: 'Отмена'
        }
      },
      metadata: {
        title: 'Метаданные',
        unitId: 'ID',
        type: 'Тип',
        parent: 'Родитель',
        created: 'Создано'
      }
    },
    form: {
      createTitle: 'Создать {{type}}',
      editTitle: 'Изменить {{type}}',
      cancel: 'Отмена',
      create: 'Создать',
      saveChanges: 'Сохранить',
      fields: {
        name: 'Название',
        type: 'Тип',
        parent: 'Родитель',
        abbreviation: 'Сокращение',
        description: 'Описание',
        lead: 'Руководитель'
      },
      placeholders: {
        name: 'напр. Инженерия, Продажи EMEA',
        parent: 'Выберите родительскую единицу',
        description: 'Необязательное описание — за что отвечает эта единица?',
        lead: 'Выберите сотрудника для руководства'
      },
      required: {
        name: 'Название обязательно',
        parent: 'Родительская единица обязательна'
      },
      noParents: 'Пока нет {{type}} — создайте сначала родителя.',
      notApiBackedFields: {
        title: 'Часть полей пока только визуальная',
        description:
          'Цвет, бюджетируемый состав и открытые позиции из макетов ещё не сохраняются на бэкенде. Они будут помечены значком "API в ожидании" до появления поддержки.',
        examples: 'Цвет · бюджет · открытые позиции'
      }
    },
    delete: {
      title: 'Удалить эту единицу?',
      content:
        'Это окончательно удалит "{{name}}". Сотрудники сохранят свои аккаунты, но лишатся этого назначения.',
      confirm: 'Удалить',
      cancel: 'Отмена'
    },
    toasts: {
      created: 'Единица создана',
      createFailed: 'Не удалось создать',
      updated: 'Единица обновлена',
      updateFailed: 'Не удалось обновить',
      deleted: 'Единица удалена',
      deleteFailed: 'Не удалось удалить',
      memberAdded: 'Сотрудник добавлен',
      memberAddFailed: 'Не удалось добавить сотрудника',
      memberRemoved: 'Сотрудник убран',
      memberRemoveFailed: 'Не удалось убрать сотрудника',
      teamRoleGranted: 'Роль выдана команде',
      teamRoleRevoked: 'Роль отозвана у команды'
    },
    notApiBacked: {
      short: 'API в ожидании',
      tooltip:
        'Это поле показано для соответствия макетам, но ещё не сохраняется в API.',
      budget: 'Бюджет и открытые позиции пока не сохраняются в API.',
      exportTooltip:
        'CSV-экспорт не подключён к API — кнопка показана для соответствия макетам.',
      exportToast: 'Экспорт пока не реализован (нет API-эндпоинта).'
    }
  },
  users: {
    title: 'Пользователи',
    tabs: {
      people: 'Пользователи',
      groups: 'Группы',
      joinRequests: 'Заявки'
    },
    joinRequests: {
      searchPlaceholder: 'Поиск по имени или почте',
      approveAs: 'Принимать как',
      approve: 'Принять',
      reject: 'Отклонить',
      approveConfirm: 'Впустить {{email}} в это пространство?',
      rejectConfirm: 'Отклонить заявку от {{email}}?',
      approved: '{{email}} добавлен в пространство.',
      rejected: 'Заявка от {{email}} отклонена.',
      columns: {
        person: 'Пользователь',
        requested: 'Запрошено',
        status: 'Статус',
        reviewed: 'Рассмотрено',
        actions: 'Действия'
      },
      status: {
        pending: 'Ожидают',
        approved: 'Приняты',
        rejected: 'Отклонены'
      }
    },
    groups: {
      searchPlaceholder: 'Поиск групп…',
      organizationScope: 'Рабочее пространство',
      memberCount_one: '{{count}} участник',
      memberCount_few: '{{count}} участника',
      memberCount_many: '{{count}} участников',
      memberCount_other: '{{count}} участников',
      columns: {
        name: 'Группа',
        members: 'Участники',
        roles: 'Выдаваемые роли',
        created: 'Создана',
        updated: 'Обновлена'
      },
      actions: {
        create: 'Новая группа',
        edit: 'Изменить',
        delete: 'Удалить',
        more: 'Ещё действия'
      },
      form: {
        createTitle: 'Новая группа',
        editTitle: 'Изменить группу',
        name: 'Название',
        namePlaceholder: 'напр. Команда поддержки',
        nameRequired: 'Укажите название группы.',
        members: 'Участники',
        addMember: 'Добавить участника',
        removeMember: 'Убрать из группы',
        membersEmpty: 'Пока нет участников.',
        membersPlaceholder: 'Поиск коллег',
        membersHint: 'Изменения сохраняются вместе с группой.',
        roles: 'Выдаваемые роли',
        rolesPlaceholder: 'Поиск ролей',
        rolesTruncated:
          'Показаны первые 200 ролей. Сузьте список ролей, если нужной нет.',
        rolesHint:
          'Участники получают эти роли — и доступ к приложениям, которым роли принадлежат.',
        save: 'Сохранить',
        cancel: 'Отмена',
        created: 'Группа создана',
        updated: 'Группа обновлена'
      },
      detail: {
        metadata: 'Детали',
        rolesEmpty: 'Группа пока не выдаёт ролей.',
        showAllMembers: 'Показать всех участников ({{count}}) →',
        removeSuccess: 'Участник убран из группы',
        removeConfirm: {
          title: 'Убрать из группы',
          content:
            'Убрать {{name}} из «{{group}}»? Роли, которые есть у него лично или через другую группу, сохранятся.',
          confirm: 'Убрать'
        }
      },
      delete: {
        title: 'Удалить группу',
        description:
          'Удалить «{{name}}»? Учётные записи участников сохранятся — удаляется только группа.',
        submit: 'Удалить группу',
        success: 'Группа удалена'
      }
    },
    statuses: {
      all: 'Все',
      active: 'Активные',
      invited: 'Приглашены',
      suspended: 'Заблокированы',
      inactive: 'Неактивные'
    },
    roles: {
      owner: 'Владелец',
      admin: 'Админ',
      employee: 'Сотрудник'
    },
    invite: {
      drawerTitle: 'Пригласить участников',
      description:
        'Добавьте один или несколько адресов электронной почты, выберите роль и при необходимости назначьте руководителя. Мы отправим каждому письмо с приглашением.',
      submit: 'Отправить приглашения',
      cancel: 'Отмена',
      success_one: 'Приглашение отправлено',
      success_other: 'Отправлено приглашений: {{count}}',
      fields: {
        emails: 'Адреса электронной почты',
        emailsPlaceholder: 'name@example.com, another@example.com',
        emailsTooltip:
          'Нажмите Enter, запятую или пробел после каждого адреса, чтобы добавить его.',
        role: 'Роль',
        manager: 'Руководитель',
        managerPlaceholder: 'Найти коллегу',
        managerHint:
          'Необязательно — человек, который будет курировать приглашённых.'
      },
      error: {
        noEmails: 'Добавьте хотя бы один адрес электронной почты.',
        invalidEmails: 'Некорректный email: {{emails}}',
        workspaceNotReady:
          'Данные рабочего пространства ещё загружаются — попробуйте через момент.'
      }
    },
    filters: {
      searchPlaceholder: 'Поиск по имени или email…',
      allStatuses: 'Статус',
      allRoles: 'Все роли',
      allTeams: 'Все команды',
      teamChip: 'Команда',
      joinedChip: 'Присоединился',
      joinedFromPlaceholder: 'Присоединился с',
      joinedToPlaceholder: 'Присоединился по',
      mfaValues: {
        all: 'MFA · любое',
        on: 'MFA включено',
        off: 'MFA выключено',
        required: 'Требуется, не настроено'
      },
      moreFilters: 'Больше фильтров',
      chipsLabel: 'Фильтры',
      statusChip: 'Статус',
      roleChip: 'Роль',
      mfaChip: 'MFA',
      is: 'равно',
      clearAll: 'Очистить все'
    },
    columns: {
      user: 'Пользователь',
      email: 'Email',
      role: 'Роль',
      status: 'Статус',
      jobTitle: 'Должность',
      manager: 'Руководитель',
      teams: 'Команды',
      mfa: 'MFA',
      mfaEnabled: 'Включено',
      mfaDisabled: 'Отключено',
      lastSignIn: 'Последний вход',
      joined: 'Дата входа',
      source: 'Источник'
    },
    export: {
      empty: 'Нечего экспортировать — фильтры не дают строк.',
      success_one: 'Экспортирован {{count}} пользователь',
      success_few: 'Экспортированы {{count}} пользователя',
      success_many: 'Экспортировано {{count}} пользователей',
      success_other: 'Экспортировано {{count}} пользователей'
    },
    lastSignIn: { never: 'Никогда' },
    toolbar: {
      selected_one: 'Выбран {{count}}',
      selected_few: 'Выбрано {{count}}',
      selected_many: 'Выбрано {{count}}',
      selected_other: 'Выбрано {{count}}',
      clear: 'Очистить',
      showing: 'Показано {{shown}} из {{total}} пользователей',
      total_one: '{{count}} запись',
      total_few: '{{count}} записи',
      total_many: '{{count}} записей',
      total_other: '{{count}} записей'
    },
    actions: {
      view: 'Открыть профиль',
      edit: 'Изменить',
      changeRole: 'Сменить роль',
      resendInvite: 'Повторно отправить приглашение',
      invitation: 'Приглашение',
      reactivate: 'Восстановить',
      suspend: 'Заблокировать',
      archive: 'Архивировать пользователя',
      unarchive: 'Разархивировать пользователя',
      delete: 'Удалить',
      requireMfa: 'Требовать MFA',
      disableMfa: 'Больше не требовать MFA',
      resetMfa: 'Сбросить MFA',
      resetPassword: 'Сбросить пароль',
      impersonate: 'Войти от имени',
      export: 'Экспорт',
      invite: 'Пригласить',
      more: 'Действия',
      apiPending: {
        changeRole: 'Смена роли — API не подключён.',
        resendInvite: 'Повторная отправка — API не подключён.',
        reactivate: 'Восстановление — API не подключён.',
        suspend: 'Блокировка — API не подключён.',
        delete: 'Удаление — API не подключён.',
        bulkSuspend: 'Массовая блокировка — API не подключён.',
        bulkDelete: 'Массовое удаление — API не подключён.',
        invite:
          'Приглашение — UI показан; существующий endpoint в legacy users.',
        export: 'Экспорт — API не подключён.',
        edit: 'Редактирование — API не подключён.',
        resetPassword: 'Сброс пароля — API не подключён.',
        requireMfa: 'Требование MFA — API не подключён.',
        impersonate: 'Вход от имени — API не подключён.'
      }
    },
    lifecycle: {
      inviteState: {
        pending: 'Приглашение ожидает',
        expired: 'Приглашение истекло',
        accepted: 'Активен',
        revoked: 'Приглашение отозвано'
      },
      inviteExpires: 'Приглашение истекает {{when}}',
      inviteExpired: 'Приглашение истекло {{when}}',
      requiresAcceptance:
        'Доступно после того, как участник примет приглашение',
      joinLink: {
        action: 'Ссылка для вступления',
        copied: 'Ссылка для вступления скопирована',
        disabledHint:
          'Включите самостоятельное вступление в настройках рабочего пространства, чтобы поделиться ссылкой.'
      },
      revokeInvite: {
        action: 'Отозвать приглашение',
        title: 'Отозвать приглашение?',
        description:
          'Это отменит ожидающее приглашение для {{name}}. Ссылка-приглашение сразу перестанет работать.',
        submit: 'Отозвать приглашение',
        success: 'Приглашение отозвано'
      },
      resetPassword: {
        title: 'Отправить сброс пароля?',
        description:
          'Мы отправим {{name}} защищённую ссылку для выбора нового пароля. Текущий пароль продолжит работать до её использования.',
        submit: 'Отправить ссылку',
        success: 'Письмо для сброса пароля отправлено'
      },
      requireMfa: {
        title: 'Требовать двухфакторную аутентификацию?',
        description:
          'Двухфакторная аутентификация будет включена для {{name}}. При следующем входе потребуется подтверждение по электронной почте или в приложении.',
        submit: 'Требовать MFA',
        success: 'MFA теперь обязательна для этого участника'
      },
      disableMfa: {
        title: 'Больше не требовать двухфакторную аутентификацию?',
        description:
          'Двухфакторная аутентификация больше не будет обязательной для {{name}} в этом рабочем пространстве. Существующая настройка участника остаётся активной — это лишь снимает требование рабочего пространства и не удаляет его регистрацию. Чтобы помочь участнику, потерявшему аутентификатор, используйте «Сбросить MFA».',
        submit: 'Не требовать',
        success: 'MFA больше не требуется для этого участника'
      },
      resetMfa: {
        title: 'Сбросить двухфакторную аутентификацию?',
        description:
          'Коды восстановления, доверенные устройства и блокировки {{name}} будут очищены для повторной настройки. MFA остаётся включённой (коды по e-mail работают, поэтому участник не блокируется). Вы никогда не видите коды восстановления — участник создаёт новые в своих настройках безопасности.',
        submit: 'Сбросить MFA',
        success: 'MFA сброшена для этого участника'
      },
      impersonate: {
        title: 'Войти от имени этого участника?',
        description:
          'Вы начнёте сессию как {{name}}. Ваша сессия администратора будет восстановлена после выхода.',
        warning:
          'Все ваши действия будут выполнены от имени этого участника и записаны в журнал аудита.',
        submit: 'Начать вход от имени',
        success: 'Сессия от имени участника начата',
        banner: 'Вы вошли от имени {{name}}',
        exit: 'Выйти из режима'
      },
      sessions: {
        title: 'Активные сессии',
        subtitle:
          'Устройства, на которых сейчас выполнен вход как этот участник',
        empty: 'Нет активных сессий.',
        current: 'Текущая',
        revoke: 'Отозвать',
        revokeAll: 'Отозвать все',
        revokeConfirm:
          'Отозвать эту сессию? Устройство будет выведено из системы.',
        revokeAllConfirm:
          'Отозвать все сессии этого участника? Он будет выведен из системы на всех устройствах.',
        revoked: 'Сессия отозвана',
        revokedAll_one: 'Отозвана {{count}} сессия',
        revokedAll_other: 'Отозвано {{count}} сессий',
        failed: 'Не удалось отозвать сессию',
        unknownDevice: 'Неизвестное устройство',
        columns: {
          device: 'Устройство',
          location: 'Местоположение',
          ip: 'IP-адрес',
          lastActive: 'Последняя активность',
          created: 'Начата'
        }
      }
    },
    modals: {
      cancel: 'Отмена',
      changeRole: {
        title: 'Изменить роль',
        description:
          'Выберите новую роль для {{name}}. Уровень доступа обновится сразу.',
        fieldLabel: 'Новая роль',
        submit: 'Сохранить изменения',
        cancel: 'Отмена',
        success: 'Роль обновлена'
      },
      suspend: {
        title: 'Заблокировать пользователя?',
        description:
          'Блокировка {{name}} завершит сессии и закроет вход до повторной активации.',
        warning:
          'Активные сессии будут отозваны, а текущие задачи могут быть переназначены.',
        submit: 'Заблокировать',
        success: 'Пользователь заблокирован'
      },
      reactivate: {
        title: 'Активировать пользователя?',
        description:
          '{{name}} снова сможет входить с существующими учётными данными.',
        submit: 'Активировать',
        success: 'Пользователь активирован'
      },
      delete: {
        title: 'Удалить пользователя из рабочей области',
        description:
          'Это удаляет {{name}} из рабочей области. Глобальная учётная запись не удаляется.',
        warning:
          'Действие необратимо. Данные и доступ внутри рабочей области будут потеряны.',
        confirmLabel: 'Для подтверждения введите email:',
        submit: 'Удалить пользователя',
        success: 'Пользователь удалён из рабочей области'
      },
      resendInvite: {
        title: 'Повторно отправить приглашение',
        description:
          'Мы отправим новое письмо-приглашение, чтобы пользователь завершил создание учётной записи.',
        recipient: 'Отправляем на:',
        submit: 'Отправить приглашение',
        success: 'Приглашение отправлено'
      },
      archive: {
        title: 'Архивировать пользователя',
        description:
          'Архивация {{name}} блокирует вход и передаёт записи, которыми он ещё владеет в этом рабочем пространстве.',
        checking: 'Проверяем, чем владеет пользователь…',
        checkFailed:
          'Не удалось загрузить записи пользователя. Попробуйте ещё раз.',
        noBlockers:
          'У пользователя нет активных записей, блокирующих архивацию. Его можно архивировать напрямую.',
        hasBlockers:
          'Пользователь ещё владеет активными записями. Выберите коллегу, который их примет — записи будут переназначены, затем пользователь будет архивирован.',
        depsTitle: 'Активные записи',
        services: { crm: 'CRM', hrm: 'HRM' },
        entityCount_one: '{{count}} активна',
        entityCount_other: '{{count}} активных',
        replaceLabel: 'Переназначить записи на',
        replacePlaceholder: 'Выберите коллегу…',
        replaceRequired: 'Выберите пользователя для переназначения записей.',
        manualHint:
          'Предпочитаете сделать это вручную? Можно открыть соответствующее приложение и переназначить эти записи самостоятельно, а затем архивировать пользователя здесь, когда ничего не останется.',
        submit: 'Архивировать пользователя',
        submitReplace: 'Переназначить и архивировать',
        success: 'Пользователь архивирован',
        job: {
          pending: 'В очереди…',
          processing: 'Переназначаем записи и архивируем…',
          succeeded: 'Пользователь архивирован',
          failed: 'Архивация не удалась'
        },
        jobError:
          'Некоторые записи не удалось переназначить. Изменения не применены.'
      },
      unarchive: {
        title: 'Разархивировать пользователя',
        description:
          'Разархивация {{name}} восстанавливает вход и владение записями в этом рабочем пространстве.',
        submit: 'Разархивировать пользователя',
        success: 'Пользователь разархивирован'
      },
      bulk: {
        note: 'Каждый пользователь обрабатывается отдельно — частичные сбои будут показаны.',
        suspend: {
          title_one: 'Заблокировать {{count}} пользователя?',
          title_few: 'Заблокировать {{count}} пользователей?',
          title_many: 'Заблокировать {{count}} пользователей?',
          title_other: 'Заблокировать {{count}} пользователей?',
          description_one:
            'Будет завершена сессия и заблокирован вход {{count}} пользователю.',
          description_few:
            'Будут завершены сессии и заблокирован вход {{count}} пользователям.',
          description_many:
            'Будут завершены сессии и заблокирован вход {{count}} пользователям.',
          description_other:
            'Будут завершены сессии и заблокирован вход {{count}} пользователям.',
          warning: 'Активные сессии будут завершены.',
          submit: 'Заблокировать',
          success_one: 'Заблокирован {{count}} пользователь',
          success_few: 'Заблокированы {{count}} пользователя',
          success_many: 'Заблокировано {{count}} пользователей',
          success_other: 'Заблокировано {{count}} пользователей',
          partial_one: 'Не удалось заблокировать {{count}} пользователя',
          partial_few: 'Не удалось заблокировать {{count}} пользователей',
          partial_many: 'Не удалось заблокировать {{count}} пользователей',
          partial_other: 'Не удалось заблокировать {{count}} пользователей'
        },
        reactivate: {
          title_one: 'Восстановить {{count}} пользователя?',
          title_few: 'Восстановить {{count}} пользователей?',
          title_many: 'Восстановить {{count}} пользователей?',
          title_other: 'Восстановить {{count}} пользователей?',
          description_one: '{{count}} пользователь снова сможет войти.',
          description_few: '{{count}} пользователя снова смогут войти.',
          description_many: '{{count}} пользователей снова смогут войти.',
          description_other: '{{count}} пользователей снова смогут войти.',
          submit: 'Восстановить',
          success_one: 'Восстановлен {{count}} пользователь',
          success_few: 'Восстановлены {{count}} пользователя',
          success_many: 'Восстановлено {{count}} пользователей',
          success_other: 'Восстановлено {{count}} пользователей',
          partial_one: 'Не удалось восстановить {{count}} пользователя',
          partial_few: 'Не удалось восстановить {{count}} пользователей',
          partial_many: 'Не удалось восстановить {{count}} пользователей',
          partial_other: 'Не удалось восстановить {{count}} пользователей'
        },
        delete: {
          title_one: 'Удалить {{count}} пользователя из workspace?',
          title_few: 'Удалить {{count}} пользователей из workspace?',
          title_many: 'Удалить {{count}} пользователей из workspace?',
          title_other: 'Удалить {{count}} пользователей из workspace?',
          description_one: 'Будет удалён {{count}} пользователь.',
          description_few: 'Будут удалены {{count}} пользователя.',
          description_many: 'Будут удалены {{count}} пользователей.',
          description_other: 'Будут удалены {{count}} пользователей.',
          warning:
            'Данные и доступ внутри workspace будут потеряны — действие необратимо.',
          submit: 'Удалить',
          success_one: 'Удалён {{count}} пользователь',
          success_few: 'Удалены {{count}} пользователя',
          success_many: 'Удалено {{count}} пользователей',
          success_other: 'Удалено {{count}} пользователей',
          partial_one: 'Не удалось удалить {{count}} пользователя',
          partial_few: 'Не удалось удалить {{count}} пользователей',
          partial_many: 'Не удалось удалить {{count}} пользователей',
          partial_other: 'Не удалось удалить {{count}} пользователей'
        }
      }
    },
    hero: {
      lastSignIn: 'Последний вход',
      mfaUnknown: 'MFA · статус недоступен',
      mfaOn: '2FA · зарегистрирован',
      mfaOff: '2FA · не зарегистрирован',
      statusHint:
        'Текущий статус аккаунта — активен, приглашён или заблокирован.',
      roleHint: 'Роль в рабочем пространстве — определяет доступ аккаунта.',
      mfaHint: 'Включена ли двухфакторная аутентификация для этого аккаунта.',
      ssoHint: 'Способ входа — единый вход (SSO) или обычные учётные данные.',
      userId: 'ID пользователя',
      via: 'через',
      source: {
        sso: 'SSO',
        manual: 'Вручную'
      },
      alerts: {
        neverSignedIn:
          'Пользователь ещё не входил в систему. Возможно, он на этапе онбординга.',
        apiPendingFields:
          'MFA, источник входа и доступ к приложениям пока не предоставлены API — показаны для визуального соответствия макетам.'
      }
    },
    detail: {
      tabs: {
        overview: 'Обзор',
        access: 'Доступ к приложениям',
        sessions: 'Сессии',
        audit: 'Аудит'
      },
      tabsPlaceholders: {
        access:
          'Доступ к приложениям и роли появятся здесь после подключения API.',
        sessions: 'Активные сессии появятся здесь после подключения API.',
        audit: 'Аудит-события появятся здесь после подключения API.'
      },
      identity: {
        title: 'Идентификация',
        subtitle: 'Личные данные',
        firstName: 'Имя',
        lastName: 'Фамилия',
        email: 'Email',
        phone: 'Телефон',
        birthDate: 'Дата рождения',
        jobTitle: 'Должность',
        position: 'Позиция',
        language: 'Язык',
        userId: 'ID',
        externalId: 'Внешний ID',
        verified: 'Подтверждён',
        phoneNotVerifiedTooltip:
          'Статус подтверждения телефона пока не сохраняется в API.'
      },
      workspaceAccess: {
        title: 'Доступ к рабочему пространству',
        groups: 'Группы',
        noGroups: 'Не состоит ни в одной группе',
        subtitle: 'У пользователя одна роль в рабочем пространстве',
        role: 'Роль',
        joined: 'Дата входа',
        headUser: 'Подчиняется',
        teams: 'Команды',
        noTeams: 'Не состоит ни в одной команде',
        roleUpdated: 'Роль обновлена',
        roleFailed: 'Не удалось обновить роль',
        headUserUpdated: 'Руководитель обновлён',
        headUserPlaceholder: 'Поиск участника'
      },
      workspaceRoles: {
        title: 'Роли рабочего пространства',
        subtitle:
          'Здесь показываются только пользовательские роли рабочего пространства. Базовая роль участника отображается в блоке «Доступ рабочего пространства».',
        placeholder: 'Выберите роли',
        empty: 'В этом рабочем пространстве ещё нет пользовательских ролей',
        save: 'Сохранить',
        cancel: 'Отмена',
        saveSuccess: 'Роли обновлены',
        saveFailed: 'Не удалось обновить роли'
      },
      access: {
        tabTitle: 'Доступ к приложениям',
        tabSubtitle:
          'Одна строка на приложение · переключатель доступа и выбор роли',
        emptyAllApps:
          'В этом рабочем пространстве пока нет зарегистрированных приложений.',
        rolePlaceholder: 'Выберите роль',
        noRoleAvailable: 'Нет доступных ролей',
        pickRolePrompt: 'Выберите роль',
        saveSuccess: 'Доступ к приложениям обновлён',
        saveFailed: 'Не удалось обновить доступ к приложениям'
      },
      authentication: {
        title: 'Аутентификация',
        password: 'Пароль',
        passwordMeta: 'Дата изменения пароля не сохраняется в API.',
        managedBySso: 'Управляется SSO',
        mfa: 'Двухфакторная аутентификация',
        mfaUnknown: 'Статус регистрации недоступен',
        mfaEnabled: 'Зарегистрирован',
        mfaRequiredTag: 'Обязательно',
        mfaRequiredMeta: 'Требуется многофакторная аутентификация',
        mfaDisabledMeta: 'Многофакторная аутентификация не настроена',
        mfaMethod: 'Способ двухфакторной аутентификации',
        mfaMethodEnrolledMeta:
          'Настроено приложение-аутентификатор или коды по e-mail',
        mfaMethodNotEnrolledMeta: 'Второй фактор не настроен',
        mfaNotEnrolled: 'Не настроено',
        mfaRequire: 'Требовать второй фактор',
        mfaRequireOnMeta: 'Должен подтверждать при следующем входе',
        mfaRequireOffMeta: 'Может входить без второго фактора',
        reset: 'Сбросить',
        emailVerified: 'Email подтверждён',
        ssoProvider: 'Провайдер SSO',
        ssoLinkedMeta: 'Подключён · {{id}}',
        ssoNotLinked: 'Не подключён',
        sso: 'SSO',
        link: 'Подключить',
        linked: 'Подключён',
        enforce: 'Требовать',
        disable: 'Не требовать',
        apiPending: {
          enforceMfa: 'Принуждение MFA — API не подключён.',
          linkSso: 'Подключение SSO — API не подключён.'
        }
      },
      quickStats: {
        signIns30d: 'Входы · 30д',
        appsUsed: 'Приложения',
        sessions: 'Сессии'
      },
      recentActivity: {
        title: 'Недавняя активность',
        seeAll: 'Все →',
        empty: 'Пока нет недавней активности.',
        error: 'Не удалось загрузить недавнюю активность.'
      },
      audit: {
        searchPlaceholder: 'Поиск событий',
        dateRangeLabel: 'Диапазон дат',
        empty: 'Для этого пользователя пока нет событий аудита.',
        noMatches: 'Нет событий, соответствующих текущим фильтрам.',
        filters: {
          allApplications: 'Приложение',
          allEventTypes: 'Тип события',
          allSeverities: 'Уровень',
          clear: 'Очистить'
        },
        toolbar: {
          events_one: '{{count}} событие',
          events_few: '{{count}} события',
          events_many: '{{count}} событий',
          events_other: '{{count}} событий'
        },
        columns: {
          time: 'Время',
          event: 'Событие',
          application: 'Приложение',
          description: 'Описание',
          severity: 'Уровень',
          ip: 'IP'
        }
      }
    },
    notApiBacked: {
      mfa: 'Статус MFA пока не сохраняется в API.'
    },
    breadcrumb: {
      users: 'Пользователи',
      notFound: 'Пользователь не найден'
    },
    notFound: {
      title: 'Пользователь не найден',
      subtitle:
        'Этот пользователь не состоит в этом воркспейсе, либо ссылка устарела.',
      back: 'К списку участников'
    },
    editForm: {
      title: 'Изменить пользователя',
      cancel: 'Отмена',
      save: 'Сохранить',
      saveSuccess: 'Пользователь обновлён',
      saveFailed: 'Не удалось обновить',
      aboutMe: 'О себе',
      birthDatePlaceholder: 'Выберите дату',
      manager: 'Руководитель',
      managerPlaceholder: 'Найдите коллегу',
      managerHint: 'Сотрудник, который руководит этим пользователем.',
      required: {
        firstName: 'Имя обязательно',
        lastName: 'Фамилия обязательна'
      }
    },
    addToGroup: {
      action: 'Добавить в группу',
      title: 'Добавить в группу',
      groupLabel: 'Группа',
      groupPlaceholder: 'Выберите группу',
      groupRequired: 'Выберите группу',
      submit: 'Добавить',
      cancel: 'Отмена',
      success: 'Пользователь добавлен в группу',
      noGroups: 'Нет доступных групп — сначала создайте её на вкладке «Группы».'
    },
    addToTeam: {
      action: 'Добавить в команду',
      title: 'Добавить в команду',
      teamLabel: 'Команда',
      teamPlaceholder: 'Выберите команду',
      teamRequired: 'Выберите команду',
      submit: 'Добавить',
      cancel: 'Отмена',
      noTeams: 'Нет доступных команд — сначала создайте её в Организации.'
    }
  },
  workspaceHome: {
    chatPlaceholder:
      'Спросите Skalx AI о пользователях, безопасности, приложениях или аудите…',
    welcome: {
      title: 'Что бы вы хотели сделать?',
      subtitle:
        'Skalx AI помогает исследовать пользователей, проверять доступ, готовить отчёты по безопасности и настраивать пространство. Действует только в рамках вашего доступа.'
    },
    greeting: {
      morning: 'Доброе утро',
      afternoon: 'Добрый день',
      evening: 'Добрый вечер',
      late: 'Полуночник',
      fallbackName: 'друг'
    },
    suggestions: {
      owner: {
        admins: 'У кого права администратора?',
        securityReview: 'Проверь безопасность пространства',
        accessChanges: 'Кто менял доступы недавно?',
        orgChart: 'Покажи оргструктуру'
      },
      admin: {
        members: 'Покажи участников и их роли',
        inviteMember: 'Пригласи нового участника',
        signInMethods: 'Какие способы входа включены?',
        accessChanges: 'Кто менял доступы недавно?'
      },
      employee: {
        myTeam: 'Кто в моей команде?',
        orgChart: 'Кто кому подчиняется?',
        myApps: 'Какие приложения мне доступны?',
        myAccess: 'Какой у меня доступ?'
      }
    },
    composer: {
      send: 'Отправить',
      stop: 'Стоп'
    },
    streaming: {
      thinking: 'Skalx AI думает…',
      cycle: {
        thinking: 'Думаю',
        reasoning: 'Размышляю',
        searching: 'Ищу',
        analyzing: 'Анализирую',
        crunching: 'Обрабатываю',
        looking_up: 'Уточняю',
        connecting: 'Соединяю детали',
        almost_ready: 'Почти готово'
      }
    },
    feedback: {
      helpful: 'Полезно',
      notHelpful: 'Бесполезно',
      failed: 'Не удалось сохранить оценку'
    },
    copy: {
      copy: 'Копировать',
      copied: 'Скопировано',
      failed: 'Не удалось скопировать'
    },
    timeline: {
      thinking: 'Размышляю…',
      thoughts: 'Размышления',
      working: 'Шаги работы',
      request: 'Запрос',
      response: 'Ответ'
    },
    approval: {
      title: 'Это действие требует вашего подтверждения',
      actionRequest: 'Требуется подтверждение',
      toolLabel: 'Запрошенное действие:',
      destructive: 'Необратимо',
      noDetails: 'Дополнительных сведений нет.',
      approve: 'Подтвердить',
      always: 'Всегда разрешать',
      alwaysHint:
        'Всегда выполнять {{tool}} для этого агента без повторных запросов.',
      reject: 'Отклонить',
      approved: 'Подтверждено',
      rejected: 'Отклонено',
      severityHint: 'Оценка риска этого действия самим агентом.',
      severity: {
        none: 'Без риска',
        low: 'Низкий риск',
        medium: 'Средний риск',
        high: 'Высокий риск',
        critical: 'Критический риск'
      },
      confidenceLabel: 'Уверенность',
      confidenceHint:
        'Насколько агент уверен, что это верное действие в данной ситуации.',
      whatWillHappen: 'Что произойдёт'
    },
    question: {
      clarification: 'Нужно уточнение',
      questionLabel: 'Вопрос',
      selected: 'Ответ',
      otherButton: 'Другое',
      otherPlaceholder: 'Или введите свой ответ…',
      submit: 'Отправить',
      answered: 'Ответ отправлен'
    },
    scrollToBottom: 'К последнему сообщению',
    attachments: {
      attach: 'Прикрепить файлы',
      remove: 'Убрать файл',
      retry: 'Повторить загрузку',
      uploadFailed: 'Не удалось загрузить. Попробуйте ещё раз.',
      uploading: 'Загрузка {{name}}',
      open: 'Открыть',
      download: 'Скачать',
      fromYou: 'Вы',
      fromAgent: 'Агент',
      empty: 'В этом чате пока нет файлов',
      loadError: 'Не удалось загрузить файлы.',
      retryLoad: 'Повторить',
      unavailable: 'Файл пока недоступен',
      sendRefused:
        'Эти файлы нельзя отправить с этим сообщением. Удалите их и прикрепите снова.',
      problems: {
        unsupported: 'Этот тип файла не поддерживается',
        too_large: 'Изображения до 5 МБ, остальные файлы до 20 МБ',
        too_many: 'Не больше 10 файлов в сообщении'
      }
    },
    files: {
      open: 'Файлы',
      title: 'Файлы чата'
    },
    history: {
      title: 'История чатов',
      back: 'К началу',
      newChat: 'Новый чат',
      hide: 'Скрыть историю',
      searchPlaceholder: 'Поиск по чатам…',
      today: 'Сегодня',
      yesterday: 'Вчера',
      older: 'Раньше',
      empty: 'Пока нет разговоров',
      noResults: 'Ничего не найдено',
      delete: 'Удалить разговор',
      deleteConfirm: 'Удалить этот разговор?',
      processing: 'Агент работает над этим чатом',
      awaitingInput: 'Этот чат ждёт вашего ответа'
    },
    errors: {
      notConfiguredTitle: 'AI-ассистент не настроен',
      notConfigured:
        'Установите VITE_APP_SQUAD_AGENT_ID (и VITE_APP_SQUAD_API) в окружении, чтобы включить ассистента. В текущей сборке не настроен агент Squad.',
      stopped: 'Остановлено.',
      empty: 'Агент не вернул ответ.',
      approvalRequired:
        'Это действие требует вашего подтверждения, чтобы продолжить.',
      generic: 'Не удалось связаться с AI-ассистентом. Попробуйте ещё раз.',
      questionPending:
        'Сначала ответьте на вопрос агента, затем отправьте файлы.'
    }
  },
  workspaceOverview: {
    title: 'Добро пожаловать в {{workspace}}',
    subtitle:
      'Это домашняя страница вашей команды. Выберите раздел, чтобы начать.',
    fallbackWorkspace: 'ваше пространство',
    inviteCta: 'Пригласить команду',
    primaryCta: 'Пригласить команду',
    greeting: {
      morning: 'Доброе утро',
      afternoon: 'Добрый день',
      evening: 'Добрый вечер',
      late: 'Полуночник',
      fallbackName: 'друг'
    },
    demo: {
      label: 'Демо',
      expired: 'истекло',
      daysLeft_one: 'остался {{count}} день',
      daysLeft_few: 'осталось {{count}} дня',
      daysLeft_many: 'осталось {{count}} дней',
      daysLeft_other: 'осталось {{count}} дня',
      endsOn: 'Демо-режим истекает {{date}}',
      noExpiry: 'Дата окончания не задана',
      noExpiryTooltip: 'Дата окончания не задана'
    },
    sections: {
      stats: 'Статистика пространства',
      shortcuts: 'Ярлыки',
      activity: 'Недавняя активность'
    },
    companyGraph: {
      title: 'Граф компании',
      preview: 'Предпросмотр',
      subtitle: '{{count}} подключённых ресурсов · живой просмотр',
      pageDescription:
        'Живая карта вашего пространства — ресурсы, связи и активность в реальном времени.',
      details: 'Детали',
      recentActivity: 'Недавняя активность',
      connections: 'Связи',
      liveActivity: 'Активность в реальном времени',
      noActivity: 'Нет недавней активности',
      sample: 'Демоданные',
      close: 'Закрыть',
      active: 'Активен',
      lastActive: 'Последняя активность',
      needsAttention: 'Требует внимания',
      allClear: 'Всё в порядке — внимание не требуется',
      viewDetails: 'Подробнее',
      highlights: 'Главное',
      liveEvents: 'Живые события',
      noEdgeEvents: 'Пока нет событий на этой связи',
      tabs: {
        graph: 'Граф',
        activity: 'Активность',
        aiInsights: 'AI-аналитика'
      },
      filters: {
        allActors: 'Участник',
        allEntities: 'Тип',
        search: 'Поиск активности…'
      },
      feedEmpty: 'Нет активности по выбранным фильтрам',
      insights: {
        latestChanges: 'Последние изменения',
        suggested: 'Спросите',
        greeting:
          'Спросите меня об активности компании — сделки, лиды, почта или отпуска.',
        askPlaceholder: 'Спросите о лидах, сделках, почте…',
        send: 'Отправить',
        thinking: 'Думаю…',
        period: {
          today: 'Сегодня',
          '7d': '7 дней',
          '30d': '30 дней'
        }
      },
      legend: {
        company: 'Компания',
        database: 'Базы данных',
        email: 'Почта',
        app: 'Приложения',
        user: 'Пользователи',
        agent: 'ИИ-агенты'
      },
      kpi: {
        activeSessions: 'Активные сессии',
        eventsPerMin: 'Событий / мин',
        agentsRunning: 'Активных агентов',
        openAlerts: 'Открытые оповещения'
      },
      events: {
        backupDone: 'Автоматическое резервное копирование завершено',
        slowQuery: 'Зафиксирован медленный запрос > 2с',
        failoverPassed: 'Тест отказоустойчивости пройден',
        emailsSent: 'Отправлена партия писем',
        emailBounced: 'Письмо отклонено (неверный адрес)',
        mailboxSynced: 'Почтовые ящики синхронизированы',
        ticketsResolved: 'Обращения в поддержку решены',
        agentRetry: 'Повтор после API 429',
        recordsSynced: 'Записи синхронизированы',
        memberInvited: 'Приглашён новый участник',
        appDeploy: 'Развёртывание успешно',
        appSession: 'Запущены новые сессии',
        userSignin: 'Выполнен вход',
        userToken: 'Токен доступа обновлён',
        agentCalledApp: 'вызвал {{target}}',
        agentSyncedData: 'синхронизировал данные в {{target}}',
        appQueriedDb: 'запросил {{target}}',
        appSentEmail: 'отправил письмо через {{target}}',
        sentData: 'отправил данные в {{target}}'
      }
    },
    hero: {
      domain: 'Основной домен',
      created: 'Создано',
      role: 'Ваша роль',
      manage: 'Управление настройками',
      openWorkspace: 'Открыть пространство',
      noDomain: 'Домен не задан'
    },
    signInActivity: {
      title: 'Активность входов',
      subtitle: 'Последние 30 дней · UTC',
      signIns: 'Входы · 30д',
      avgPerDay: 'Среднее за день',
      failed: 'Неудачные',
      uniqueUsers: 'Уникальные пользователи',
      legendSignIns: 'Входы',
      legendFailures: 'Ошибки'
    },
    securitySignals: {
      title: 'Сигналы безопасности',
      viewAll: 'Все события'
    },
    appsHealth: {
      title: 'Здоровье приложений',
      subtitle: 'Доступность и объём запросов в реальном времени',
      manage: 'Управление приложениями',
      sessions: 'Сессии',
      errorRate: 'Уровень ошибок',
      p95: 'P95'
    },
    planUsage: {
      title: 'Тариф и использование',
      upgrade: 'Перейти на платный'
    },
    details: {
      title: 'Детали пространства',
      manage: 'Управление настройками',
      name: 'Название',
      domain: 'Основной домен',
      created: 'Создано',
      role: 'Ваша роль',
      stats: {
        members: 'Участники',
        apps: 'Приложения',
        roles: 'Роли',
        authMethods: 'Активные методы входа',
        mfaCoverage: 'Охват MFA'
      }
    },
    tiles: {
      users: 'Участники и команды в этом пространстве',
      roles: 'Роли и права',
      apps: 'Подключённые приложения',
      security: 'SSO, SAML и политика входа',
      apiKeys: 'API-ключи пространства',
      audit: 'Недавняя административная активность'
    },
    activity: {
      title: 'Недавняя активность',
      viewAll: 'Открыть журнал аудита',
      systemActor: 'Система',
      emptyTitle: 'Пока без активности',
      emptyDescription:
        'Активность команды появится здесь, как только люди начнут работать.'
    }
  },
  home: {
    greeting: 'Привет, {{name}}! Что хочешь создать?',
    chatPlaceholder: 'Опиши идею, и Agent поможет воплотить её...',
    chatHint: 'AI-ассистент для auth и настройки workspace',
    send: 'План',
    suggestionsTitle: 'Быстрые идеи',
    suggestions: {
      sso: {
        title: 'Настроить SSO для workspace',
        description:
          'Включите вход через Google и Entra ID для участников workspace.'
      },
      invite: {
        title: 'Создать onboarding workspace',
        description:
          'Запустите чистый workspace или используйте встроенные приложения и пресеты.'
      },
      security: {
        title: 'Усилить безопасность аккаунта',
        description:
          'Проверьте личные методы входа и включите более строгие политики авторизации.'
      }
    }
  },
  credentials: {
    optional: 'необязательно',
    reasonLabel: 'Причина',
    reasonPlaceholder: 'Почему эти реквизиты отзываются?',
    newExpiryLabel: 'Новый срок действия',
    newExpiryPlaceholder: 'Без срока действия',
    revokeOldLabel: 'Отозвать предыдущий токен'
  },
  workspace: {
    credentials: {
      status: {
        active: 'Активны',
        revoked: 'Отозваны',
        expired: 'Истекли'
      },
      columns: {
        status: 'Статус',
        expires: 'Срок действия',
        lastUsed: 'Последнее использование',
        created: 'Создано',
        createdBy: 'Создал(а)',
        id: 'ID реквизитов'
      },
      noExpiry: 'Никогда',
      neverUsed: 'Не использовался',
      revokedReason: 'Причина: {{reason}}',
      revokedAt: 'Отозван {{at}}',
      noPermissions: 'Для этого приложения нет разрешений.',
      appSummary: '{{permissions}} разрешений по {{resources}} ресурсам',
      tokenReveal: {
        title: 'Скопируйте ключ сейчас',
        body: 'Это единственный раз, когда ключ виден. Сохраните его в надёжном месте — после ухода со страницы или её перезагрузки восстановить ключ будет невозможно.',
        done: 'Я сохранил(а) ключ'
      },
      quickStart: {
        title: 'Быстрый старт',
        intro:
          'Передавайте ключ в заголовке Authorization каждого запроса. У каждого привязанного приложения свои endpoints, тело запроса и формат ответа — детали смотрите в документации приложения.',
        copy: 'Скопировать пример',
        docs: 'API-документация',
        endpointHint:
          'Замените <APP_ENDPOINT> реальным путём из документации вашего приложения. У каждого приложения свои маршруты и структура payload.',
        tokenHint:
          'Токен показывается только один раз при создании. Замените <YOUR_API_TOKEN> значением, которое вы сохранили при создании реквизитов.',
        tips: {
          storage:
            'Храните ключ в менеджере секретов или серверной переменной окружения — не коммитьте его в репозиторий.',
          transport: 'Передавайте ключ только по HTTPS.',
          rotate:
            'Регулярно выполняйте ротацию ключа — или немедленно, если он мог быть скомпрометирован.',
          scope:
            'Выдавайте минимально необходимый набор разрешений и привязок приложений.'
        }
      }
    },
    aiConnectors: {
      sectionTitle: 'AI-коннекторы',
      sectionDescription:
        'Подключайте Claude, ChatGPT, Gemini, Cursor и другие AI-клиенты к этому рабочему пространству. Каждое подключение действует от вашего имени и никогда не получает больше ваших прав.',
      services: {
        core: {
          name: 'Core',
          description: 'Участники, команды, роли и настройки пространства.'
        },
        crm: {
          name: 'CRM',
          description: 'Контакты, компании, лиды, сделки и задачи.'
        },
        notification: {
          name: 'Уведомления',
          description: 'Ваши уведомления и их статус прочтения.'
        },
        squad: {
          name: 'Squad',
          description: 'AI-агенты, их запуски, согласования и память.'
        }
      },
      clients: {
        claude: 'Claude (веб / десктоп)',
        claudeCode: 'Claude Code',
        chatgpt: 'ChatGPT',
        geminiCli: 'Gemini CLI',
        cursor: 'Cursor',
        vscode: 'VS Code',
        other: 'Другой (токен)'
      },
      connect: {
        serviceStep: 'Сервис',
        clientStep: 'AI-клиент',
        instructionsStep: 'Подключение',
        chooseService: 'К какому сервису подключить AI-клиент?',
        chooseClient: 'Какой AI-клиент вы используете?',
        noServices:
          'Пока вам не доступен ни один сервис. Попросите администратора пространства включить сервис в разделе AI-коннекторы.',
        mcpUrl: 'URL MCP-сервера',
        mcpUrls: 'URL MCP-серверов',
        repeatPerUrl: 'Добавьте по одному коннектору на каждый URL выше.',
        tokenOneService:
          'Персональный токен выдаётся на один сервис. Чтобы использовать его, выберите один сервис.',
        snippetTitle: 'Конфигурация',
        copy: 'Копировать',
        copied: 'Скопировано',
        copyFailed:
          'Не удалось скопировать. Выделите текст и скопируйте его вручную.',
        tokenLocked:
          'Скопируйте токен, прежде чем продолжить. Закройте его, чтобы выбрать другой сервис или клиент.',
        oauthHint:
          'При первом подключении клиент откроет страницу Skalx: войдите, выберите это пространство и разрешите доступ.',
        steps: {
          claude: {
            s1: 'В Claude откройте Settings → Connectors.',
            s2: 'Нажмите «Add custom connector».',
            s3: 'Вставьте URL MCP-сервера, нажмите Add, затем Connect.'
          },
          chatgpt: {
            s1: 'В ChatGPT откройте Settings → Apps & Connectors.',
            s2: 'Включите Developer mode в расширенных настройках.',
            s3: 'Нажмите Create, вставьте URL MCP-сервера и выберите OAuth в качестве аутентификации.'
          },
          claudeCode: {
            s1: 'Выполните это в терминале.',
            s2: 'Запустите Claude Code, выполните /mcp и войдите в {{server}}.'
          },
          geminiCli: {
            s1: 'Добавьте это в ~/.gemini/settings.json.',
            s2: 'Перезапустите Gemini CLI и выполните /mcp auth {{server}}, чтобы войти.'
          },
          cursor: {
            s1: 'Добавьте это в ~/.cursor/mcp.json (или в .cursor/mcp.json проекта).',
            s2: 'Откройте Cursor Settings → MCP и войдите в {{server}}, когда Cursor попросит.'
          },
          vscode: {
            s1: 'Добавьте это в .vscode/mcp.json вашего проекта.',
            s2: 'Запустите {{server}} из этого файла и войдите, когда VS Code попросит.'
          },
          other: {
            s1: 'Выпустите персональный токен ниже. Он показывается только один раз.',
            s2: 'Добавьте сервер в клиент и передавайте токен в заголовке Authorization.'
          }
        },
        serviceOff: 'Выключен в этом пространстве.',
        adminServicesHint:
          'Включите сервис, чтобы участники могли подключать к нему AI-клиенты. Выключение отключит все клиенты.',
        waitingTitle: 'Ждём AI-клиента…',
        waitingBody:
          'Выполните шаги выше и разрешите доступ на каждой открывшейся странице Skalx. Этот шаг завершится сам, когда клиент подключится.',
        connectedTitle: 'Подключено',
        connectedBody:
          '{{name}} теперь работает с {{services}} в этом пространстве.',
        done: 'Готово',
        open: 'Подключить',
        title: 'Подключение AI-клиента',
        closeWithTokenTitle: 'Закрыть, не сохранив токен?',
        closeWithTokenBody:
          'Персональный токен показывается только один раз. Скопируйте его перед закрытием или выпустите новый позже.',
        closeWithTokenOk: 'Закрыть'
      },
      pat: {
        noScopes: 'У этого сервиса пока нет прав в каталоге.',
        title: 'Персональный токен',
        intro:
          'Для клиентов без OAuth. Токен действует от вашего имени, ограничен выбранными правами и истекает в указанную дату.',
        name: 'Название',
        namePlaceholder: 'например, Скрипт на ноутбуке',
        nameRequired: 'Введите название',
        expiresAt: 'Действует до',
        expiresRequired: 'Выберите дату окончания не позже чем через год',
        scopes: 'Права',
        issue: 'Выпустить токен',
        placeholderHint:
          'Замените <YOUR_PERSONAL_TOKEN> на токен, выпущенный выше.'
      },
      connections: {
        columns: {
          client: 'Клиент',
          user: 'Пользователь',
          service: 'Сервис',
          scopes: 'Права',
          status: 'Статус',
          created: 'Создано',
          lastUsed: 'Последнее использование'
        },
        kind: {
          oauth: 'OAuth',
          pat: 'Персональный токен'
        },
        scopesCount_one: '{{count}} право',
        scopesCount_few: '{{count}} права',
        scopesCount_many: '{{count}} прав',
        scopesCount_other: '{{count}} прав',
        revokeReasons: {
          user: 'Отозвано пользователем',
          admin: 'Отозвано администратором',
          policy_disabled: 'Сервис выключен',
          personal_tokens_disabled: 'Персональные токены выключены',
          client: 'Отозвано AI-клиентом',
          refresh_reuse: 'Повторное использование токена',
          membership_removed: 'Удалён из пространства',
          membership_blocked: 'Заблокирован в пространстве',
          app_access_removed: 'Доступ к приложению снят'
        },
        countLabel: 'подключений',
        filters: {
          service: 'Все сервисы',
          user: 'Все пользователи'
        },
        empty:
          'К этому пространству пока не подключён ни один AI-клиент. Нажмите «Подключить», чтобы добавить.',
        emptyMine:
          'Вы ещё не подключили ни одного AI-клиента. Нажмите «Подключить», чтобы добавить.',
        revoke: 'Отозвать',
        revokeTitle: 'Отозвать это подключение?',
        revokeBody:
          'AI-клиент потеряет доступ в течение нескольких секунд. Чтобы снова им пользоваться, подключите его заново.',
        revoked: 'Подключение отозвано',
        editScopes: 'Права',
        scopesTitle: 'Права подключения {{name}}',
        scopesHint:
          'Что может делать это подключение. Больше ваших собственных прав в сервисе оно не получит никогда.',
        scopesSave: 'Сохранить',
        scopesSaved: 'Права обновлены'
      },
      servicesTab: {
        enabledAria: 'Включить {{service}} для AI-клиентов',
        empty: 'В этом пространстве пока нет сервисов для AI-коннекторов.',
        needsInstance:
          'Установите {{service}} в этом пространстве, чтобы включить его.',
        notConfigured:
          'Не настроен для этого окружения. {{service}} нельзя включить, пока он не настроен.',
        saved: 'Сервис обновлён',
        disableTitle: 'Выключить {{service}} для AI-клиентов?',
        disableBody:
          'Все подключения и персональные токены этого сервиса перестанут работать в течение нескольких секунд.',
        disable: 'Выключить'
      },
      consent: {
        title: '{{client}} запрашивает доступ к вашим данным Skalx',
        unverified: 'Не проверен',
        unverifiedHint:
          'Skalx не проверял этот клиент. Разрешайте доступ, только если подключение начали вы сами.',
        redirectsTo: 'Затем вы вернётесь на {{host}}.',
        service: 'Сервис',
        workspace: 'Рабочее пространство',
        workspacePlaceholder: 'Выберите пространство',
        scopes: 'Клиент сможет',
        noScopes: 'Только вход, без доступа к данным.',
        actsAsYou:
          'Клиент действует от вашего имени и никогда не получает больше ваших прав.',
        noWorkspaceTitle: 'Ни одно пространство не разрешает это подключение',
        noWorkspaceBody:
          '{{service}} не включён для AI-клиентов ни в одном доступном вам пространстве. Попросите администратора включить его в разделе AI-коннекторы и подключитесь снова.',
        expiredTitle: 'Срок действия запроса истёк',
        expiredBody: 'Вернитесь в AI-клиент и начните подключение заново.',
        allow: 'Разрешить',
        deny: 'Отклонить'
      }
    },
    publicAccess: {
      sectionTitle: 'Реквизиты публичного доступа',
      sectionDescription:
        'Токены, дающие публичный (неаутентифицированный) доступ к выбранным приложениям и их разрешениям. Токен показывается только один раз — при создании или ротации; скопируйте его сразу и храните в надёжном месте.',
      create: 'Создать реквизиты',
      createDrawerTitle: 'Новые реквизиты публичного доступа',
      editDrawerTitle: 'Изменить реквизиты публичного доступа',
      rotate: 'Ротация',
      revoke: 'Отозвать',
      namePlaceholder: 'напр. Публичный виджет бронирования',
      expiresAt: 'Срок действия',
      expiresAtPlaceholder: 'Без срока действия',
      noExpiry: 'Никогда',
      neverUsed: 'Не использовался',
      empty: 'Реквизитов публичного доступа пока нет.',
      revokedReason: 'Причина: {{reason}}',
      revokedAt: 'Отозван {{at}}',
      rotateConfirmTitle: 'Выполнить ротацию реквизитов?',
      rotateConfirmBody:
        'Будет выпущен новый токен. Текущий продолжит работать, пока вы не отзовёте его ниже.',
      revokeConfirmTitle: 'Отозвать реквизиты?',
      revokeConfirmBody:
        'Этот токен перестанет работать для всех использующих его интеграций. Отменить действие нельзя.',
      toolbar: {
        count_one: '{{count}} реквизит',
        count_few: '{{count}} реквизита',
        count_many: '{{count}} реквизитов',
        count_other: '{{count}} реквизитов',
        credentialsLabel: 'реквизитов'
      },
      status: {
        active: 'Активны',
        revoked: 'Отозваны',
        expired: 'Истекли'
      },
      columns: {
        name: 'Имя',
        apps: 'Приложения',
        appsCount_one: '{{count}} приложение',
        appsCount_few: '{{count}} приложения',
        appsCount_many: '{{count}} приложений',
        appsCount_other: '{{count}} приложений',
        status: 'Статус',
        expires: 'Срок действия',
        lastUsed: 'Последнее использование',
        actions: 'Действия'
      },
      bindings: {
        label: 'Доступ к приложениям',
        addApp: 'Добавить приложение',
        removeApp: 'Удалить приложение',
        appPlaceholder: 'Выберите приложение',
        permissionsPlaceholder: 'Выберите разрешения',
        permissionCount_one: '{{count}} разрешение',
        permissionCount_few: '{{count}} разрешения',
        permissionCount_many: '{{count}} разрешений',
        permissionCount_other: '{{count}} разрешений',
        required: 'Добавьте хотя бы одно приложение.',
        unbindableApp:
          'Выбранное приложение нельзя привязать (отсутствует идентификатор).',
        none: 'Приложения не привязаны.'
      },
      messages: {
        updated: 'Реквизиты обновлены',
        revoked: 'Реквизиты отозваны',
        rotated: 'Реквизиты ротированы'
      },
      detail: {
        back: 'Назад к реквизитам публичного доступа',
        tokenReveal: {
          title: 'Скопируйте ключ сейчас',
          body: 'Это единственный раз, когда ключ виден. Сохраните его в надёжном месте — после ухода со страницы или её перезагрузки восстановить ключ будет невозможно.',
          done: 'Я сохранил(а) ключ'
        },
        overview: {
          title: 'Обзор',
          id: 'ID реквизитов',
          created: 'Создано',
          createdBy: 'Создал(а)',
          noPermissions: 'Для этого приложения нет разрешений.',
          resourceCount_one: '{{count}} ресурс',
          resourceCount_few: '{{count}} ресурса',
          resourceCount_many: '{{count}} ресурсов',
          resourceCount_other: '{{count}} ресурсов',
          appSummary: '{{permissions}} разрешений по {{resources}} ресурсам'
        },
        quickStart: {
          title: 'Быстрый старт',
          intro:
            'Передавайте ключ в заголовке Authorization каждого запроса. У каждого привязанного приложения свои endpoints, тело запроса и формат ответа — детали смотрите в документации приложения.',
          copy: 'Скопировать пример',
          endpointHint:
            'Замените <APP_ENDPOINT> реальным путём из документации вашего приложения. У каждого приложения свои маршруты и структура payload.',
          tokenHint:
            'Токен показывается только один раз при создании. Замените <YOUR_API_TOKEN> значением, которое вы сохранили при создании реквизитов.',
          tips: {
            storage:
              'Храните ключ в менеджере секретов или серверной переменной окружения — не коммитьте его в репозиторий.',
            transport: 'Передавайте ключ только по HTTPS.',
            rotate:
              'Регулярно выполняйте ротацию ключа — или немедленно, если он мог быть скомпрометирован.',
            scope:
              'Выдавайте минимально необходимый набор разрешений и привязок приложений.'
          }
        }
      }
    },
    tab: {
      overview: 'Обзор',
      users: 'Пользователи',
      members: 'Пользователи',
      roles: 'Роли',
      security: 'Безопасность',
      ssoScim: 'SSO / SCIM',
      domains: 'Домены',
      agents: 'Агенты',
      audit: 'Аудит',
      billing: 'Оплата и использование'
    },
    overviewPage: {
      sectionTitle: 'Обзор',
      sectionDescription:
        'Сводка по workspace, быстрая статистика и переходы к частым настройкам.',
      workspaceId: 'ID workspace',
      primaryDomain: 'Основной домен',
      created: 'Создан',
      statMembers: 'Участники',
      statApps: 'Приложения',
      statRoles: 'Роли',
      statAuthMethods: 'Методы auth',
      statSsoScim: 'SSO / SCIM',
      statApiKeys: 'API-ключи',
      platformModel: 'Модель платформы',
      platformModelValue:
        'Этот workspace выступает ядром идентификации для участников, провайдеров, политики безопасности и доступа к приложениям.',
      appPortfolio: 'Портфель приложений',
      appPortfolioValue:
        '{{builtIn}} встроенных и {{custom}} кастомных приложений сейчас используют ядро workspace среди {{count}} настроенных приложений.',
      identityCoverage: 'Покрытие identity',
      identityCoverageValue:
        '{{authMethods}} методов входа, {{roles}} ролей, {{sso}} SSO-подключений и {{scim}} SCIM-точек активны в этом workspace.',
      apiSurface: 'API-поверхность',
      apiSurfaceValue:
        '{{apiKeys}} API-ключей workspace поддерживают автоматизацию в {{apps}} интеграциях приложений.',
      platformHealth: 'Здоровье платформы',
      platformHealthSso: 'SSO',
      platformHealthScim: 'SCIM',
      platformHealthMfa: 'Внедрение MFA',
      platformHealthApiKeysExpiring: 'API-ключи истекают',
      platformHealthConnected: '{{count}} подключено',
      platformHealthNotConfigured: 'Не настроено',
      platformHealthSyncActive: 'Синхронизация активна',
      platformHealthExpiresSoon: 'Истекает в течение 30 дней',
      goToMembers: 'Управлять участниками',
      goToApps: 'К приложениям',
      goToSecurity: 'Настройки безопасности'
    },
    membersPage: {
      sectionDescription:
        'Пользователи рабочего пространства, приглашения, доступ к приложениям и роли.'
    },
    membersTeams: {
      listTitleWithCount: '{{label}} ({{count}})',
      tabs: {
        members: 'Участники',
        teams: 'Команды',
        divisions: 'Дивизионы',
        departments: 'Отделы'
      },
      teamsCardTitle: 'Команды workspace',
      teamsCardDescription:
        'Создавайте команды, группируйте участников по функциям и назначайте ролям организации доступ внутри этих команд.',
      teamMembersTitle: 'Участники команды',
      createTeam: 'Создать команду',
      manageTeam: 'Управлять командой',
      assignMember: 'Назначить участника',
      createRole: 'Создать роль команды',
      assignMemberTitle: 'Назначить участника в команду',
      editMemberRolesTitle: 'Изменить роли команды',
      createRoleTitle: 'Создать роль команды',
      editRoleTitle: 'Изменить роль команды',
      createTeamModalTitle: 'Создать команду workspace',
      deleteConfirm: 'Удалить эту команду?',
      deleteRoleConfirm: 'Удалить эту роль команды?',
      removeMemberConfirm: 'Удалить этого участника из команды?',
      selectTeam: 'Выберите команду, чтобы управлять её участниками и ролями.',
      emptyTeams: 'Команд пока нет.',
      emptyTeamRoles: 'Ролей команды пока нет.',
      emptyTeamMembers: 'В этой команде пока нет участников.',
      childTeam: 'Дочерняя команда',
      headRole: 'Главная роль',
      membersCount: '{{count}} участников',
      columns: {
        team: 'Команда',
        type: 'Тип',
        members: 'Участники',
        teams: 'Команды',
        actions: 'Действия'
      },
      membersColumns: {
        member: 'Участник',
        roles: 'Роли',
        permissions: 'Права',
        actions: 'Действия'
      },
      roleColumns: {
        role: 'Роль',
        permissions: 'Права',
        actions: 'Действия'
      },
      form: {
        teamName: 'Название команды',
        teamType: 'Тип команды',
        abbreviation: 'Сокращение',
        parentTeam: 'Родительская команда',
        member: 'Участник',
        teamRoles: 'Роли команды',
        roleName: 'Название роли',
        headRole: 'Главная роль',
        permissionGroup: 'Группа прав',
        application: 'Приложение',
        permissions: 'Права'
      },
      teamRolesTitle: 'Роли команды',
      addPermissionGroup: 'Добавить группу прав',
      teamType: {
        branch: 'Филиал',
        department: 'Отдел',
        section: 'Секция'
      },
      messages: {
        teamCreated: 'Команда успешно создана',
        teamDeleted: 'Команда успешно удалена',
        roleCreated: 'Роль команды создана',
        roleUpdated: 'Роль команды обновлена',
        roleDeleted: 'Роль команды удалена',
        memberAssigned: 'Участник назначен в команду',
        membershipUpdated: 'Роли команды обновлены',
        memberRemoved: 'Участник удалён из команды'
      }
    },
    orgChart: {
      tabTitle: 'Оргструктура',
      types: {
        company: 'Компания',
        division: 'Подразделение',
        department: 'Отдел',
        team: 'Команда'
      },
      membersLabel: 'участников',
      memberTable: {
        name: 'Имя',
        role: 'Роль',
        email: 'Эл. почта',
        joined: 'Присоединился'
      },
      mockNotice:
        'Примерные данные для вёрстки и сценариев. Сбрасываются при полной перезагрузке страницы и пока не синхронизируются с API.',
      organization: 'Организация',
      backToMembers: 'Назад к участникам',
      zoomIn: 'Увеличить',
      zoomOut: 'Уменьшить',
      resetView: 'Сбросить вид',
      collapseHint: 'Нажмите, чтобы свернуть/развернуть',
      notFound: 'Этого элемента нет в примерном каталоге.',
      actions: {
        manage: 'Управлять',
        edit: 'Изменить',
        open: 'Действия',
        view: 'Просмотр'
      },
      columns: {
        name: 'Название',
        owner: 'Ответственный',
        roles: 'Роли',
        division: 'Дивизион',
        department: 'Отдел',
        departments: 'Отделы',
        teams: 'Команды',
        members: 'Участники',
        actions: 'Действия'
      },
      fields: {
        name: 'Название',
        abbreviation: 'Сокращение',
        abbreviationHelp: 'Только заглавные буквы, от 2 до 10 символов',
        description: 'Описание',
        owner: 'Ответственный',
        ownerPlaceholder: 'Выберите ответственного',
        parent: 'Родитель',
        parentDivision: 'Дивизион',
        department: 'Отдел'
      },
      divisions: {
        hint: 'Дивизионы находятся под workspace. Они объединяют отделы; родитель — сам workspace, отдельного выбора родителя нет.',
        add: 'Добавить дивизион',
        drawerTitle: 'Добавить дивизион',
        editDrawerTitle: 'Изменить дивизион',
        deleteConfirm:
          'Удалить это подразделение? Отделы под ним станут неназначенными.'
      },
      division: {
        departmentsTableTitle: 'Отделы в этом дивизионе',
        departmentsTableHint:
          'Откройте отдел для управления командами или добавьте новый в этом дивизионе.',
        addDepartmentDrawerTitle: 'Добавить отдел в этот дивизион'
      },
      departments: {
        hint: 'Отдел может опционально принадлежать дивизиону. Команды должны принадлежать отделу.',
        add: 'Добавить отдел',
        drawerTitle: 'Добавить отдел',
        editDrawerTitle: 'Изменить отдел',
        divisionPlaceholder: 'Необязательно — привязать к дивизиону',
        noDivision: 'Без дивизиона',
        deleteConfirm:
          'Удалить этот отдел? Команды под ним станут неназначенными.'
      },
      department: {
        teamsTableTitle: 'Команды в этом отделе',
        teamsTableHint:
          'Команды всегда принадлежат отделу. Откройте команду, чтобы управлять составом.',
        addTeamDrawerTitle: 'Добавить команду в этот отдел'
      },
      teams: {
        hint: 'Команды всегда принадлежат отделу. Выберите отдел при создании.',
        add: 'Добавить команду',
        drawerTitle: 'Добавить команду',
        editDrawerTitle: 'Изменить команду',
        deleteConfirm: 'Удалить эту команду? Участники будут откреплены.'
      },
      team: {
        membersTableTitle: 'Участники команды',
        membersTableHint:
          'Участники workspace в этой команде. Удалите доступ или пригласите новых на вкладке «Участники».',
        addMember: 'Добавить участников',
        addMemberDrawerTitle: 'Добавить участников в команду',
        selectMember: 'Участник',
        selectMembers: 'Участники workspace',
        selectMembersPlaceholder: 'Выберите одного или нескольких участников',
        removeMember: 'Убрать',
        removeMemberConfirm: 'Убрать этого участника из команды?'
      },
      memberDetail: {
        email: 'Email',
        phone: 'Телефон',
        location: 'Локация',
        joinedAt: 'Дата входа в workspace',
        manager: 'Менеджер',
        sectionAccess: 'Доступ в workspace',
        permissions: 'Права',
        permissionsEmpty: 'Для этого примера участника права не заданы.',
        sectionFunctions: 'Роль и функции',
        jobTitle: 'Должность',
        functions: 'Функции',
        functionsEmpty: 'Функции не назначены.',
        sectionTeams: 'Команды',
        teamsEmpty: 'Пока не состоит ни в одной команде.',
        appAccess: {
          sectionTitle: 'Доступ к приложениям',
          selectRole: 'Выберите роль',
          noRoleAvailable: 'Роль недоступна',
          emptyState: 'В этом workspace ещё нет приложений.',
          permissionsUpdated: 'Доступ к приложениям обновлён'
        }
      },
      nodeDetail: {
        owner: 'Ответственный',
        members: 'Участники',
        childUnits: 'Прямые подразделения',
        directReports: 'Прямые подчинённые'
      },
      invites: {
        title: 'Приглашения',
        description:
          'Управляйте ожидающими приглашениями. Приглашённые пользователи получат письмо для присоединения.',
        empty: 'Нет ожидающих приглашений.',
        inviteButton: 'Пригласить по email',
        drawerTitle: 'Пригласить людей',
        submit: 'Отправить приглашения',
        emailsPlaceholder:
          'Введите или вставьте email через запятую или пробел',
        fields: {
          emails: 'Адреса email',
          manager: 'Менеджер',
          teams: 'Команды',
          team: 'Команда'
        },
        teamPlaceholder: 'Необязательно — одна команда на приглашение',
        columns: {
          emails: 'Email',
          manager: 'Менеджер',
          teams: 'Команды',
          status: 'Статус',
          invitedAt: 'Приглашён',
          actions: 'Действия'
        },
        actions: {
          resend: 'Отправить снова',
          revoke: 'Пометить истёкшим'
        }
      },
      inviteStatus: {
        pending: 'Ожидает',
        expired: 'Истекло',
        accepted: 'Принято'
      },
      members: {
        title: 'Участники',
        hint: 'Активные люди в примере workspace. Блокировка и разблокировка — прямо в таблице.',
        addButton: 'Добавить участника',
        drawerTitle: 'Добавить участника',
        submit: 'Добавить участника',
        notFound: 'Нет результатов для "{{keyword}}"',
        notFoundHint:
          'Этого человека ещё нет в системе. Отправьте приглашение для создания аккаунта.',
        fields: {
          name: 'Полное имя',
          email: 'Email',
          role: 'Роль в workspace',
          manager: 'Менеджер',
          teams: 'Команды',
          team: 'Команда'
        },
        teamPlaceholder: 'Необязательно — одна команда на участника',
        columns: {
          name: 'Имя',
          email: 'Email',
          role: 'Роль',
          manager: 'Менеджер',
          teams: 'Команды',
          status: 'Статус',
          actions: 'Действия'
        },
        actions: {
          block: 'Заблокировать',
          unblock: 'Разблокировать'
        }
      },
      memberStatus: {
        active: 'Активен',
        inactive: 'Неактивен',
        blocked: 'Заблокирован',
        invited: 'Приглашён'
      },
      workspaceRole: {
        owner: 'Владелец',
        admin: 'Админ',
        employee: 'Участник'
      },
      validation: {
        emailsRequired: 'Добавьте хотя бы один email.',
        nameRequired: 'Введите имя.',
        departmentRequired: 'Выберите отдел для этой команды.',
        membersRequired: 'Выберите хотя бы одного участника.',
        organizationNotReady: 'Workspace ещё загружается, попробуйте ещё раз.'
      },
      messages: {
        divisionAdded: 'Дивизион добавлен.',
        divisionUpdated: 'Дивизион обновлён.',
        departmentAdded: 'Отдел добавлен.',
        departmentUpdated: 'Отдел обновлён.',
        teamAdded: 'Команда добавлена.',
        teamUpdated: 'Команда обновлена.',
        inviteCreated: 'Приглашение записано.',
        inviteResent: 'Приглашение отправлено снова.',
        inviteRevoked: 'Приглашение помечено истёкшим.',
        memberAdded: 'Участник добавлен.',
        memberBlocked: 'Участник заблокирован.',
        memberUnblocked: 'Участник разблокирован.',
        memberAddedToTeam: 'Участник добавлен в команду.',
        membersAddedToTeam: 'Участники добавлены в команду.',
        memberRemovedFromTeam: 'Участник удалён из команды.',
        divisionDeleted: 'Подразделение удалено.',
        departmentDeleted: 'Отдел удалён.',
        teamDeleted: 'Команда удалена.',
        memberUpdated: 'Участник обновлён.'
      }
    },
    billingPage: {
      sectionTitle: 'Оплата и использование',
      sectionDescription:
        'Предпросмотр использования на уровне workspace. Детальное управление подпиской может быть в биллинге аккаунта при подключении.',
      goToAccountBilling: 'Открыть биллинг аккаунта',
      usageTitle: 'Обзор использования',
      period: {
        current: 'Этот месяц',
        previous: 'Прошлый месяц',
        quarter: 'Прошлый квартал'
      },
      overageWarning:
        'Обнаружено высокое использование за {{period}}. Некоторые метрики приближаются к лимитам.'
    },
    users: {
      stub: 'Управление участниками пространства будет доступно здесь.',
      openDirectory: 'Открыть каталог пользователей',
      memberTableTitle: 'Участники workspace',
      memberCountSuffix: 'участников',
      columns: {
        member: 'Участник',
        role: 'Роль',
        status: 'Статус',
        joinedAt: 'Дата входа',
        actions: 'Действия'
      },
      status: {
        active: 'Активен',
        invited: 'Приглашён',
        suspended: 'Заблокирован'
      },
      remove: 'Удалить',
      removeConfirm: 'Удалить этого участника из workspace?',
      invite: {
        nameLabel: 'Полное имя',
        email: 'Email пользователя',
        roleLabel: 'Роль',
        submit: 'Пригласить пользователя',
        success: 'Приглашение успешно отправлено',
        modalTitle: 'Пригласить участника',
        openButton: 'Пригласить участника',
        manager: 'Руководитель (необязательно)',
        role: 'Роль'
      }
    },
    billing: {
      mockNotice:
        'Ниже приведены примерные данные для интерфейса. Они подключатся к API биллинга, когда он появится.',
      period: 'Расчётный период',
      apiRequests: 'Запросы API',
      storageGb: 'Хранилище',
      aiTokensUsed: 'Использовано AI-токенов',
      aiTokensLimit: 'Лимит AI-токенов'
    },
    agents: {
      title: 'Агенты',
      description:
        'Регистрируйте AI-агентов как управляемые идентичности с изоляцией по тенанту. Выдавайте минимально необходимый доступ к приложениям, брокерите их доступ к внешним инструментам, затем ротируйте, отзывайте и аудируйте.',
      mockNotice:
        'Демоданные — агенты, подключения и токены хранятся в локальном mock. Выпуск токенов и внешние OAuth-обмены имитируются до появления бэкенда.',
      register: 'Зарегистрировать агента',
      empty:
        'Агентов пока нет. Зарегистрируйте агента, чтобы дать AI-агенту доступ к приложениям и инструментам с ограниченной областью.',
      moreScopes: '+{{count}} ещё',
      kpi: {
        agents: 'Агенты',
        active: 'Активные',
        delegated: 'Делегированные',
        expiringSoon: 'Скоро истекут',
        pendingApprovals: 'Ожидают одобрения'
      },
      visibility: {
        private: 'Приватный',
        public: 'Публичный',
        restricted: 'Ограниченный'
      },
      tier: {
        system: 'Системный',
        template: 'Шаблон',
        workspace: 'Рабочее пространство',
        personal: 'Личный'
      },
      restricted: {
        label: 'Ограничен'
      },
      runAs: {
        shareWarning: {
          title: 'Ваши автоматизации продолжат работать от вашего имени',
          body: 'На этом агенте {{count}} ваших триггеров ({{schedules}} по расписанию, {{channels}} webhook, {{widgets}} виджет). Как только он откроется рабочему пространству, коллеги смогут менять его поведение — а запуски по-прежнему будут использовать ваши права.',
          confirm: 'Всё равно открыть',
          cancel: 'Оставить ограниченным'
        }
      },
      toolExecution: {
        ask: 'Спрашивать перед запуском инструментов',
        auto: 'Запускать инструменты автономно'
      },
      delete: {
        confirmTitle: 'Удалить агента?',
        confirmBody:
          '«{{name}}» удаляется безвозвратно вместе со своими разрешениями. Это действие нельзя отменить.',
        success: 'Агент удалён'
      },
      toolbar: {
        showing: 'Показано {{shown}} из {{total}}'
      },
      intro: {
        lead: 'Агенты — это нечеловеческие идентичности, которые организация разворачивает для действий на платформе: автономно или от имени пользователя. Они входят по коротким токенам с изоляцией по тенанту (никогда не статические ключи) и обращаются к внешним инструментам через защищённое хранилище.',
        howTitle: 'Как это работает',
        whereTitle: 'Когда использовать',
        where:
          'Используйте агента, когда ПО — автоматизация, бот или AI-ассистент — нуждается в управляемом доступе к вашим приложениям или внешним инструментам, с полным аудитом и мгновенным отзывом.',
        hide: 'Скрыть руководство',
        show: 'Как работают агенты',
        steps: {
          register: {
            title: '1 · Регистрация',
            desc: 'Создайте идентичность агента — Сервисный (автономный) или Делегированный (действует за пользователя).'
          },
          scope: {
            title: '2 · Выдача доступа',
            desc: 'Дайте минимально необходимый доступ к конкретным приложениям и операциям.'
          },
          connect: {
            title: '3 · Подключение инструментов',
            desc: 'При необходимости подключите Gmail, Slack и другие через хранилище — агент никогда не видит учётные данные.'
          },
          authenticate: {
            title: '4 · Аутентификация',
            desc: 'Агент получает короткие токены с изоляцией по тенанту. Без статических ключей.'
          },
          call: {
            title: '5 · Вызов инструментов',
            desc: 'Возможности предоставляются как инструменты MCP, которые агент обнаруживает и вызывает.'
          },
          approve: {
            title: '6 · Одобрение',
            desc: 'Вызовы с высоким риском приостанавливаются для одобрения человеком через device или CIBA перед выполнением.'
          },
          govern: {
            title: '7 · Управление',
            desc: 'Ротируйте, отзывайте, проверяйте и аудируйте любое действие в любой момент.'
          }
        },
        typesTitle: 'Два вида агентов'
      },
      agentType: {
        service: 'Сервисный',
        delegated: 'Делегированный'
      },
      agentTypeHint: {
        service:
          'Принадлежит организации, действует автономно через grant client-credentials.',
        delegated:
          'Принадлежит пользователю, действует от его имени через authorization-code + обмен токенами.'
      },
      status: {
        active: 'Активен',
        suspended: 'Приостановлен',
        revoked: 'Отозван',
        expired: 'Истёк'
      },
      list: {
        search: 'Поиск по имени или client ID',
        openRow: 'Открыть {{name}}',
        filterType: 'Тип',
        filterVerified: 'Проверка',
        all: 'Все',
        expiringSoon: 'Скоро истекает',
        kpiTotal: 'Агенты',
        kpiActive: 'Активные',
        kpiDelegated: 'Делегированные',
        kpiExpiring: 'Скоро истекают',
        kpiPendingApprovals: 'Ожидают одобрения'
      },
      verified: {
        yes: 'Проверен',
        no: 'Не проверен'
      },
      verifiedTooltip:
        'Проверенным агентам можно выдавать более широкий доступ. Непроверенных следует ограничивать.',
      columns: {
        name: 'Агент',
        type: 'Тип',
        actingUser: 'Действует за',
        scopes: 'Доступ к приложениям',
        connections: 'Подключения',
        lastActive: 'Активность',
        created: 'Создан',
        status: 'Статус',
        actions: 'Действия'
      },
      noConnections: 'Нет инструментов',
      noScopes: 'Нет доступа к приложениям',
      moreApps: '+{{count}} ещё',
      lastActiveNever: 'Никогда',
      actions: {
        open: 'Открыть',
        rotate: 'Сменить секрет',
        revoke: 'Отозвать',
        delete: 'Удалить',
        configure: 'Настроить',
        viewActivity: 'Активность',
        suspend: 'Приостановить',
        resume: 'Возобновить',
        reconnect: 'Переподключить'
      },
      rotate: {
        confirmTitle: 'Сменить секрет агента?',
        confirmBody:
          'Текущий секрет немедленно перестаёт работать. Новый секрет показывается один раз.',
        success: 'Секрет сменён'
      },
      revoke: {
        confirmTitle: 'Отозвать агента?',
        confirmBody:
          '«{{name}}» немедленно теряет весь доступ, а его токены аннулируются. Это нельзя отменить.',
        success: 'Агент отозван'
      },
      messages: {
        registered: 'Агент зарегистрирован',
        updated: 'Агент обновлён',
        scopesUpdated: 'Области обновлены',
        scopeRevoked: 'Область отозвана',
        connected: 'Инструмент подключён',
        disconnected: 'Инструмент отключён',
        reconnected: 'Инструмент переподключён',
        tokenIssued: 'Тестовый токен выпущен',
        verifiedSet: 'Проверка обновлена',
        suspended: 'Агент приостановлен',
        resumed: 'Агент возобновлён'
      },
      reveal: {
        title: 'Учётные данные агента',
        warning:
          'Скопируйте секрет клиента сейчас — он показывается только один раз.',
        clientId: 'Client ID',
        secret: 'Секрет клиента',
        done: 'Готово'
      },
      form: {
        registerTitle: 'Зарегистрировать агента',
        editTitle: 'Настроить агента',
        registerNotice:
          'Агент действует от имени того, кто с ним общается, через общий OAuth-клиент Core рабочего пространства. После регистрации подключите инструменты и выдайте доступ на странице агента.',
        name: 'Название',
        nameRequired: 'Укажите название',
        nameDuplicate: 'Агент с таким именем уже существует',
        namePlaceholder: 'напр. Агент по исследованию биллинга',
        description: 'Описание',
        descriptionOptional: 'необязательно',
        descriptionPlaceholder: 'Что делает агент и какие есть ограничения.',
        systemPrompt: 'Системный промпт',
        systemPromptHint: 'Инструкции, определяющие, как агент отвечает.',
        systemPromptPlaceholder: 'Ты — полезный ассистент, который…',
        visibility: 'Видимость',
        tier: 'Владение',
        tierHint:
          'Личные агенты доступны только вам; агенты рабочего пространства общие для организации.',
        restricted: 'Только назначенным пользователям',
        restrictedHint:
          'По умолчанию агент следует своему типу (личный — только вы; рабочее пространство — все). Включите, чтобы ограничить назначенными пользователями.',
        toolExecutionMode: 'Выполнение инструментов',
        toolExecutionModeHint:
          'Автономно — агент запускает инструменты записи без запроса. Спрашивать — приостанавливает выполнение и ждёт вашего одобрения перед каждым инструментом записи/изменения. Инструменты только для чтения выполняются всегда.',
        autoApprovedTools: 'Всегда одобряемые инструменты',
        autoApprovedToolsHint:
          'Инструменты, для которых вы выбрали «Всегда одобрять» в чате — для этого агента они больше не спрашивают подтверждения. Удалите тег, чтобы снова спрашивал.',
        autoApprovedToolsEmpty: 'Пока нет.',
        type: 'Тип агента',
        typeRequired: 'Выберите тип агента',
        actingUser: 'Действует от имени',
        actingUserRequired:
          'Выберите пользователя, за которого действует агент',
        actingUserPlaceholder: 'Выберите участника',
        actingUserHint:
          'Делегированные токены несут и пользователя, и агента; эффективный доступ — пересечение этих двух.',
        scopes: 'Разрешённые области',
        scopesHint:
          'Потолок возможностей, которые агент может запрашивать. Для каждого пользователя эффективный доступ — пересечение этих областей с его разрешениями (минимальные привилегии).',
        addScope: 'Добавить приложение',
        app: 'Приложение',
        appPlaceholder: 'Выберите приложение',
        appAlreadyAdded: 'Уже добавлено',
        permissions: 'Разрешения',
        permissionsPlaceholder: 'Все разрешения в этом приложении',
        noPermissions: 'У этого приложения пока нет гранулярных разрешений.',
        removeScope: 'Удалить',
        ttl: 'Время жизни токена доступа',
        ttlHint: 'Короткое; поддерживается refresh с ротацией.',
        ttlSuffix: 'мин',
        expiresAt: 'Срок действия агента',
        expiresAtOptional: 'необязательно',
        expiresAtPlaceholder: 'Без срока',
        cancel: 'Отмена',
        submit: 'Зарегистрировать агента',
        save: 'Сохранить изменения'
      },
      detail: {
        notFound: 'Агент не найден',
        tabs: {
          overview: 'Обзор',
          mcp: 'MCP',
          access: 'Доступ',
          approvals: 'Одобрения',
          connections: 'Подключения',
          externalTools: 'Внешние',
          activity: 'Активность'
        },
        hero: {
          clientId: 'Client ID',
          actingUser: 'Действует за',
          owner: 'Владелец',
          type: 'Тип',
          created: 'Создан',
          expires: 'Истекает',
          noExpiry: 'Без срока',
          scopes: 'Разрешённые области',
          scopesCount: '{{count}} область',
          scopesCount_few: '{{count}} области',
          scopesCount_many: '{{count}} областей',
          model: 'Модель',
          scopesCount_other: '{{count}} областей'
        }
      },
      overview: {
        identityTitle: 'Делегированная идентичность',
        identityBody:
          'Запросы выполняются как «{{name}}» от имени того, кто общается с агентом, через общий OAuth-клиент Core рабочего пространства. Нет ни секрета, ни срока токена, ни фиксированного пользователя для агента.',
        identityHint:
          'Эффективный доступ при каждом запросе — пересечение разрешённых областей агента с разрешениями этого пользователя в Skalx, проверяется Core.',
        agentId: 'ID агента',
        workspaceClient: 'Клиент рабочего пространства (org)',
        scopeCeiling: 'Потолок областей',
        provider: 'Модель',
        toolExecutionMode: 'Выполнение инструментов'
      },
      access: {
        title: 'Разрешённые области',
        save: 'Сохранить области',
        intersectionTitle: 'Как вычисляется эффективный доступ',
        intersectionBody:
          'Области выдаются для каждого подключения ниже — у каждого подключённого инструмента (и каждого экземпляра) свои. Для каждого пользователя, который общается с этим агентом, он может делать только (выданные области) ∩ (что разрешено пользователю в Skalx). Управляйте тем, кто может использовать агентов, в разделе <rolesLink>Роли</rolesLink>.',
        emptyBody:
          'У этого агента пока нет подключённых инструментов. Сначала подключите MCP-сервер, затем выдайте его области здесь.',
        emptyCta: 'Подключить инструмент',
        noScopesForApp: 'У этого подключения нет настраиваемых областей.',
        empty: 'Области не выданы.'
      },
      mcp: {
        introTitle: 'Подключить инструменты (MCP)',
        introBody:
          'Подключите приложения, которые может использовать агент, и выдайте права каждому подключению ниже. Агент может делать только (выданные области) ∩ (что разрешено каждому пользователю в Skalx).',
        permissions: 'Права',
        title: 'Подключения инструментов',
        empty: 'Пока нет доступных интеграций инструментов.',
        connect: 'Подключить',
        connectedTag: 'Подключено',
        connected: 'Инструмент подключён',
        detached: 'Инструмент отключён',
        detach: 'Отключить',
        detachConfirm: 'Отключить этот сервер от агента?',
        enabledTip:
          'Включено — агент может вызывать инструменты этого сервера.',
        disabledTip: 'Выключено — подключено, но инструменты недоступны.',
        availableTitle: 'Доступные интеграции',
        activeTitle: 'Подключённые инструменты',
        activeIntroTitle: 'Инструменты, доступные этому агенту',
        activeIntroBody:
          'MCP-серверы, подключённые к агенту. Выключите сервер, чтобы его инструменты стали недоступны, не отключая его. Подключить новые — на вкладке «Подключения».',
        activeEmpty:
          'Инструменты ещё не подключены. Добавьте их на вкладке «Подключения».',
        noInstance:
          'Приложение {{app}} не установлено в этом рабочем пространстве.'
      },
      builtinTools: {
        introTitle: 'Встроенные инструменты',
        introBody:
          'Инструменты-функции, которые агент может вызывать напрямую. Включите нужный, чтобы он стал доступен агенту.',
        title: 'Доступные инструменты',
        empty: 'Нет доступных инструментов.',
        otherCategory: 'Прочее',
        enabledTip: 'Включено — агент может вызывать этот инструмент.',
        disabledTip: 'Выключено — включите, чтобы агент мог его вызывать.',
        updated: 'Инструменты обновлены',
        externalIntroTitle: 'Сторонние инструменты',
        externalIntroBody:
          'Инструменты от внешних сервисов, например Firecrawl. Включите нужный, чтобы он стал доступен агенту.',
        externalTitle: 'Инструменты провайдеров',
        externalEmpty: 'Нет сторонних инструментов.',
        apiKeyLabel: 'API-ключ {{provider}}',
        apiKeyPlaceholder: 'Вставьте API-ключ',
        apiKeyHelp:
          'Хранится в настройках агента. Обязательно — runtime не подставляет ключ.',
        apiKeyMissing:
          'Ключ не задан — добавьте, иначе инструмент не работает.',
        apiKeySaved: 'API-ключ сохранён'
      },
      connections: {
        title: 'Подключения к внешним инструментам',
        subtitle:
          'Подключённые аккаунты, к которым агент обращается через хранилище учётных данных.',
        brokerNote:
          'Хранилище хранит и обновляет сторонние токены на сервере. Агент и LLM никогда не видят базовые учётные данные.',
        connect: 'Подключить инструмент',
        connectTitle: 'Подключить внешний инструмент',
        connectNotice:
          'В продакшене здесь открывается OAuth-согласие провайдера. Здесь подключение имитируется.',
        provider: 'Инструмент',
        providerPlaceholder: 'Выберите инструмент',
        account: 'Аккаунт',
        accountPlaceholder: 'напр. agent@company.com',
        accountRequired: 'Укажите подключаемый аккаунт',
        toolScopes: 'Разрешения инструмента',
        toolScopesPlaceholder: 'Операции, которые может выполнять агент',
        empty: 'Инструменты не подключены.',
        columns: {
          tool: 'Инструмент',
          account: 'Аккаунт',
          status: 'Статус',
          scopes: 'Разрешения',
          lastRefreshed: 'Токен обновлён',
          actions: 'Действия'
        },
        status: {
          connected: 'Подключён',
          expired: 'Истёк',
          revoked: 'Отозван'
        },
        neverRefreshed: 'Ещё нет',
        reconnect: 'Переподключить',
        disconnect: 'Отключить',
        disconnectConfirmTitle: 'Отключить этот инструмент?',
        disconnectConfirmBody:
          'Агент немедленно потеряет возможность вызывать {{tool}}.'
      },
      activity: {
        title: 'Активность',
        subtitle: 'История запусков для {{name}}.',
        empty: 'Активность ещё не зафиксирована.',
        tokens: '{{count}} токенов',
        trigger: {
          chat: 'Запуск из чата',
          schedule: 'Запуск по расписанию',
          webhook: 'Запуск по вебхуку',
          api: 'Запуск через API'
        },
        status: {
          pending: 'В очереди',
          running: 'Выполняется',
          done: 'Готово',
          error: 'Ошибка',
          paused: 'Приостановлено'
        },
        columns: {
          action: 'Действие',
          when: 'Когда'
        }
      },
      tools: {
        introTitle: 'Инструменты, которые может вызывать агент (MCP)',
        introBody:
          'Возможности предоставляются как инструменты MCP и управляются в Squad. Каждый вызов наследует разрешённые области агента, пересечённые для каждого пользователя с его разрешениями Skalx.',
        mcpTitle: 'Обнаружение MCP',
        mcpSubtitle:
          'Что получает клиент MCP, чтобы узнать endpoint и каталог инструментов этого агента.',
        discoveryUrl: 'Документ обнаружения',
        mcpEndpoint: 'Endpoint MCP',
        title: 'Инструменты',
        mcpServers: 'Серверы MCP',
        managedInSquad:
          'Инструменты и серверы MCP этого агента настраиваются в Squad.',
        subtitle:
          'Возможности, привязанные к этому агенту. Каждая соответствует разрешению приложения или подключённому инструменту.',
        add: 'Добавить инструмент',
        addTitle: 'Добавить инструмент',
        addNotice:
          'Выберите возможность из каталога. Политику одобрения можно изменить позже.',
        addPlaceholder: 'Выберите возможность',
        empty:
          'Инструментов пока нет. Добавьте один, чтобы агент мог выполнить действие.',
        remove: 'Удалить',
        removeConfirmTitle: 'Удалить этот инструмент?',
        removeConfirmBody: 'Агент больше не сможет вызывать {{tool}}.',
        test: 'Тестовый вызов',
        run: 'Выполнить вызов',
        testTitle: 'Тестовый вызов · {{tool}}',
        testApprovalNote:
          'Этот инструмент требует одобрения — вызов приостановится как ожидающий запрос вместо немедленного выполнения.',
        inputLabel: 'Входные данные инструмента (JSON)',
        requiresApproval: 'Требует одобрения',
        autoRuns: 'Выполняется автоматически',
        recentCallsTitle: 'Недавние вызовы',
        columns: {
          tool: 'Инструмент',
          source: 'Источник',
          risk: 'Риск',
          approval: 'Политика одобрения',
          enabled: 'Включён'
        },
        callColumns: {
          tool: 'Инструмент',
          status: 'Результат',
          when: 'Когда'
        },
        source: {
          app: 'Приложение',
          connector: 'Коннектор'
        },
        risk: {
          low: 'Низкий',
          medium: 'Средний',
          high: 'Высокий'
        },
        callStatus: {
          succeeded: 'Успешно',
          denied: 'Отклонено',
          pending_approval: 'Ожидает одобрения',
          failed: 'Ошибка'
        },
        messages: {
          added: 'Инструмент добавлен',
          updated: 'Инструмент обновлён',
          removed: 'Инструмент удалён'
        },
        result: {
          okTitle: 'Вызов завершён',
          heldTitle: 'Отправлено на одобрение',
          heldBody:
            'Этот вызов требует одобрения человеком ({{method}}). Разрешите его во вкладке «Одобрения».',
          userCode: 'Код устройства'
        }
      },
      approvals: {
        introTitle: 'Одобрения с участием человека',
        introBody:
          'Вызовы инструментов, требующие решения человека, приостанавливаются здесь перед выполнением. Одобрение возобновляет агента и разрешает вызов; отклонение блокирует его.',
        pendingTitle: 'Ожидают ({{count}})',
        pendingEmpty:
          'Нет ожидающих одобрений. Ограниченные вызовы появятся здесь.',
        historyTitle: 'История решений',
        filterAll: 'Все',
        pendingCount: 'В ожидании: {{count}}',
        scope: {
          agent: 'Этот агент',
          workspace: 'Все агенты'
        },
        approve: 'Одобрить',
        deny: 'Отклонить',
        denyTitle: 'Отклонить этот запрос?',
        reasonLabel: 'Причина',
        reasonPlaceholder: 'Необязательная заметка, записываемая с решением.',
        status: {
          pending: 'Ожидает',
          accepted: 'Одобрено',
          edited: 'Одобрено (изменено)',
          rejected: 'Отклонено',
          answered: 'Отвечено'
        },
        columns: {
          action: 'Действие',
          requested: 'Запрошено',
          when: 'Когда',
          agent: 'Агент',
          status: 'Статус',
          resolved: 'Решено'
        },
        messages: {
          approved: 'Запрос одобрен — агент возобновляется',
          denied: 'Запрос отклонён',
          failed: 'Не удалось обработать запрос'
        }
      }
    },
    apps: {
      title: 'Приложения workspace',
      description:
        'Управляйте каталогом приложений, ролями, учётными данными, вебхуками и аудитом.',
      routeShellDescription:
        'Настройте приложение: роли, учётные данные, вебхуки и журнал аудита.',
      create: 'Создать приложение',
      createModalTitle: 'Создать приложение workspace',
      browseCatalog: 'Каталог',
      createCustomLocal: 'Кастомное приложение',
      navLabel: 'Разделы приложения',
      nav: {
        overview: 'Обзор',
        people: 'Люди',
        groups: 'Группы',
        roles: 'Роли',
        oidc: 'OIDC',
        scim: 'SCIM',
        credentials: 'Учетные данные',
        webhooks: 'Вебхуки',
        outboundWebhooks: 'Вебхуки',
        activity: 'Активность',
        settings: 'Настройки'
      },
      groups: {
        columns: {
          name: 'Группа',
          members: 'Участники',
          roles: 'Роли в этом приложении',
          updated: 'Обновлено',
          otherApps_one: '+{{count}} роль в других приложениях',
          otherApps_few: '+{{count}} роли в других приложениях',
          otherApps_many: '+{{count}} ролей в других приложениях',
          otherApps_other: '+{{count}} ролей в других приложениях',
          otherAppsHint: 'Группа также выдаёт: {{roles}}'
        },
        actions: {
          add: 'Добавить группу',
          create: 'Новая группа',
          editRoles: 'Изменить роли',
          revoke: 'Отозвать доступ'
        },
        modal: {
          addTitle: 'Добавить группу в это приложение',
          editTitle: 'Изменить роли',
          accessNotice:
            'Все участники группы получат эти роли и доступ к этому приложению.',
          groupLabel: 'Группа',
          groupPlaceholder: 'Выберите группу',
          groupRequired: 'Выберите группу',
          noCandidates: 'У всех групп уже есть доступ здесь.',
          rolesLabel: 'Роли в этом приложении',
          rolesPlaceholder: 'Выберите роли',
          rolesHint:
            'Затрагивается только это приложение. Роли других приложений не меняются.',
          alsoGrants: 'Группа выдаёт доступ и в других приложениях',
          submit: 'Сохранить',
          cancel: 'Отмена'
        },
        create: {
          title: 'Новая группа',
          submit: 'Создать группу',
          success: 'Группа создана',
          accessNotice:
            'Участники группы получат выбранные здесь роли — и доступ к этому приложению. Те, у кого доступа ещё нет, получат его.',
          membersHint:
            'Добавить можно любого участника организации, не только тех, кто уже пользуется приложением.',
          rolesHint:
            'Здесь предлагаются только роли этого приложения. Остальные можно добавить позже в разделе «Пользователи → Группы».'
        },
        revoke: {
          title: 'Отозвать доступ',
          content:
            'Убрать все роли, которые это приложение выдаёт через «{{name}}»? Участники сохранят доступ, который есть у них лично или через другую группу.',
          confirm: 'Отозвать'
        },
        messages: {
          rolesUpdated: 'Роли группы обновлены',
          revoked: 'Доступ группы отозван'
        }
      },
      navGroups: {
        access: 'Доступ',
        connection: 'Подключение',
        monitor: 'Управление'
      },
      outboundWebhookDetail: {
        breadcrumb: 'Вебхук',
        back: 'Назад к {{app}}',
        overviewTitle: 'Обзор',
        eventsTitle: 'Подписанные события',
        noEvents: 'События не выбраны, поэтому ничего не отправляется.',
        eventSummary: '{{events}} в {{entities}}',
        objectCount_one: '{{count}} объекте',
        objectCount_few: '{{count}} объектах',
        objectCount_many: '{{count}} объектах',
        updated: 'Последнее изменение',
        stateActive: 'Активен',
        stateInactive: 'Неактивен',
        objectCount_other: '{{count}} объектов'
      },
      outboundWebhooks: {
        create: 'Добавить вебхук',
        empty:
          'Пока нет эндпоинтов. Добавьте первый, чтобы получать события CRM.',
        toolbar: { label: 'настроенных эндпоинтов' },
        columns: {
          name: 'Название',
          url: 'Эндпоинт',
          events: 'События',
          eventCount_one: '{{count}} событие',
          eventCount_few: '{{count}} события',
          eventCount_many: '{{count}} событий',
          active: 'Активен',
          created: 'Создан',
          eventCount_other: '{{count}} событий'
        },
        actions: {
          reveal: 'Показать секрет подписи',
          test: 'Отправить тестовый вебхук'
        },
        deleteModal: {
          title: 'Удалить вебхук?',
          content:
            'Доставка прекратится сразу, включая попытки, уже поставленные в очередь на повтор.'
        },
        test: {
          title: 'Тестовая отправка',
          accepted: 'Эндпоинт принял доставку ({{status}}).',
          rejected: 'Эндпоинт ответил {{status}}.',
          unreachable: 'Не удалось достучаться до эндпоинта.',
          responseBody: 'Ответ эндпоинта',
          hint: 'Запрос подписан ровно так же, как настоящее событие, с именем webhook.test. Некоторые сервисы активируют тестовую ссылку на один вызов — нажмите у них кнопку прослушивания и отправьте ещё раз.',
          deliveryId: 'Доставка: {{id}}'
        },
        messages: { deleted: 'Вебхук удалён' },
        managed: {
          tag: 'Squad',
          openInSquad: 'Открыть в Squad',
          editWarning:
            'Этим вебхуком управляет Squad — смена адреса или секрета отключит агента'
        },
        secret: {
          title: 'Секрет подписи',
          hint: 'Передайте его получателю событий — им проверяется заголовок X-CRM-Signature. Каждый показ фиксируется в журнале активности.'
        },
        events: {
          placeholder: 'Выберите события для получения',
          selectAll: 'Выбрать все',
          clear: 'Очистить',
          unavailable: 'Не удалось загрузить список событий из этого CRM.',
          unavailableHint:
            'Список отдаёт само приложение CRM. Проверьте, что оно доступно, и откройте форму заново.'
        },
        verify: {
          title: 'Проверка подписи',
          copy: 'Копировать',
          intro:
            'Каждая доставка приходит с заголовком X-CRM-Signature: t=<unix>,v1=<hex> — это HMAC-SHA256 от строки "<t>.<raw body>" на секрете этого вебхука. Пересчитав его, получатель убеждается, что запрос от нас и не изменён по пути.',
          secretHint:
            'Секрет возьмите из «Показать секрет подписи» и держите его в переменных окружения, а не в коде.',
          tips: {
            rawBody:
              'Подписывайте сырые байты. Если распарсить JSON и собрать заново, байты изменятся и подпись никогда не совпадёт.',
            constantTime:
              'Сравнивайте функцией с постоянным временем. Обычный === выдаёт, какая часть подписи была угадана верно.',
            replay:
              'Отклоняйте старую метку времени. Каждая повторная попытка подписывается заново, поэтому устаревший t означает, что кто-то воспроизводит перехваченный запрос.',
            idempotency:
              'Отсеивайте дубликаты по X-CRM-Delivery. Доставка, отвалившаяся по таймауту на вашей стороне, будет повторена — одно событие может прийти дважды.',
            retries:
              'Отвечайте 2xx быстро, а обрабатывайте потом. Всё остальное мы повторяем пять раз в течение примерно двух с половиной часов, затем событие теряется.'
          },
          n8n: 'В n8n проверка устроена иначе. Шаблон по ссылке ниже реализует схему GitHub: один заголовок, подпись только от тела. Для нас: включите Raw Body в ноде Webhook, разберите X-CRM-Signature на t и v1 и подписывайте "<t>.<raw body>". Ноды Crypto и IF не умеют добавлять метку времени перед сырыми байтами, поэтому используйте вместо них ноду Code с примером на Node.js выше.',
          n8nLink: 'Шаблон проверки HMAC в n8n'
        },
        form: {
          name: 'Название',
          namePlaceholder: 'Например, Распределение лидов',
          createTitle: 'Новый вебхук',
          editTitle: 'Изменить вебхук',
          url: 'URL эндпоинта',
          urlHttps: 'Допустимы только https-адреса.',
          events: 'События',
          eventsRequired: 'Выберите хотя бы одно событие.',
          secret: 'Секрет подписи',
          secretPlaceholderCreate: 'Оставьте пустым — сгенерируем сами',
          secretPlaceholderEdit:
            'Оставьте пустым, чтобы сохранить текущий секрет',
          secretCreateHint:
            'Заполняйте только если принимающая система требует своё значение.',
          secretEditHint:
            'Замена сломает проверку подписи у получателя, пока он не обновит значение у себя.',
          secretTooShort: 'Секрет должен быть не короче {{min}} символов.',
          active: 'Активен',
          activeHint:
            'Выключение немедленно прекращает доставку, включая уже поставленные в очередь повторы.'
        }
      },
      board: {
        searchPlaceholder: 'Поиск приложений',
        filterAll: 'Все',
        filterInstalled: 'Установленные',
        filterAvailable: 'Доступные',
        createCustom: 'Создать кастомное приложение',
        installedGroup: 'Установленные',
        installedHint: 'Работают в этом рабочем пространстве.',
        availableGroup: 'Доступные',
        availableHint: 'Ещё не установлены.',
        factType: 'Тип',
        launch: 'Открыть {{name}} в новой вкладке',
        userCount_one: '{{count}} пользователь',
        userCount_few: '{{count}} пользователя',
        userCount_many: '{{count}} пользователей',
        userCount_other: '{{count}} пользователей',
        userCountUnknown: 'Пользователи —',
        sortLabel: 'Сортировка приложений',
        sort: {
          name: 'Название А–Я',
          '-name': 'Название Я–А',
          newest: 'Сначала новые',
          oldest: 'Сначала старые'
        },
        factInstalled: 'Установлено',
        openApp: 'Открыть',
        manageAccess: 'Управление доступом',
        install: 'Установить',
        empty: {
          filtered: 'Нет приложений, соответствующих поиску.',
          none: 'Для этого рабочего пространства пока нет приложений.'
        }
      },
      iconField: {
        pick: 'Выбрать иконку',
        reset: 'Сбросить',
        hint: 'Иконка или своё изображение · PNG, JPG, SVG до 1 МБ',
        hintIconsOnly: 'Иконка для приложения'
      },
      createCustom: {
        defaultTitle: 'Новое кастомное приложение',
        defaultSubtitle: 'Идентификация workspace для любого приложения',
        cancel: 'Отмена',
        submit: 'Создать приложение',
        fields: {
          name: 'Название приложения',
          nameExtra: 'Видно в Skalx и на экране согласия OAuth.',
          namePlaceholder: 'например Edge gateway',
          description: 'Описание',
          descriptionExtra:
            'Необязательно. Помогает команде понять назначение приложения.',
          descriptionPlaceholder: 'Краткое описание приложения.',
          icon: 'Иконка приложения'
        },
        connection: {
          domain: 'Домен приложения',
          domainExtra:
            'Необязательно. Хост для redirect URI и CORS. Сохраняется как application_domain.',
          appUrl: 'URL приложения',
          appUrlExtra:
            'Необязательно. Куда попадает пользователь, открывая приложение из Skalx. Сохраняется как application_url.'
        }
      },
      customTab: {
        headerTitle: 'Кастомные приложения',
        headerDescription:
          'Внутренние или сторонние приложения, авторизующиеся через Skalx. Подключайте их по OIDC.',
        docs: 'Документация',
        create: 'Создать кастомное приложение',
        authType: 'OIDC',
        empty: 'Кастомных приложений пока нет.',
        noDeployment: 'URL развёртывания пока не указан.',
        users: 'Пользователи',
        created: 'Создано',
        status: {
          ready: 'Готово',
          draft: 'Черновик'
        },
        menu: {
          open: 'Открыть приложение',
          manage: 'Управление',
          rotate: 'Обновить ключи',
          delete: 'Удалить приложение'
        },
        howItWorks: {
          title: 'Skalx как слой идентификации для любого приложения',
          description:
            'Кастомные приложения позволяют использовать Skalx для аутентификации, ролей и аудита в любом внешнем или внутреннем приложении.',
          steps: {
            defineApp: 'Опишите приложение',
            issueCredentials: 'Выпустите ключи',
            connect: 'Подключите по OIDC',
            grantAccess: 'Выдайте доступ'
          }
        },
        createDrawerTitle: 'Новое кастомное приложение',
        drawerPlaceholder: {
          title: 'Многошаговый поток появится на шаге 5',
          description:
            'Этот drawer проведёт через идентификацию, метод аутентификации, подключение и роли в четыре шага.',
          note: 'Сейчас поток в разработке. После утверждения шага 5 этот drawer будет подключён к реальному API приложений и создаст приложение при отправке.'
        }
      },
      catalogTab: {
        searchPlaceholder: 'Поиск в каталоге…',
        shown: 'показано',
        submitApp: 'Предложить приложение →',
        featured: 'Рекомендуется',
        featuredFallbackDescription:
          'Встроенное приложение, которое устанавливается в один клик.',
        addToWorkspace: 'Добавить в workspace',
        manage: 'Управление',
        installed: 'Установлено',
        popular: 'Популярное',
        docs: 'Документация',
        noDescription: 'Нет описания.',
        orderName: 'По имени (А → Я)',
        orderNameDesc: 'По имени (Я → А)',
        orderNewest: 'Сначала новые',
        orderOldest: 'Сначала старые',
        loadingMore: 'Загружаем ещё приложения…',
        statusFilter: {
          all: 'Все',
          installed: 'Установленные',
          available: 'Доступные'
        },
        empty: {
          none: 'В каталоге пока нет приложений.',
          filtered: 'Нет приложений, соответствующих фильтрам.'
        }
      },
      installed: {
        kpi: {
          installed: 'Установленные приложения',
          activeSessions: 'Активные сессии',
          totalUsers: 'Всего пользователей',
          totalUsersFooter: 'в {{count}} приложениях',
          needAttention: 'Требуют внимания'
        },
        filters: {
          searchPlaceholder: 'Поиск приложений…',
          typeAll: 'Все типы',
          typeBuiltin: 'Встроенные',
          typeCustom: 'Кастомные',
          healthAll: 'Все статусы',
          healthSoon:
            'Фильтр статуса — будет доступен, когда API начнёт отдавать статус каждого приложения.'
        },
        totalApps_one: '{{count}} приложение',
        totalApps_few: '{{count}} приложения',
        totalApps_many: '{{count}} приложений',
        totalApps_other: '{{count}} приложений',
        totalApps: '{{count}} приложений',
        columns: {
          app: 'Приложение',
          type: 'Тип',
          health: 'Статус',
          users: 'Пользователи',
          sessions: 'Сессии · 24ч',
          errorRate: 'Ошибки',
          created: 'Создано'
        },
        type: {
          builtin: 'Встроенное',
          custom: 'Кастомное'
        },
        actions: {
          addFromCatalog: 'Добавить из каталога',
          newCustom: 'Новое кастомное приложение',
          refresh: 'Обновить',
          density: 'Плотность (скоро)'
        },
        rowMenu: {
          open: 'Открыть приложение',
          manage: 'Управление',
          credentials: 'Учётные данные',
          roles: 'Роли',
          uninstall: 'Удалить'
        },
        empty: {
          none: 'В этом workspace ещё нет установленных приложений.',
          filtered: 'Нет приложений, соответствующих фильтрам.'
        }
      },
      builtin: {
        installDrawerTitle: 'Установить встроенное приложение'
      },
      custom: {
        fields: {
          url: 'URL',
          urlInvalid: 'Введите корректный URL (https://...)'
        },
        delete: 'Удалить приложение',
        deleteConfirm: {
          title: 'Удалить это кастомное приложение?',
          description:
            'Это действие безвозвратно удалит приложение, его роли и токены.'
        }
      },
      catalog: {
        crm: {
          title: 'Workspace CRM',
          description: 'Воронка, клиенты и продажи в ролях workspace.'
        },
        hrm: {
          title: 'Workspace HRM',
          description: 'Кадры, SCIM и HR-процессы.'
        },
        identity: {
          title: 'Идентификация и доступ',
          description: 'Токены, SSO и партнёрские поверхности входа.'
        },
        finance: {
          title: 'Финансы и биллинг',
          description: 'Счета, подписки и выручка.'
        }
      },
      manage: 'Управлять',
      status: {
        active: 'Активно',
        archived: 'Архивировано',
        revoked: 'Отозвано',
        expired: 'Истекло'
      },
      messages: {
        created: 'Приложение успешно создано',
        updated: 'Приложение успешно обновлено',
        deleted: 'Приложение удалено',
        deleteTokenMissing:
          'Токен приложения ещё не загружен. Обновите страницу и попробуйте снова.',
        roleUpdated: 'Роль успешно обновлена',
        customPermissionCreated: 'Пользовательское разрешение создано',
        customPermissionCreateFailed:
          'Не удалось создать пользовательское разрешение'
      },
      loadError: 'Не удалось загрузить приложения для этого workspace.',
      retry: 'Повторить',
      empty: 'Приложений пока нет.',
      noRepositoryTypes:
        'Нет доступных шаблонов приложений. Обратитесь к администратору.',
      createForm: {
        instanceType: 'Шаблон приложения',
        instanceTypePlaceholder: 'Выберите шаблон',
        platformConfigHint:
          'Выберите, как приложение встраивается в платформу workspace, чтобы роли, подготовка пользователей и API-доступ оставались согласованными с первого дня.'
      },
      overview: {
        domain: 'Домен',
        appUrl: 'URL приложения',
        instanceType: 'Шаблон',
        createdAt: 'Создано',
        visibility: 'Видимость',
        appInfoTitle: 'Сведения о приложении',
        editHint:
          'Имя и описание сохраняются в записи приложения. Значок хранится в этом браузере, пока API не поддерживает значки. Контекст продукта в разделах выше остаётся в UI workspace до появления отдельных endpoint.',
        coreWrappingHint:
          'По умолчанию приложения должны наследовать аутентификацию workspace, контроль доступа и настройки безопасности, если вы явно не моделируете отдельную SSO-границу.',
        templateConfigTitle: 'Поверхность настройки шаблона',
        templateConfigDescription:
          'Этот шаблон открывает {{count}} настраиваемых ключей, которые может оборачивать платформа workspace.',
        templateConfigEmpty:
          'Этот шаблон не открывает дополнительных ключей настройки через текущий API.',
        appRolesCardTitle: 'Роли и права приложения',
        appRolesCardDescription:
          'Определите, кто может управлять приложением, учётными данными и интеграциями. Вкладка «Роли» дублирует эти действия в отдельном виде.',
        workspaceRolesAccessHint:
          'Это приложение использует роли workspace. Назначайте участников в разделах «Участники» и «Роли» workspace; роли уровня приложения скрыты.',
        analyticsTitle: 'Использование и надёжность',
        analyticsSessions: 'Активные сессии (24ч)',
        analyticsErrors: 'Доля ошибок',
        analyticsLatency: 'P95 задержка',
        dashboardsTitle: 'Дашборды',
        dashboardsHint:
          'Закреплённые операционные виды для этого приложения (mock).',
        agentsTitle: 'ИИ-агенты',
        agentsHint: 'Автономные помощники для этого приложения (mock).',
        dangerZoneTitle: 'Опасная зона',
        dangerZoneDescription:
          'Безвозвратно удалить это кастомное приложение и все его настройки.',
        dashboardItem: {
          health: 'Здоровье и uptime',
          usage: 'Использование и квоты',
          security: 'Позиция по безопасности'
        },
        agentItem: {
          support: 'Триаж поддержки',
          supportDesc: 'Черновики ответов по тикетам и аудиту.',
          ops: 'Копилот операций',
          opsDesc: 'Сводки инцидентов и шаги из runbook.'
        }
      },
      settings: {
        edit: 'Изменить настройки',
        save: 'Сохранить настройки',
        saved: 'Настройки шаблона сохранены',
        default: 'По умолчанию',
        placeholder: 'Введите значение'
      },
      productType: {
        built_in: 'Встроенное',
        custom: 'Кастомное'
      },
      solution: {
        crm: 'CRM',
        hrm: 'HRM',
        identity: 'Идентификация',
        finance: 'Финансы',
        operations: 'Операции',
        custom: 'Кастомное'
      },
      accessModel: {
        workspace_roles: 'Роли workspace',
        app_roles: 'Роли приложения'
      },
      provisioning: {
        manual: 'Вручную',
        jit: 'Just-in-time',
        scim: 'SCIM'
      },
      authMode: {
        workspace_core: 'Ядро auth workspace',
        dedicated_sso: 'Отдельная SSO-граница'
      },
      apiExposure: {
        internal: 'Внутренний',
        partner: 'Партнёрский',
        public: 'Публичный'
      },
      configurationStatus: {
        ready: 'Готово',
        needsAttention: 'Требует внимания'
      },
      visibility: {
        public: 'Публичное',
        private: 'Приватное'
      },
      columns: {
        app: 'Приложение',
        domain: 'Домен',
        url: 'URL',
        instanceType: 'Шаблон',
        visibility: 'Видимость',
        createdAt: 'Создано',
        actions: 'Действия'
      },
      fields: {
        slug: 'Slug',
        goal: 'Цель',
        description: 'Описание',
        owner: 'Владелец',
        productType: 'Тип продукта',
        solutionArea: 'Область решения',
        accessModel: 'Модель доступа',
        provisioningMode: 'Provisioning',
        authMode: 'Граница auth',
        apiExposure: 'Экспозиция API',
        environment: 'Среда',
        status: 'Статус'
      },
      environments: {
        development: 'Разработка',
        staging: 'Staging',
        production: 'Продакшен'
      },
      tabs: {
        overview: 'Обзор',
        users: 'Пользователи',
        roles: 'Роли',
        credentials: 'Учетные данные',
        webhooks: 'Вебхуки',
        audit: 'Аудит',
        settings: 'Настройки',
        access: 'Доступ',
        connection: 'Подключение',
        activity: 'Активность'
      },
      segments: {
        users: 'Пользователи',
        roles: 'Роли',
        oidc: 'OIDC',
        scim: 'SCIM',
        credentials: 'Учетные данные',
        webhooks: 'Вебхуки'
      },
      overviewTab: {
        kpi: {
          activeSessions: 'Активные сессии',
          errorRate: 'Ошибки',
          p95Latency: 'Латентность P95',
          monthlyActive: 'Месячная активность пользователей',
          noDataYet: 'API пока не возвращает метрики.'
        },
        usage: {
          title: 'Объём запросов',
          subtitle: 'Последние 24 часа · по часу.',
          empty:
            'Графики появятся, когда будет подключён API метрик приложения.'
        },
        info: {
          title: 'Информация о приложении',
          name: 'Имя',
          template: 'Шаблон',
          description: 'Описание',
          domain: 'Домен',
          appUrl: 'URL приложения',
          visibility: 'Видимость',
          created: 'Создано',
          token: 'Токен приложения',
          version: 'Версия'
        },
        activity: {
          title: 'Последняя активность',
          empty:
            'События аудита по приложению появятся, когда API будет открыт.'
        },
        apiNote:
          'Имя, шаблон, домен, видимость и дата создания приходят из реального API. Метрики, версия и активность подтянутся, как только появятся соответствующие эндпоинты.'
      },
      autoProvision: {
        title: 'Доступ для всех участников',
        enableLabel: 'Выдавать доступ всем по умолчанию',
        description:
          'Все участники workspace получают это приложение с выбранной ролью — и те, кто уже есть, и все, кого добавят позже. У тех, у кого роль в этом приложении уже есть, она сохраняется.',
        roleLabel: 'Роль по умолчанию',
        rolePlaceholder: 'Выберите роль',
        roleRequired: 'Выберите роль для участников или выключите настройку.'
      },
      settingsTab: {
        save: 'Сохранить',
        reset: 'Сбросить',
        general: {
          title: 'Общие',
          name: 'Имя',
          domain: 'Домен',
          domainReadOnly:
            'Домен задаётся при установке приложения и пока не редактируется.',
          appUrl: 'URL приложения',
          appUrlExtra: 'Куда попадает пользователь, открывая приложение.',
          description: 'Описание',
          icon: 'Иконка приложения'
        },
        danger: {
          title: 'Опасная зона',
          uninstall: {
            title: 'Удалить приложение',
            description:
              'Удаляет приложение из workspace. Доступ пользователей, роли и ключи будут удалены.',
            action: 'Удалить'
          }
        }
      },
      auditTab: {
        tabs: {
          events: 'События',
          exports: 'Экспорты'
        },
        title: 'Журнал аудита',
        subtitle: 'Ограничено этим приложением.',
        totalEvents_one: '{{count}} событие',
        totalEvents_few: '{{count}} события',
        totalEvents_many: '{{count}} событий',
        totalEvents_other: '{{count}} событий',
        refresh: 'Обновить',
        loadError: 'Не удалось загрузить события аудита для этого приложения.',
        retry: 'Повторить',
        openDetails: 'Открыть детали события {{event}}',
        filters: {
          searchPlaceholder: 'Поиск по описанию или инициатору…',
          actionPlaceholder: 'Действие',
          entityTypePlaceholder: 'Тип сущности',
          dateRangeLabel: 'Диапазон дат',
          entityIdPlaceholder: 'ID сущности',
          actorTypePlaceholder: 'Тип исполнителя',
          actorIdPlaceholder: 'Инициатор',
          clear: 'Очистить'
        },
        columns: {
          time: 'Время',
          application: 'Приложение',
          event: 'Событие',
          actor: 'Инициатор',
          description: 'Описание'
        },
        export: 'Экспорт',
        noMatches: 'Нет событий, соответствующих выбранным фильтрам.',
        empty: 'Для этого приложения пока нет событий аудита.'
      },
      auditDetail: {
        breadcrumb: 'Событие аудита',
        backToAudit: 'Назад к журналу аудита',
        loadError: 'Не удалось загрузить это событие аудита.',
        sections: {
          actorAndRequest: 'Инициатор и запрос',
          additionalData: 'Дополнительные данные',
          changes: 'Изменения',
          metadata: 'Метаданные',
          localizedDescriptions: 'Локализованные описания'
        },
        fields: {
          description: 'Описание',
          timestamp: 'Время',
          eventId: 'ID события',
          eventType: 'Тип события',
          channel: 'Канал',
          entityType: 'Тип сущности',
          entityId: 'ID сущности',
          category: 'Категория',
          application: 'Приложение',
          applicationId: 'ID приложения',
          organizationId: 'ID организации',
          service: 'Сервис',
          actor: 'Инициатор',
          actorId: 'ID инициатора',
          method: 'Метод',
          clientIp: 'IP клиента',
          url: 'URL запроса'
        }
      },
      usersTab: {
        searchPlaceholder: 'Поиск по имени или email…',
        totalUsers_one: '{{count}} пользователь',
        totalUsers_few: '{{count}} пользователя',
        totalUsers_many: '{{count}} пользователей',
        totalUsers_other: '{{count}} пользователей',
        totalUsers: '{{count}} пользователей',
        refresh: 'Обновить',
        grantAccess: 'Выдать доступ',
        grantAccessTitle: 'Выдать доступ к приложению',
        memberLabel: 'Участник',
        memberPlaceholder: 'Выберите участника рабочего пространства',
        memberRequired: 'Выберите участника.',
        roleLabel: 'Роль',
        rolePlaceholder: 'Выберите роль (необязательно)',
        grantSuccess: 'Доступ выдан',
        manageAccessTitle: 'Управление доступом к приложению',
        updateSuccess: 'Доступ обновлён',
        removeAccess: 'Убрать из приложения',
        removeConfirmTitle: 'Убрать доступ?',
        removeConfirmBody:
          'Участник потеряет доступ к этому приложению, включая его роли. Остальные приложения не затрагиваются.',
        removeSuccess: 'Доступ убран',
        noRoles: 'Нет ролей',
        organizationScope: 'Рабочее пространство',
        columns: {
          user: 'Пользователь',
          roles: 'Роли',
          source: 'Источник',
          userId: 'ID пользователя',
          actions: 'Действия'
        },
        empty: {
          none: 'У этого приложения пока нет пользователей с доступом.',
          filtered: 'Нет пользователей, соответствующих запросу.'
        }
      },
      roles: {
        workspaceRolesTitle: 'Связи ролей workspace',
        workspaceRolesHelp:
          'Выберите роли workspace, которые должны получить это приложение при онбординге. Затем сопоставьте права в матрице ниже.',
        saveLinkedWorkspaceRoles: 'Сохранить связи',
        linkedSaved: 'Связи обновлены',
        workspaceRolesMatrixTitle: 'Роли workspace × права приложения',
        workspaceRolesMatrixHint:
          'Для каждой связанной роли workspace отметьте возможности уровня приложения (права платформы и свои). Отдельно от ролей приложения.',
        workspaceRolesMatrixNeedLinks:
          'Сначала свяжите хотя бы одну роль workspace выше.',
        saveWorkspaceRolePermissionMap: 'Сохранить карту прав workspace',
        workspaceRolePermissionMapSaved: 'Карта прав сохранена',
        matrixTitle: 'Матрица прав',
        matrixHint:
          'Строки — права (платформа + свои). Столбцы — роли приложения. Встроенные роли только для чтения.',
        matrix: { permission: 'Право' },
        panelIntro:
          'Роли приложения объединяют права для этого приложения. Пользовательские роли можно менять и удалять; встроенные роли задаёт шаблон платформы.',
        add: 'Добавить роль',
        roleListTitle: 'Роли приложения',
        modalTitle: 'Добавить роль приложения',
        editModalTitle: 'Изменить роль приложения',
        viewModalTitle: 'Роль приложения',
        view: 'Просмотр',
        edit: 'Изменить',
        viewDone: 'OK',
        systemBadge: 'Встроенная',
        systemRoleHint:
          'Это встроенная роль. Имя и права управляются шаблоном платформы.',
        descriptionLabel: 'Описание роли',
        permissionsLabel: 'Права доступа',
        roleSourceLabel: 'Источник роли',
        workspaceRoleSelectLabel: 'Роль workspace',
        workspaceRoleSelectPlaceholder: 'Выберите роль workspace',
        roleSource: {
          custom: 'Пользовательская',
          workspace: 'Workspace'
        },
        removeConfirm: 'Удалить эту роль?',
        columns: {
          name: 'Имя',
          type: 'Тип',
          permissions: 'Права',
          actions: 'Действия'
        },
        appCustomPermissionsTitle: 'Права возможностей приложения',
        appCustomPermissionsHelp:
          'Задайте значения `code_name`, которые продукт проверяет в рантайме. У каждой записи стабильный `id` для API и назначений на роли.',
        appCustomPermissionCodeName: 'Код права',
        appCustomPermissionDisplayName: 'Отображаемое имя',
        appCustomPermissionDescription: 'Описание',
        appCustomPermissionId: 'Id права',
        addAppCustomPermission: 'Добавить своё право',
        removeAppCustomPermissionConfirm:
          'Удалить это право? Оно будет убрано из всех ролей, где используется.',
        appCustomPermissionDuplicate: 'Право с таким кодом уже существует.',
        appCustomPermissionCodeInvalid:
          'Используйте строчные буквы, цифры, точки, дефисы или подчёркивания (1–64 символа).',
        customPermissionsPickerLabel: 'Свои права приложения',
        createCustomPermissionForRole:
          'Создать своё право и добавить к этой роли',
        customPermissionsSelectPlaceholder: 'Выберите свои права',
        customPermissionsSelectEmpty:
          'Своих прав пока нет. Создайте право по ссылке ниже.',
        permissionsOrCustomRequired:
          'Выберите хотя бы одно право платформы или одно своё право.',
        module: 'Модуль/Ресурс',
        admin: 'Admin',
        adminHasFullAccess:
          'Роль Admin автоматически имеет все права и не может быть отредактирована.',
        selectAll: 'Выбрать все',
        deselectAll: 'Снять все',
        adminAll: 'Все права',
        noPermissions: 'Без прав',
        selectViewFirst: 'Сначала выберите право Просмотр',
        allPermissionTooltip: 'Включает записи всей команды, а не только свои.',
        deleteRoleConfirm: 'Удалить эту роль?',
        roleNamePlaceholder: 'Название роли',
        roleDescriptionPlaceholder: 'Описание (опционально)',
        permissionsUpdated: 'Права обновлены',
        unsavedChanges_one: '{{count}} несохранённое изменение',
        unsavedChanges_few: '{{count}} несохранённых изменения',
        unsavedChanges_many: '{{count}} несохранённых изменений',
        unsavedChanges_other: '{{count}} несохранённых изменений',
        resetToDefault: 'Сбросить',
        roleCreated: 'Роль создана',
        roleUpdated: 'Роль обновлена',
        roleDeleted: 'Роль удалена',
        deleteRoleWarning: 'Это действие нельзя отменить.',
        deletingRole: 'Удаление роли',
        usersWithRole_one: '{{count}} пользователь имеет эту роль.',
        usersWithRole_few: '{{count}} пользователя имеют эту роль.',
        usersWithRole_many: '{{count}} пользователей имеют эту роль.',
        usersWithRole_other: '{{count}} пользователей имеют эту роль.',
        selectReplacementRole: 'Переназначить пользователей на',
        replacementRoleDescription:
          'Существующие пользователи с этой ролью будут перенесены на выбранную роль.',
        selectRolePlaceholder: 'Выберите роль',
        permissionsCatalogTitle: 'Каталог прав',
        permissionsCatalogDescription:
          'Доступные права для назначения ролям этого приложения.',
        searchPermissions: 'Найти право…',
        addPermission: 'Добавить право',
        editPermission: 'Редактировать право',
        permissionCode: 'Код',
        permissionCodePlaceholder: 'напр. invoices.create',
        permissionCodeHelp:
          'Создаётся автоматически из названия — при необходимости измените. Используется в API и журналах аудита.',
        permissionCodeImmutable: 'Код нельзя изменить после создания.',
        permissionCodeRequired: 'Код обязателен.',
        permissionCodeInvalid:
          'Только маленькие буквы, цифры и символы . _ : -',
        permissionLabel: 'Название',
        permissionLabelPlaceholder: 'напр. Утверждение счетов',
        permissionLabelRequired: 'Название обязательно.',
        permissionDescription: 'Описание',
        permissionCreated: 'Право создано',
        permissionUpdated: 'Право обновлено',
        permissionDeleted: 'Право удалено',
        deletePermissionTitle: 'Удалить право?',
        deletePermissionWarning_one:
          '{{count}} роль потеряет это право. Действие необратимо.',
        deletePermissionWarning_few:
          '{{count}} роли потеряют это право. Действие необратимо.',
        deletePermissionWarning_many:
          '{{count}} ролей потеряют это право. Действие необратимо.',
        deletePermissionWarning_other:
          '{{count}} ролей потеряют это право. Действие необратимо.',
        emptyPermissionsCatalog:
          'Прав ещё нет. Добавьте первое, чтобы начать назначать ролям.'
      },
      credentials: {
        intro:
          'Создавайте API-токены, привязанные к этому приложению. Значение токена показывается ровно один раз при создании или ротации — скопируйте его сразу и храните в безопасном месте.',
        create: 'Создать учётные данные',
        createDrawerTitle: 'Новые учётные данные',
        editDrawerTitle: 'Изменить учётные данные',
        rotate: 'Ротировать',
        revoke: 'Отозвать',
        expiresAt: 'Срок действия',
        expiresAtPlaceholder: 'Без срока',
        noExpiry: 'Бессрочно',
        permissions: 'Разрешения',
        permissionsHint:
          'Разрешения, с которыми этот токен будет вызывать API приложения.',
        permissionsPlaceholder: 'Выберите разрешения',
        selectAll: 'Выбрать все',
        clear: 'Очистить',
        noPermissions: 'Нет разрешений',
        noPermissionsHint:
          'У этого токена нет разрешений; он идентифицирует интеграцию, но не имеет доступа к защищённым endpoint.',
        lastUsed: 'Последнее использование',
        neverUsed: 'Не использовался',
        revealTitle: 'Сохраните учётные данные',
        revealWarning:
          'Это единственный раз, когда вы видите этот токен. Скопируйте его сейчас и сохраните в безопасном месте.',
        revealDone: 'Сохранил',
        rotateConfirmTitle: 'Ротировать учётные данные?',
        rotateConfirmBody:
          'Будет выпущен новый токен. Текущий продолжит работать, пока вы не отзовёте его ниже.',
        revokeConfirmTitle: 'Отозвать учётные данные?',
        revokeConfirmBody:
          'Этот токен перестанет работать для всех использующих его интеграций. Отменить действие нельзя.',
        revokedReason: 'Причина: {{reason}}',
        revokedAt: 'Отозван {{at}}',
        empty: 'Реквизитов пока нет.',
        toolbar: {
          credentialsLabel: 'реквизитов'
        },
        columns: {
          name: 'Имя',
          permissions: 'Разрешения',
          expires: 'Срок действия',
          lastUsed: 'Последнее использование',
          status: 'Статус',
          actions: 'Действия'
        }
      },
      credentialDetail: {
        breadcrumb: 'Реквизиты',
        back: 'Назад к реквизитам {{app}}',
        overviewTitle: 'Обзор'
      },
      webhooks: {
        soonBadge: 'Скоро',
        disabledHint:
          'Вебхуки для приложений workspace пока недоступны. Вкладка только для предпросмотра.',
        url: 'URL вебхука',
        events: 'События (через запятую)',
        create: 'Создать вебхук',
        modalTitle: 'Создать вебхук',
        removeConfirm: 'Удалить этот вебхук?',
        columns: {
          name: 'Имя',
          url: 'URL',
          events: 'События',
          actions: 'Действия'
        }
      }
    },
    perm: {
      workspace_settings: 'Настройки workspace',
      workspace_members: 'Участники',
      workspace_roles: 'Роли',
      workspace_security: 'Безопасность',
      workspace_audit: 'Журнал аудита',
      apps_manage: 'Приложения (использование)',
      apps_roles: 'Роли приложения',
      apps_credentials: 'Учётные данные приложения'
    },
    roles: {
      sectionTitle: 'Функции/Роли',
      sectionDescription:
        'Шаблоны ролей задают права workspace и приложений для участников.',
      sectionDescriptionApi:
        'Роли организации из API. У администраторов неявный полный доступ; у остальных ролей права задаются явно.',
      sectionDescriptionManage:
        'Задайте должностные функции и роли workspace. Наборы прав для приложений настраиваются в каждом приложении; связывайте роли с функциями для ясной структуры.',
      manageHint:
        'Численность по функции — участники, у которых должность совпадает с именем функции (пока API не хранит связь). Численность по роли — по назначенным ролям участников.',
      tabs: {
        functions: 'Функции',
        roles: 'Роли'
      },
      rolesTabIntro:
        'Роли workspace назначаются участникам. Права приложений настраиваются в каждом приложении.',
      drawerClose: 'Закрыть',
      actions: {
        viewDetails: 'Подробнее'
      },
      editRoleTitle: 'Изменить роль',
      form: {
        functionLabel: 'Функция',
        functionHelp:
          'Необязательная связь с функцией на вкладке «Функции» (локально в браузере, пока API не поддерживает поле).',
        functionPlaceholder: 'Выберите функцию'
      },
      details: {
        roleTitle: 'Сведения о роли',
        membersWithRole: 'Участники с этой ролью',
        membersWithAssignment: 'Участники с такой должностью',
        noMembers: 'Нет участников.',
        moreMembers: '…и ещё {{count}}.'
      },
      columns: {
        role: 'Роль',
        description: 'Описание',
        isAdmin: 'Админ-роль',
        permissions: 'Права',
        customCodes: 'Кастомные коды',
        updated: 'Обновлено',
        actions: 'Действия',
        headcount: 'Численность',
        linkedFunction: 'Функция'
      },
      functions: {
        add: 'Добавить функцию',
        addTitle: 'Новая функция',
        editTitle: 'Изменить функцию',
        detailsTitle: 'Сведения о функции',
        intro:
          'Функции описывают типы работ (например, Продажи, Инженерия). Совпадение имени функции с должностью участника задаёт численность.',
        nameLabel: 'Название функции',
        headcountTooltip:
          'Число участников, у которых должность совпадает с именем этой функции (без учёта регистра).',
        deleteConfirm:
          'Удалить эту функцию? Связи ролей с этой функцией будут сняты.',
        columns: {
          name: 'Функция',
          description: 'Описание',
          codename: 'Код',
          updated: 'Обновлено'
        },
        messages: {
          created: 'Функция создана',
          updated: 'Функция обновлена',
          deleted: 'Функция удалена'
        },
        api: {
          createSuccess: 'Функция создана',
          updateSuccess: 'Функция обновлена',
          deleteSuccess: 'Функция удалена'
        }
      },
      addRole: 'Добавить роль',
      nameLabel: 'Имя роли',
      codenameLabel: 'Системное имя',
      codenamePlaceholder: 'Необязательно; сгенерируется из имени',
      descriptionLabel: 'Описание',
      permissionsLabel: 'Права',
      permissionsPickerLabel: 'Права',
      permissionsPickerPlaceholder: 'Поиск и выбор прав',
      customPermissionsLabel: 'Кастомные коды прав',
      customPermissionsHelp:
        'Необязательные коды для проверок в продукте (например, флаги функций). Сохраняются с ролью и отображаются в матрице ниже.',
      customPermissionDuplicate:
        'На одной роли нельзя дублировать один и тот же кастомный код.',
      customPermissionCodePlaceholder: 'напр. contacts.read, reports.export',
      customPermissionCodeRequired: 'Код права обязателен',
      customPermissionCodeInvalid:
        'Используйте строчные буквы, цифры, точки, дефисы или подчёркивания (макс. 64 символа)',
      addCustomPermission: 'Добавить код права',
      editPermissions: 'Изменить права',
      editPermissionsTitle: 'Изменить права',
      editApiPermissions: 'Изменить права',
      editApiPermissionsTitle: 'Права роли',
      deleteConfirm:
        'Удалить эту роль? Участники перейдут на роль по умолчанию.',
      adminProtected: 'Защищено',
      adminBadge: 'Админ',
      system: 'Системная',
      builtIn: 'Встроенная',
      api: {
        createSuccess: 'Роль создана',
        updateSuccess: 'Роль обновлена',
        deleteSuccess: 'Роль удалена'
      },
      rolesTableTitle: 'Роли',
      matrix: {
        sectionTitle: 'Матрица «роль → право»',
        description:
          'Права API уровня организации и кастомные коды по ролям. Админ-роли неявно включают каждую строку.',
        permission: 'Право',
        customCodeBadge: 'Кастом',
        customCodeHint: 'Не право API; проверяется в ваших приложениях.',
        adminTooltip: 'Админ-роли автоматически получают все права.',
        noRoles: 'Нет ролей для отображения.',
        noPermissions: 'Права организации не загружены.'
      }
    },
    security: {
      sectionTitle: 'Безопасность',
      sectionDescription:
        'Политика аутентификации, способы входа и корпоративный SSO / SCIM для workspace.',
      tabs: {
        policy: 'Политика',
        signIn: 'Способы входа',
        customProviders: 'Кастомные провайдеры'
      },
      apiPolicyNotice:
        'Эта форма политики использует тестовые (mock) данные. MFA, правила приглашений и настройки JIT пока не доступны в этом API. Для живой конфигурации workspace перейдите на вкладку «Способы входа».',
      saved: 'Политика безопасности сохранена',
      missingPolicy: 'Политика безопасности для workspace не найдена.',
      authMethods: 'Разрешённые способы входа',
      mfaPolicy: 'Политика MFA',
      invitePolicy: 'Политика приглашений',
      jitProvisioning: 'JIT-подготовка из SSO',
      method: {
        password: 'Пароль',
        google: 'Google',
        microsoft: 'Microsoft',
        sso: 'Корпоративный SSO'
      },
      mfa: {
        optional: 'Необязательно',
        requiredAdmins: 'Обязательно для админов',
        requiredAll: 'Обязательно для всех'
      },
      invite: {
        inviteOnly: 'Только по приглашению',
        domainRestricted: 'Ограничение по домену',
        open: 'Открытое присоединение (доверенные домены)'
      },
      policyCardTitle: 'Политика аутентификации',
      savePolicy: 'Сохранить политику'
    },
    customProviders: {
      title: 'Кастомные провайдеры идентификации',
      description:
        'Подключите этот workspace к собственному провайдеру OIDC, OAuth 2.0 или SAML 2.0. Каждый провайдер становится кнопкой входа для участников workspace.',
      addProvider: 'Добавить провайдера',
      editProvider: 'Изменить провайдера',
      empty: 'Кастомные провайдеры ещё не добавлены.',
      deleteConfirm:
        'Удалить провайдера «{{name}}»? Привязанные к нему участники потеряют этот способ входа.',
      protocols: {
        oidc: 'OpenID Connect',
        oauth2: 'OAuth 2.0',
        saml2: 'SAML 2.0'
      },
      sections: {
        connection: 'Подключение',
        claimMapping: 'Сопоставление claim-ов'
      },
      columns: {
        name: 'Название',
        slug: 'Слаг',
        protocol: 'Протокол',
        enabled: 'Включён',
        actions: 'Действия'
      },
      actions: {
        edit: 'Изменить',
        delete: 'Удалить'
      },
      fields: {
        name: 'Отображаемое имя',
        slug: 'Слаг (идентификатор)',
        logo: 'Логотип',
        logoNone: 'Без логотипа (стандартный значок)',
        logoPreset: 'Использовать пресет',
        logoPresetPick: 'Выбрать пресет',
        logoUrl: 'Произвольный URL',
        logoUrlInput: 'URL логотипа',
        logoUrlHelp:
          'Прямая ссылка на SVG, PNG или JPG (например, https://cdn.example.com/logo.svg).',
        logoPreview: 'Превью:',
        slugInvalid:
          'Слаг должен начинаться с буквы и содержать только строчные латинские буквы, цифры, дефисы или подчёркивания.',
        slugHelp:
          'Используется в callback-URL. Нельзя изменить после создания.',
        protocol: 'Протокол',
        enabled: 'Доступен для входа',
        clientId: 'Client ID',
        clientSecret: 'Client secret',
        clientSecretHelp: 'Оставьте пустым, чтобы сохранить текущий секрет.',
        scope: 'Scope',
        issuerUrl: 'Issuer URL',
        issuerUrlHelp:
          'Базовый URL OIDC-провайдера, поддерживающий /.well-known/openid-configuration.',
        authorizeUrl: 'Authorize URL',
        authorizeUrlOptional:
          'Authorize URL (опционально, определяется через issuer)',
        tokenUrl: 'Token URL',
        tokenUrlOptional: 'Token URL (опционально, определяется через issuer)',
        userinfoUrl: 'Userinfo URL',
        userinfoUrlOptional:
          'Userinfo URL (опционально, определяется через issuer)',
        jwksUrl: 'JWKS URL',
        jwksUrlOptional: 'JWKS URL (опционально, определяется через issuer)',
        samlEntityId: 'Entity ID IdP',
        samlSsoUrl: 'SSO URL (HTTP-Redirect binding)',
        samlSloUrl: 'URL единого выхода (опционально)',
        samlX509Cert: 'Подписывающий сертификат IdP (PEM)',
        samlX509CertHelp:
          'Публичный сертификат, которым IdP подписывает assertion-ы. Вставьте полный PEM-блок.',
        emailClaim: 'Claim для e-mail',
        firstNameClaim: 'Claim для имени',
        lastNameClaim: 'Claim для фамилии'
      },
      messages: {
        created: 'Провайдер создан',
        updated: 'Провайдер обновлён',
        deleted: 'Провайдер удалён'
      }
    },
    authentication: {
      sectionTitle: 'Аутентификация',
      sectionDescription:
        'Управляйте способами входа в этот workspace — методы входа, пользовательские провайдеры идентификации и политика аутентификации.',
      previewTag: 'Предпросмотр',
      activeUsersTooltip_one:
        '{{count}} активный пользователь использует этот метод',
      activeUsersTooltip_few:
        '{{count}} активных пользователя используют этот метод',
      activeUsersTooltip_many:
        '{{count}} активных пользователей используют этот метод',
      activeUsersTooltip_other:
        '{{count}} активных пользователей используют этот метод',
      tabs: {
        signIn: 'Методы входа',
        customProviders: 'Пользовательские провайдеры',
        policy: 'Политика'
      },
      summary: {
        title: 'Методы аутентификации',
        description:
          'Включайте встроенные методы ниже или добавьте свой OIDC, OAuth 2.0 или SAML 2.0 провайдер идентификации.',
        active: 'Активно',
        custom: 'Пользовательские',
        ssoUsers: 'Пользователи SSO'
      },
      providersCard: {
        title: 'Провайдеры входа',
        description:
          'Провайдеры, которые воркспейс подключает своими учётными данными. Личный вход через Google работает и без них.',
        setupGuide: 'Руководство по настройке →',
        builtInGroup: 'Встроенные методы'
      },
      providers: {
        password: 'Пароль',
        passwordSubtitle: 'Email + пароль',
        emailOtp: 'OTP по email',
        emailOtpSubtitle: 'Одноразовый код по email',
        qrLogin: 'QR-код',
        qrLoginSubtitle: 'Вход без пароля через подтверждение в приложении',
        google: 'Google',
        googleSubtitle:
          'Свой OAuth-клиент Google — вход только для вашей организации',
        entraid: 'Microsoft Entra ID',
        entraidSubtitle:
          'Своё приложение Entra ID — вход только для вашего тенанта',
        apple: 'Apple',
        appleSubtitle: 'Свои Service ID и ключ Apple',
        passkey: 'Passkey / WebAuthn',
        passkeySubtitle: 'Аппаратные ключи, Touch ID, Windows Hello',
        appleTeamId: 'Team ID',
        apiPendingLabel: 'API ожидается',
        apiPendingHint:
          'Backend-эндпоинт для этого провайдера ещё не развернут — переключатель не работает.',
        needsSetupLabel: 'Требуется настройка',
        needsSetupHint:
          'Включено, но учётные данные отсутствуют. Нажмите на шестерёнку для завершения настройки.',
        mockOnlyLabel: 'Предпросмотр',
        mockOnlyHint: 'Это поле ещё не отправляется в API.',
        setupGuide: 'Открыть руководство по настройке',
        credentialsTitle: 'Учётные данные',
        noConfigTitle: 'Работает без настройки',
        noConfigGeneric:
          'Этот провайдер не имеет настроек на уровне workspace. Включите или отключите его в списке.',
        noConfig: {
          password:
            'Вход по паролю встроен. Отключайте его только после проверки SSO-соединения.',
          passkey:
            'Passkey / WebAuthn зависит от того, что каждый пользователь зарегистрирует ключ из своего профиля — настройка администратора не требуется.',
          email_otp:
            'OTP по email отправляет одноразовый код. Backend-эндпоинт ещё разрабатывается — это предпросмотр.',
          qr_login:
            'Вход по QR позволяет участникам подтверждать вход в браузере из мобильного приложения Skalx.'
        }
      },
      actions: {
        settings: 'Настройки провайдера',
        save: 'Сохранить изменения',
        reset: 'Сбросить',
        setup: 'Открыть настройку',
        viewInfo: 'Подробнее'
      },
      additionalSettings: {
        title: 'Дополнительные настройки авторизации',
        description:
          'Настройки уровня workspace, сохраняемые как конфигурация аутентификации.',
        autoProvisionDefaultRole: 'Роль по умолчанию',
        enforceSso: {
          title: 'Принудительный SSO для всех участников',
          description:
            'Отключите вход по паролю после проверки SSO-соединения для каждого участника. Пароль остаётся доступным только для восстановления.'
        },
        selfServiceJoin: {
          title: 'Разрешить самостоятельные заявки на присоединение',
          description:
            'Пользователи с проверенным доменом могут запросить присоединение. Админы одобряют со страницы Участники.'
        },
        autoProvision: {
          title: 'Авто-провижининг пользователей через SSO',
          description:
            'При первом входе пользователя через SSO аккаунт создаётся автоматически с ролью по умолчанию.'
        }
      },
      customProviders: {
        title: 'Пользовательские провайдеры идентификации',
        description:
          'Подключите workspace к своему OIDC, OAuth 2.0 или SAML 2.0 провайдеру. Каждый провайдер становится опцией входа для участников.',
        docs: 'Документация',
        add: 'Добавить провайдера',
        addProvider: 'Добавить пользовательского провайдера',
        editProvider: 'Изменить пользовательского провайдера',
        addProviderHint: 'Подключите любой IdP OIDC, OAuth 2.0 или SAML 2.0',
        createProvider: 'Создать провайдера',
        setupGuide: 'Руководство OIDC →',
        emptyTitle: 'Пользовательских провайдеров пока нет',
        emptyDescription:
          'Добавьте Auth0, Okta, Keycloak или любой OIDC / SAML провайдер, чтобы участники входили через ваш стек.',
        searchPlaceholder: 'Поиск по названию, slug или issuer',
        noResultsTitle: 'Нет провайдеров по вашему запросу',
        noResultsDescription:
          'Ничего не найдено по запросу «{{search}}». Очистите поиск, чтобы увидеть всех провайдеров.',
        deleteConfirm:
          'Удалить провайдера "{{name}}"? Связанные участники потеряют этот способ входа.',
        lastSyncLabel: 'Последнее обновление',
        callbacksHint:
          'Скопируйте эти URL в список разрешённых redirect-ов вашего провайдера.',
        protocols: {
          oidc: 'OpenID Connect',
          oauth2: 'OAuth 2.0',
          saml2: 'SAML 2.0'
        },
        sections: {
          identity: 'Идентификация',
          connection: 'Соединение',
          attributeMapping: 'Маппинг атрибутов',
          provisioning: 'Провижининг',
          callbackUrls: 'Callback URL',
          oidcAdvanced: 'Дополнительно — переопределить OIDC discovery'
        },
        columns: {
          name: 'Имя',
          slug: 'Slug',
          protocol: 'Протокол',
          enabled: 'Активно'
        },
        actions: {
          edit: 'Изменить провайдера',
          delete: 'Удалить',
          deleteProvider: 'Удалить провайдера',
          test: 'Проверить соединение',
          rotate: 'Сменить секрет',
          audit: 'Аудит'
        },
        callbacks: {
          redirect: 'Redirect URI',
          logout: 'Logout URI',
          metadata: 'Metadata URL'
        },
        fields: {
          displayName: 'Отображаемое имя',
          slug: 'Slug (идентификатор URL)',
          slugHelp:
            'Используется в callback URL. Не может быть изменён после создания.',
          slugInvalid:
            'Slug должен начинаться с буквы и содержать только строчные буквы, цифры, дефисы или подчёркивания.',
          protocol: 'Протокол',
          enabled: 'Доступен для входа',
          logo: 'Логотип',
          logoNone: 'Без логотипа (стандартный щит)',
          logoPreset: 'Использовать пресет',
          logoPresetPick: 'Пресет логотипа',
          logoUrl: 'Свой URL',
          logoUrlInput: 'URL логотипа',
          logoUrlHelp:
            'Прямая ссылка на SVG, PNG или JPG (напр. https://cdn.example.com/logo.svg).',
          logoPreview: 'Предпросмотр:',
          clientId: 'Client ID',
          clientSecret: 'Client secret',
          clientSecretHelp: 'Оставьте пустым, чтобы сохранить текущий секрет.',
          scope: 'Scope',
          issuerUrl: 'URL issuer',
          issuerUrlHelp:
            'Базовый URL провайдера OIDC с поддержкой /.well-known/openid-configuration.',
          authorizeUrl: 'URL Authorize',
          authorizeUrlOptional:
            'URL Authorize (опционально, обнаружится из issuer)',
          tokenUrl: 'URL Token',
          tokenUrlOptional: 'URL Token (опционально, обнаружится из issuer)',
          userinfoUrl: 'URL Userinfo',
          userinfoUrlOptional:
            'URL Userinfo (опционально, обнаружится из issuer)',
          jwksUrl: 'URL JWKS',
          jwksUrlOptional: 'URL JWKS (опционально, обнаружится из issuer)',
          samlEntityId: 'ID сущности IdP',
          samlSsoUrl: 'URL SSO (HTTP-Redirect binding)',
          samlSloUrl: 'URL Single Logout (опционально)',
          samlX509Cert: 'Сертификат подписи IdP (PEM)',
          samlX509CertHelp:
            'Открытый сертификат, которым IdP подписывает assertions. Вставьте полный PEM блок.',
          emailClaim: 'Claim email',
          firstNameClaim: 'Claim имени',
          lastNameClaim: 'Claim фамилии',
          provisioningOnFirstSignIn: 'При первом входе'
        },
        provisioning: {
          jitTitle: 'Just-in-time провижининг',
          jitDescription:
            'Создавать пользователя автоматически с ролью по умолчанию.',
          approvalTitle: 'Требовать одобрение админа',
          approvalDescription:
            'Попытки входа создают запрос, который должен одобрить админ.',
          explicitTitle: 'Только заранее заведённые пользователи',
          explicitDescription:
            'Отклонять вход пользователей, которые ещё не в workspace.'
        },
        messages: {
          created: 'Пользовательский провайдер создан',
          updated: 'Пользовательский провайдер обновлён',
          deleted: 'Пользовательский провайдер удалён'
        }
      },
      policy: {
        shippingSoon: 'Политика аутентификации скоро появится.',
        shippingSoonDescription:
          'Поля ниже — предварительный просмотр того, что вы сможете настроить.',
        password: {
          title: 'Политика пароля',
          minLength: 'Минимальная длина',
          reusePrevention: 'Защита от повторов',
          maxAge: 'Максимальный возраст',
          characters_one: '{{count}} символ',
          characters_few: '{{count}} символа',
          characters_many: '{{count}} символов',
          characters_other: '{{count}} символов',
          noRestriction: 'Без ограничений',
          lastN_one: 'Последний {{count}} пароль',
          lastN_few: 'Последние {{count}} пароля',
          lastN_many: 'Последние {{count}} паролей',
          lastN_other: 'Последние {{count}} паролей',
          neverExpires: 'Никогда не истекает',
          days_one: '{{count}} день',
          days_few: '{{count}} дня',
          days_many: '{{count}} дней',
          days_other: '{{count}} дней',
          requireUpper: 'Требовать заглавные',
          requireLower: 'Требовать строчные',
          requireNumber: 'Требовать цифру',
          requireSymbol: 'Требовать символ',
          rejectLeaked: 'Отклонять скомпрометированные пароли (HIBP)'
        },
        mfa: {
          title: 'Политика MFA',
          requireMfaAdmins: 'Требовать MFA для владельцев и админов',
          requireMfaAll: 'Требовать MFA для всех участников',
          allowSmsFallback: 'Разрешить SMS как запасной метод',
          requireWebAuthnOwners: 'Требовать WebAuthn для владельцев'
        },
        session: {
          title: 'Политика сессии',
          idleTimeout: 'Таймаут бездействия',
          absoluteTimeout: 'Абсолютный таймаут',
          minutes_one: '{{count}} минута',
          minutes_few: '{{count}} минуты',
          minutes_many: '{{count}} минут',
          minutes_other: '{{count}} минут',
          days_one: '{{count}} день',
          days_few: '{{count}} дня',
          days_many: '{{count}} дней',
          days_other: '{{count}} дней'
        }
      }
    },
    ssoScim: {
      sectionTitle: 'SSO / SCIM',
      sectionDescription:
        'Корпоративный SSO и синхронизация каталога SCIM для workspace.',
      ssoTitle: 'Подключения SSO',
      scimTitle: 'Поставка SCIM',
      ssoEmpty: 'Подключений SSO пока нет.',
      scimEmpty: 'SCIM не настроен.',
      enabled: 'Включено',
      disabled: 'Выключено',
      scimProvider: 'Провайдер',
      scimStatus: 'Статус',
      scimEndpoint: 'Endpoint',
      scimToken: 'Bearer-токен (последние 4)',
      scimGroupMapping: 'Сопоставление групп и ролей',
      scimLastSync: 'Последняя синхронизация',
      columns: {
        name: 'Имя',
        provider: 'Провайдер',
        protocol: 'Протокол',
        domain: 'Домен почты',
        status: 'Статус',
        certRotated: 'Ротация сертификата',
        actions: 'Действия'
      },
      addConnection: 'Добавить SSO',
      addScimConnection: 'Добавить SCIM',
      addModalTitle: 'Добавить подключение SSO',
      providerLabel: 'Провайдер',
      protocolLabel: 'Протокол',
      domainLabel: 'Домен почты',
      createSuccess: 'Подключение SSO добавлено',
      protocol: {
        saml: 'SAML 2.0',
        oidc: 'OpenID Connect'
      },
      connectionStatus: {
        active: 'Активно',
        inactive: 'Неактивно'
      },
      actions: {
        activate: 'Включить',
        deactivate: 'Отключить',
        rotateCertificate: 'Ротировать сертификат',
        remove: 'Удалить',
        syncNow: 'Запустить синхронизацию',
        rotateToken: 'Ротировать токен',
        disconnect: 'Отключить',
        enableScim: 'Включить SCIM'
      },
      confirmRemoveSso:
        'Удалить это подключение SSO? Это может затронуть участников.',
      confirmDisconnectScim:
        'Отключить SCIM для workspace? Синхронизация каталога остановится.',
      enableScimDrawerTitle: 'Включить SCIM',
      scimEndpointUrlLabel: 'Базовый URL SCIM',
      messages: {
        ssoRemoved: 'Подключение SSO удалено',
        certificateRotated: 'Ротация сертификата записана',
        scimSynced: 'Синхронизация каталога выполнена',
        tokenRotated: 'Токен SCIM обновлён',
        scimDisconnected: 'SCIM отключён',
        scimEnabled: 'SCIM включён'
      }
    },
    domains: {
      sectionTitle: 'Домены',
      sectionDescription: 'Проверенные домены и правила вступления участников.',
      empty: 'Правил для доменов пока нет.',
      verified: {
        yes: 'Проверен',
        no: 'Ожидает'
      },
      columns: {
        domain: 'Домен',
        mode: 'Политика входа',
        verified: 'Проверка',
        actions: 'Действия'
      },
      mode: {
        allow_invite: 'Приглашение с доменной почты',
        auto_join: 'Авто-вступление',
        claim_required: 'Подтверждение / админ'
      },
      tableTitle: 'Правила доменов',
      addDomain: 'Добавить домен',
      addModalTitle: 'Добавить правило домена',
      domainLabel: 'Домен',
      modeLabel: 'Политика входа',
      createSuccess: 'Правило домена добавлено',
      verifyDomain: 'Отметить проверенным',
      deleteDomain: 'Удалить',
      confirmDelete: 'Удалить это правило домена?',
      verifiedSuccess: 'Домен отмечен как проверенный',
      deletedSuccess: 'Правило домена удалено'
    },
    auditPage: {
      sectionTitle: 'Журнал аудита',
      sectionDescription:
        'Все изменения в workspace — с поиском, экспортом, хранятся 90 дней.',
      empty: 'Событий аудита для этого workspace пока нет.',
      noMatches: 'Нет событий, соответствующих фильтрам.',
      openDetails: 'Открыть детали события {{event}}',
      actor: 'Исполнитель',
      target: 'Объект',
      searchPlaceholder: 'Поиск событий…',
      dateRangeLabel: 'Диапазон дат',
      tabs: {
        events: 'События',
        exports: 'Экспорты'
      },
      filters: {
        allActions: 'Действие',
        allSeverities: 'Уровень',
        allApplications: 'Приложение',
        allActors: 'Исполнитель',
        allActorTypes: 'Тип исполнителя',
        entityId: 'ID объекта',
        clear: 'Сбросить'
      },
      toolbar: {
        events_one: '{{count}} событие',
        events_few: '{{count}} события',
        events_many: '{{count}} событий',
        events_other: '{{count}} событий',
        refresh: 'Обновить'
      },
      actions: {
        export: 'Экспорт'
      },
      exportModal: {
        title: 'Экспорт журнала аудита',
        description:
          'Создать архив событий аудита для скачивания. Готовые архивы появятся в списке экспортов.',
        periodLabel: 'Период',
        formatLabel: 'Формат',
        formatCsv: 'CSV',
        formatXlsx: 'Excel (XLSX)',
        formatJsonl: 'JSON Lines',
        filtersLabel: 'Применяемые фильтры',
        filtersNone: 'Без фильтров — все события за выбранный период',
        filters: {
          service: 'Сервис',
          search: 'Поиск',
          action: 'Действие',
          severity: 'Уровень',
          application_id: 'Приложение',
          entity_type: 'Тип объекта',
          entity_id: 'ID объекта',
          actor_id: 'Исполнитель'
        },
        submit: 'Запросить экспорт',
        cancel: 'Отмена',
        queued: 'Экспорт запрошен — скоро появится в списке.',
        viewExports: 'Открыть список',
        failed: 'Не удалось поставить экспорт в очередь. Попробуйте ещё раз.'
      },
      exports: {
        empty: 'Экспортов пока нет — запросите его во вкладке «События».',
        total_one: '{{count}} экспорт',
        total_few: '{{count}} экспорта',
        total_many: '{{count}} экспортов',
        total_other: '{{count}} экспортов',
        refresh: 'Обновить',
        filters: {
          allStatuses: 'Статус',
          includeAppScoped: 'Включая архивы приложений'
        },
        columns: {
          period: 'Период',
          format: 'Формат',
          status: 'Статус',
          requestedBy: 'Кто запросил',
          fileSize: 'Размер',
          createdAt: 'Создан',
          actions: 'Действия'
        },
        status: {
          pending: 'Ожидает',
          processing: 'Готовится',
          ready: 'Готов',
          failed: 'Ошибка'
        },
        actions: {
          download: 'Скачать',
          delete: 'Удалить'
        },
        bulk: {
          selected_one: 'выбран {{count}}',
          selected_few: 'выбрано {{count}}',
          selected_many: 'выбрано {{count}}',
          selected_other: 'выбрано {{count}}',
          delete: 'Удалить выбранные',
          clear: 'Снять выделение'
        },
        confirmDeleteTitle: 'Удалить этот экспорт?',
        confirmDeleteContent: 'Архив будет удалён и его нельзя восстановить.',
        confirmBulkDeleteTitle: 'Удалить выбранные экспорты?',
        confirmBulkDeleteContent:
          'Будет удалено {{count}} архивов, восстановить их нельзя.',
        deleteSuccess: 'Экспорт удалён.',
        bulkDeleteSuccess: 'Выбранные экспорты удалены.',
        deleteFailed: 'Не удалось удалить экспорт. Попробуйте ещё раз.',
        downloadFailed: 'Не удалось скачать экспорт. Попробуйте ещё раз.'
      },
      columns: {
        time: 'Время',
        application: 'Приложение',
        severity: 'Уровень',
        actor: 'Исполнитель',
        action: 'Действие',
        description: 'Описание',
        target: 'Объект',
        scope: 'Область',
        ip: 'IP'
      },
      pagination: {
        range: '{{from}}–{{to}} из {{total}}'
      }
    },
    orgRoles: {
      sectionTitle: 'Роли и разрешения',
      sectionDescription:
        'Определите роли организации и доступ, который даёт каждая роль.',
      addRole: 'Добавить роль',
      createRole: 'Создать роль',
      editRole: 'Редактировать роль',
      newRole: 'Новая роль',
      save: 'Сохранить',
      saveChanges: 'Сохранить изменения',
      cancel: 'Отмена',
      searchRoles: 'Поиск ролей…',
      searchPermissions: 'Найти разрешение…',
      permissionsAll: 'Все',
      emptyRoles: {
        title: 'Пока нет ролей',
        description:
          'Создайте первую пользовательскую роль, чтобы управлять доступом к рабочему пространству.'
      },
      kpi: {
        workspaceRoles: 'Роли рабочего пространства',
        customRoles: 'свои',
        permissionsCatalog: 'Каталог разрешений',
        appScopedRoles: 'Роли уровня приложения',
        permissionsFooter: '{{count}} ресурсов'
      },
      tabs: {
        roles: 'Роли рабочего пространства',
        permissions: 'Каталог разрешений'
      },
      matrix: {
        title: 'Матрица разрешений',
        description:
          'Роли рабочего пространства объединяют разрешения. Роли владельца и админа дают всё; встроенные роли фиксированы платформой.',
        moduleColumn: 'Модуль/Ресурс',
        hint: 'Изменения применятся ко всем участникам с этой ролью.',
        reset: 'Сбросить изменения',
        adminHasFullAccess:
          'Роли администратора получают все разрешения рабочего пространства.',
        grantsEverything: 'Все разрешения',
        needsViewFirst:
          'Сначала выдайте право Просмотр в этой категории — остальные опираются на него.',
        noPermissions: 'Нет разрешений',
        permissionsInMatrixHint: 'Разрешения выдаются в матрице, а не здесь.'
      },
      columns: {
        role: 'Роль',
        type: 'Тип',
        permissions: 'Разрешения',
        actions: 'Действия'
      },
      types: {
        owner: 'Владелец',
        admin: 'Админ',
        custom: 'Своя',
        builtin: 'Встроенная',
        workspace: 'Рабочее пространство',
        app: 'Приложение'
      },
      groups: {
        builtin: 'Встроенные · рабочее пространство',
        custom: 'Свои · рабочее пространство',
        app: 'Уровень приложения'
      },
      filters: {
        all: 'Все',
        granted: 'Выданные',
        denied: 'Недоступные'
      },
      actions: {
        edit: 'Редактировать',
        duplicate: 'Дублировать',
        replaceAndDelete: 'Заменить и удалить',
        delete: 'Удалить',
        assign: 'Назначить',
        selectAll: 'Выбрать все',
        clear: 'Очистить'
      },
      form: {
        name: 'Название роли',
        namePlaceholder: 'например, Ревизор комплаенса',
        codename: 'Кодовое имя',
        codenameHelp:
          'Опциональный машинный идентификатор (например, sales_manager).',
        description: 'Описание',
        descriptionPlaceholder:
          'Доступ только на чтение к журналам аудита и событиям безопасности.',
        permissions: 'Разрешения',
        permissionsPlaceholder: 'Найдите и выберите разрешения',
        permissionsAdminTooltip:
          'Админ-роли автоматически получают все разрешения.',
        permissionsGeneral: 'Общие'
      },
      messages: {
        created: 'Роль создана',
        updated: 'Роль обновлена',
        deleted: 'Роль удалена',
        replaced: 'Участники переназначены, роль удалена',
        permissionsUpdated: 'Разрешения обновлены'
      },
      detail: {
        membersWithRole: 'Участники с этой ролью',
        noMembers: 'Пока нет участников.',
        permissions: 'Разрешения',
        ownerSubtitle: 'Роль владельца · даёт все разрешения, включая будущие',
        permissionsSummary: 'Включено {{granted}} из {{total}} разрешений',
        roleId: 'ID роли',
        builtinNotice: 'Встроенные роли нельзя редактировать.',
        duplicateToCustomize: 'Дублируйте, чтобы настроить →',
        ownerNotice:
          'Роль владельца автоматически даёт все разрешения, включая добавленные в будущем.',
        adminAppNotice:
          'Админ-роли автоматически получают все разрешения своего уровня ({{scope}}).',
        scopeWorkspace: 'рабочее пространство',
        scopeApp: 'это приложение',
        emptySelection: 'Выберите роль, чтобы увидеть её детали и разрешения.',
        permissionsGroupAll: 'Все {{group}}',
        permissionsGroupCount: '{{granted}}/{{total}}'
      },
      permission: {
        catalogTitle: 'Каталог разрешений',
        catalogDescription:
          'Все разрешения, которые платформа определяет для этого рабочего пространства. Роли объединяют их; сам каталог фиксирован.',
        categoryLabel: 'Категория',
        allCategories: 'Все категории',
        categories: {
          organization: 'Рабочее пространство',
          users: 'Участники',
          roles: 'Роли',
          groups: 'Группы',
          applications: 'Приложения',
          attachments: 'Вложения',
          audit: 'Аудит'
        },
        rolesUsing_one: '{{count}} роль',
        rolesUsing_few: '{{count}} роли',
        rolesUsing_many: '{{count}} ролей',
        rolesUsing_other: '{{count}} ролей',
        empty: 'В этом рабочем пространстве пока нет разрешений.',
        codeLabel: 'Код',
        labelLabel: 'Название',
        builtinTag: 'Встроенное',
        usedByRoles: 'Используется'
      },
      deleteConfirmTitle: 'Удалить «{{name}}»?',
      deleteConfirmDescription:
        'Роль будет удалена. Участников с этой ролью необходимо сначала перевести на другую роль.',
      archiveConfirmTitle: 'Заменить и удалить «{{name}}»?',
      archiveConfirmDescription:
        '{{count}} участников имеют эту роль. Выберите роль для замены.',
      selectRole: 'Выберите роль...',
      archiveAndReassign: 'Переназначить и удалить',
      archiveReassignWarning:
        'Все {{count}} участников будут переназначены на роль «{{role}}».'
    },
    roleDetail: {
      members: 'Участники',
      created: 'Создана',
      edit: 'Редактировать',
      membersWithRole: 'Участники с этой ролью',
      searchMembers: 'Поиск участников...',
      teamsWithRole: 'Команды с этой ролью',
      noTeams: 'Ни одна команда не выдаёт эту роль.',
      revokeTeamConfirm:
        'Отозвать роль у команды? Её участники потеряют роль, кроме тех, у кого есть персональное назначение.',
      memberColumns: {
        name: 'Имя',
        email: 'Email',
        team: 'Команда',
        source: 'Источник',
        assigned: 'Назначен'
      },
      source: {
        personal: 'Персонально',
        group: 'Группа',
        viaGroupHint: 'Роль получена через участие в группе «{{group}}».',
        viaGroupHintUnknown: 'Роль получена через участие в группе.'
      }
    },
    settings: {
      sectionTitle: 'Настройки',
      sectionDescription: 'Управление конфигурацией рабочей области',
      general: 'Общие',
      workspaceName: 'Название рабочей области',
      domain: 'Домен',
      save: 'Сохранить изменения',
      saved: 'Настройки успешно сохранены',
      savedFields: 'Сохраняемые поля: имя, домен, логотип',
      auditChanges: 'История изменений',
      auditChangesPreview: 'История изменений ещё не подключена.',
      changeDomain: 'Сменить домен',
      domainLockedHint:
        'Домен workspace заблокирован. Нажмите "Сменить домен" для разблокировки с подтверждением.',
      domainUnlockedNotice:
        'Редактирование домена разблокировано. Изменения применятся при сохранении и сломают существующие URL входа.',
      domainConfirmTitle: 'Сменить домен workspace?',
      domainConfirmDescription:
        'Введите текущий домен, чтобы разблокировать редактирование для "{{name}}".',
      domainConfirmWarning:
        'Смена домена сломает URL-ы входа, magic links и любые внешние интеграции. Предупредите участников перед сохранением.',
      domainConfirmButton: 'Разблокировать редактирование',
      descriptionLabel: 'Описание',
      descriptionHelp:
        'Опционально. Отображается в переключателе workspace и на публичной странице входа.',
      descriptionPlaceholder: 'Краткое описание этой рабочей области',
      languages: {
        default: 'Язык по умолчанию',
        defaultHelp:
          'Новые участники и пользователи без сохранённых настроек начинают с этого языка.',
        enabled: 'Доступные языки',
        enabledHelp:
          'Только эти языки предлагаются участникам в настройках профиля.',
        enabledRequired: 'Включите хотя бы один язык.',
        defaultMustBeEnabled:
          'Язык по умолчанию должен быть одним из доступных языков.',
        placeholder: 'Выберите языки'
      },
      branding: {
        title: 'Брендинг',
        scope: 'Применяется к страницам входа и письмам',
        recommended: 'Рекомендуемые',
        primaryColor: 'Основной цвет',
        signInBackground: 'Фон страницы входа',
        signInBackgroundHint:
          'PNG или JPG, до 2 МБ. Изображение заполняет панель входа и может быть обрезано.',
        bgSolid: 'Сплошной',
        bgGradient: 'Градиент',
        bgImage: 'Изображение',
        dragDrop: 'Перетащите файл или нажмите, чтобы загрузить',
        fileTypes: 'Любое изображение, до 5 МБ · SVG до {{svgSize}} МБ',
        fileTooLarge: 'Изображение должно быть меньше 5 МБ',
        pickerHint:
          'Изображение или градиент · заполняет панель входа и может быть обрезан.',
        configure: 'Настроить',
        apply: 'Применить',
        upload: 'Загрузить',
        change: 'Изменить',
        remove: 'Удалить',
        emailFromName: 'Имя отправителя email',
        poweredByTitle: 'Показывать бейдж "Powered by Skalx"',
        poweredByDescription:
          'Виден на страницах входа. Доступно на Business и выше; скрыто на Enterprise.'
      },
      danger: {
        deleteTitle: 'Удалить этот workspace',
        deleteDescription: 'Удалить навсегда этот workspace и все его данные.',
        deleteWarning: 'Это действие нельзя отменить.',
        deleteWarningBlock:
          'Все пользователи, роли, приложения, события аудита и API-ключи будут удалены навсегда.',
        deleteButton: 'Удалить workspace',
        deleteConfirmTitle: 'Удалить workspace',
        deleteConfirmDescription:
          'Введите имя workspace "{{name}}", чтобы подтвердить удаление.',
        transferTitle: 'Передать владение',
        transferDescription:
          'Передайте этот workspace другому участнику. Вы останетесь администратором.',
        transferButton: 'Передать владение',
        transferMemberLabel: 'Новый владелец',
        transferMemberPlaceholder: 'Выберите участника',
        transferConfirmDescription:
          'Участник получит полный контроль над рабочим пространством, включая биллинг и удаление. Вы сохраните доступ администратора, но не сможете отменить это самостоятельно.',
        transferSuccess: '{{name}} теперь владелец рабочего пространства',
        acting: 'Действие над:'
      },
      footer: {
        created: 'Создан {{date}}'
      },
      dangerZone: 'Опасная зона',
      deleteSuccess: 'Рабочая область успешно удалена',
      typeToConfirm: 'Введите «{{name}}» для подтверждения',
      demoDataSection: 'Демо-данные',
      demoDataDescription: 'Управление демо-данными в этой рабочей области',
      recreateDemoDataTitle: 'Пересоздать демо-данные',
      recreateDemoDataDescription:
        'Сгенерировать демо-данные по выбранному отраслевому preset. Существующие записи могут быть перезаписаны.',
      recreateDemoData: 'Пересоздать',
      recreateDemoDataConfirmTitle: 'Пересоздать демо-данные',
      recreateDemoDataConfirmDescription:
        'Выберите, какие демо-данные нужно создать для этого workspace.',
      clearDemoDataTitle: 'Очистить демо-данные',
      clearDemoDataDescription:
        'Удалить демо-записи во всех подключённых сервисах (CRM, HRM и т.д.). Структура рабочей области, участники и настройки сохранятся.',
      clearDemoData: 'Очистить',
      clearDemoDataConfirmTitle: 'Очистить демо-данные?',
      clearDemoDataConfirmDescription:
        'Демо-записи (кандидаты, сделки, контакты и другие примеры) будут безвозвратно удалены из каждого подключённого сервиса.',
      clearDemoDataWarning: 'Демо-записи будут безвозвратно удалены',
      demoDataBuildStarted: 'Сборка демо-данных запущена',
      demoDataNothingToCreate:
        'Для этого типа демо-данных в этой рабочей области нечего создавать',
      demoDataNothingToClear:
        'В этой рабочей области нет демо-данных для очистки',
      demoDataIndustryLabel: 'Тип демо-данных',
      demoDataIndustryRequired: 'Выберите тип демо-данных',
      demoDataInstallMissingAppsLabel:
        'Сначала добавить недостающие приложения',
      demoDataInstallMissingAppsHint:
        'Включите этот параметр, если для выбранных демо-данных нужны приложения, которых ещё нет в workspace. Иначе демо-данные для отсутствующих приложений будут пропущены.'
    }
  },
  workspaces: {
    clearSearch: 'Очистить поиск',
    empty: 'Вы пока не состоите ни в одном рабочем пространстве.',
    emptyFiltered: 'По вашему запросу ничего не найдено.',
    externalAccess: 'Откроется в рабочем пространстве',
    member: 'участник',
    members: 'участники',
    membersCount_one: '{{count}} участник',
    membersCount_few: '{{count}} участника',
    membersCount_many: '{{count}} участников',
    membersCount_other: '{{count}} участников',
    pickerDescription: 'Выберите рабочее пространство или создайте новое.',
    searchPlaceholder: 'Поиск по названию или домену',
    onboarding: {
      documentTitle: 'Настройка рабочего пространства',
      creating: 'Создаём пространство…',
      createWorkspace: 'Создать пространство',
      backToWorkspace: 'Назад в пространство',
      steps: {
        details: 'Детали',
        template: 'Шаблон',
        attribution: 'Как узнали',
        invite: 'Участники',
        done: 'Готово'
      },
      details: {
        title: 'Настройте рабочее пространство',
        iconLabel: 'Иконка пространства',
        iconUpload: 'Загрузить',
        iconChange: 'Заменить',
        addressShort: 'Минимум {{min}}',
        iconPreview: 'Посмотреть изображение',
        iconRemove: 'Удалить изображение',
        iconHint:
          'PNG или JPG до {{max}}×{{max}} px, либо SVG. Лучше квадратные.',
        iconError: {
          format: 'Поддерживаются только PNG, JPG и SVG.',
          dimensions:
            'Изображение больше {{max}}×{{max}} px. Уменьшите его и попробуйте снова.',
          unreadable: 'Не удалось прочитать файл как изображение.'
        },
        nameLabel: 'Название компании',
        namePlaceholder: 'Введите название компании…',
        addressLabel: 'Адрес компании',
        addressPlaceholder: 'ваша-компания',
        addressFree: 'Свободен',
        addressTaken: 'Занят',
        sizeLabel: 'Размер компании'
      },
      join: {
        title: 'Ваша компания уже работает в Skalx',
        subtitle:
          'Ваш почтовый домен принадлежит уже существующему пространству. Попроситесь в него, вместо того чтобы создавать второе рядом.',
        existingWorkspace: 'Существующее пространство',
        request: 'Запросить вход',
        requested: 'Запрос отправлен',
        createInstead: 'Всё равно создать отдельное пространство',
        pendingTitle: 'Ждём администратора',
        pendingBody:
          'Администратор пространства уже получил уведомление. Как только он примет решение, вам придёт письмо.',
        rejectedTitle: 'Отклонён'
      },
      companySize: {
        '1-10': '1–10',
        '11-50': '10+',
        '51-200': '50+',
        '201-1000': '200+'
      },
      template: {
        title: 'Хотите добавить демо-данные для знакомства с платформой?',
        subtitle:
          'Выберите свою отрасль, чтобы увидеть подходящие примеры, или вариант «Общий».',
        industryEyebrow: 'Отрасль',
        priorityEyebrow: 'Главный приоритет',
        clean: 'Чистое пространство'
      },
      priority: {
        deal_pipeline: 'Воронка сделок',
        stop_losing_deals: 'Не терять сделки',
        automate_routine: 'Автоматизация рутины',
        forecast_revenue: 'Прогноз выручки',
        customer_support: 'Быстрые ответы',
        off_spreadsheets: 'Уйти от таблиц',
        other: 'Другое'
      },
      attribution: {
        title: 'Как вы о нас узнали?',
        options: {
          google: 'Google',
          youtube: 'YouTube',
          linkedin: 'LinkedIn',
          reviews: 'Сайты отзывов',
          referral: 'По рекомендации',
          ai_assistant: 'ИИ-ассистент',
          event: 'Мероприятие',
          press: 'Пресса',
          other: 'Другое'
        }
      },
      invite: {
        title: 'Пригласите команду',
        emailPlaceholder: 'colleague@company.com',
        addAnother: 'Добавить ещё',
        removeRow: 'Удалить строку',
        skip: 'Пропустить',
        send: 'Отправить приглашения',
        roles: {
          member: 'Участник',
          admin: 'Администратор',
          viewer: 'Наблюдатель — пока недоступно'
        }
      },
      errors: {
        nameRequired: 'Укажите название пространства.',
        handleTooShort: 'Адрес компании должен быть не короче 3 символов.',
        sizeRequired: 'Выберите размер компании.',
        industryRequired:
          'Выберите отрасль или чистое пространство — от этого зависит, что загрузится дальше.',
        priorityRequired: 'Выберите главный приоритет.',
        authRequired: 'Оставьте включённым хотя бы один способ входа.',
        googleClientIdRequired:
          'Для Google SSO нужен client ID, иначе через него нельзя будет войти.',
        inviteInvalid: 'Один из адресов указан неверно.'
      },
      done: {
        titleWorking: 'Готовим пространство «{{name}}»',
        title: 'Пространство «{{name}}» готово',
        open: 'Открыть пространство',
        setupRunning: 'Настраиваем окружение (загружаем демо-данные)',
        setupFinished: 'Окружение готово',
        setupView: 'Подробнее',
        copyLink: 'Скопировать ссылку',
        linkCopied: 'Ссылка скопирована',
        copyFailed: 'Не удалось скопировать ссылку.',
        profileFailed:
          'Пространство создано, но ваши ответы сохранить не удалось, поэтому по ним ничего не настроено. Демо-данные можно собрать в настройках пространства.',
        invitesFailed: 'Часть приглашений не удалось отправить.',
        photoFailed:
          'Картинку пространства не удалось прикрепить. Загрузите её ещё раз в настройках пространства.',
        authFailed:
          'Способы входа применены не полностью. Завершите настройку в разделе «Аутентификация».',
        build: {
          members: 'Участники',
          steps: 'Что настраивается',
          activity: 'Последние действия',
          starting: 'Ставим в очередь',
          ready: 'Готово — можно открывать',
          failed: 'Некоторые шаги не завершились',
          preparing: 'Подготавливаем пространство',
          writing: 'пишется…',
          status: {
            queued: 'в очереди',
            running: 'идёт',
            done: 'готово',
            failed: 'ошибка',
            skipped: 'пропущены'
          },
          stepNames: {
            roles: 'Роли и права',
            signIn: 'Способы входа',
            apps: 'Приложения',
            members: 'Участники и доступ',
            demoData: 'Демо-данные'
          },
          industry: 'Отрасль',
          priority: 'Главная цель',
          demoSkipped: 'Демо-данные пропущены — пространство пустое',
          byYourChoice: 'по вашему выбору',
          emptyTitle: 'Пространство пустое — начните с первой записи',
          emptyBody:
            'Импортируйте свои данные или добавьте сделку вручную · демо-данные можно собрать позже',
          emptyAction: 'Импортировать'
        },
        checks: {
          created: 'Пространство {{name}} создано',
          owner: 'Вы владелец этого пространства',
          authMethods: 'Активных способов входа: {{count}}',
          template:
            'Приложения включены, данные собраны по шаблону «{{preset}}»',
          cleanWorkspace: 'Чистое пространство — демо-данные не загружались',
          invites: 'Отправлено приглашений: {{count}}',
          noInvites: 'Приглашения пока не отправлены'
        },
        cards: {
          steps: 'шагов: {{count}}',
          crm: {
            title: 'Настроить CRM',
            badge: 'Рекомендуем',
            body: 'Перенесите реальную воронку и подключите каналы, которыми уже пользуются клиенты.',
            items: {
              import: 'Импортировать данные',
              pipeline: 'Настроить воронку сделок',
              messengers: 'Подключить мессенджеры',
              email: 'Подключить почту и календарь'
            }
          },
          workspace: {
            title: 'Настроить пространство',
            body: 'Пригласите команду, решите кто что может, включите SSO и MFA.',
            items: {
              invite: 'Пригласить команду',
              roles: 'Роли и права',
              auth: 'Аутентификация и безопасность',
              settings: 'Настройки пространства'
            }
          }
        }
      },
      preview: {
        activity: 'Последние действия',
        nav: {
          workspace: 'Пространство',
          home: 'Главная',
          overview: 'Обзор',
          identity: 'Идентификация',
          users: 'Пользователи',
          organization: 'Организация',
          roles: 'Роли',
          authentication: 'Аутентификация',
          applications: 'Приложения',
          apps: 'Приложения',
          agents: 'Агенты',
          compliance: 'Комплаенс',
          audit: 'Журнал аудита',
          graph: 'Граф компании',
          settings: 'Настройки',
          workspaceSettings: 'Настройки пространства'
        },
        meta: {
          primaryDomain: 'Основной домен',
          created: 'Создано',
          today: 'Сегодня',
          yourRole: 'Ваша роль',
          owner: 'владелец'
        },
        stats: {
          title: 'Статистика пространства',
          members: 'Участники',
          apps: 'Приложения',
          roles: 'Роли',
          authMethods: 'Способы входа'
        },
        greeting: {
          morning: 'Доброе утро, {{name}}.',
          afternoon: 'Добрый день, {{name}}.',
          evening: 'Добрый вечер, {{name}}.'
        }
      },
      spotlight: {
        name: {
          label: 'Название компании',
          why: 'заголовок, который видят все'
        },
        logo: {
          label: 'Иконка пространства',
          why: 'плитка в боковом меню и в списке приложений'
        },
        handle: {
          label: 'Адрес компании',
          why: 'адрес, по которому входит команда'
        },
        domain: {
          label: 'Основной домен',
          why: 'по нему пространство узнают везде'
        },
        template: {
          label: 'Приложения',
          why: 'отрасль решает, что попадёт в демо-данные'
        },
        security: {
          label: 'Способы входа',
          why: 'потом меняются в «Аутентификации»'
        },
        members: { label: 'Участники', why: 'приглашённые появятся здесь' },
        role: { label: 'Ваша роль', why: 'владелец — полный доступ' }
      }
    },
    pageTitle: 'Рабочие пространства',
    backToList: 'Назад к списку',
    accessDenied: {
      noAccess: {
        title: 'Не тот аккаунт',
        description:
          'У аккаунта, под которым вы вошли, нет доступа к этому workspace. Войдите под другим аккаунтом, чтобы продолжить.',
        switchAccount: 'Войти под другим аккаунтом',
        backToWorkspaces: 'Перейти к своим workspace'
      },
      insufficientRole: {
        title: 'Нет доступа к этому разделу',
        description:
          'У вас нет права, которое требует этот раздел. Попросите администратора рабочего пространства выдать его.',
        goToSection: 'Перейти в «{{section}}»'
      }
    },
    create: {
      title: 'Создать пространство',
      description:
        'Укажите имя, домен и при необходимости пресет демо-данных. Тот же сценарий, что при добавлении организации в панели.',
      submit: 'Создать пространство',
      backToDetails: 'Назад к деталям',
      auth: {
        applyFailed:
          'Workspace создан, но методы авторизации не удалось полностью применить. Завершите настройку в Workspace Settings.'
      },
      demoDataFailed:
        'Workspace создан, но демо-данные загрузить не удалось. Workspace-ом можно пользоваться.',
      submitFailedSwitchedStep:
        'Не удалось создать workspace. Проверьте поле, выделенное на предыдущем шаге.',
      steps: {
        details: 'Детали workspace',
        authorization: 'Авторизация'
      },
      template: {
        label: 'Шаблон workspace',
        withBuiltIn: 'Workspace со встроенными приложениями и демо-настройкой',
        clean: 'Чистый workspace (без встроенных приложений)',
        builtInPreset: 'Пресет встроенных приложений'
      },
      authorization: {
        methodsLabel: 'Методы авторизации',
        methodsHint:
          'Включите хотя бы один способ входа для этого рабочего пространства.',
        customTitle: 'Пользовательские провайдеры авторизации',
        customEmpty:
          'Пользовательские провайдеры ещё не добавлены. Добавьте их, если этому workspace нужна отдельная enterprise-настройка идентификации.',
        atLeastOneMethod:
          'Для этого workspace должен оставаться включён хотя бы один способ входа.',
        password: 'Логин + пароль'
      },
      invite: {
        stepTitle: 'Пригласить участников',
        title: 'Пригласите свою команду',
        description:
          'Добавьте участников для начала работы. Пригласить можно и позже.',
        byEmail: 'Пригласить по email',
        emailPlaceholder: 'Введите адрес электронной почты',
        selectRole: 'Выберите роль',
        defaultRole: 'Роль по умолчанию',
        chipPlaceholder: 'Введите email…',
        chipPlaceholderMore: 'Добавить ещё email…',
        chipHint:
          'Нажмите Enter, запятую или Tab чтобы добавить. Вставьте список — добавятся все сразу.',
        invalidEmails: 'Неверные адреса пропущены: {{emails}}',
        add: 'Добавить',
        pending: 'Ожидающие приглашения ({{count}})',
        orgRole: {
          admin: 'Администратор',
          employee: 'Сотрудник'
        },
        appRoles: 'Роли по приложениям',
        appRolesHint:
          'Назначьте роль для каждого приложения, которое будет использовать участник.',
        noApplications: 'В этом воркспейсе пока нет приложений.',
        skipForNow: 'Пропустить',
        sendAndFinish: 'Отправить приглашения и завершить',
        sent: 'Отправлено приглашений: {{count}}',
        sendFailed:
          'Воркспейс создан, но часть приглашений отправить не удалось.'
      }
    }
  },
  workspaceSwitcher: {
    placeholder: 'Сменить пространство',
    ariaLabel: 'Активное пространство'
  },
  workspaceAuth: {
    personalMethodsTitle: 'Личные методы входа в этом workspace',
    personalMethodsDescription:
      'Привяжите или отвяжите личные методы входа для workspace "{{workspace}}".'
  },
  account: {
    settings: {
      pageTitle: 'Настройки аккаунта',
      pageSubtitle:
        'Управляйте профилем, способами входа и настройками. Создавайте пространства или присоединяйтесь к ним в разделе «Рабочие пространства».',
      navAriaLabel: 'Разделы настроек аккаунта'
    },
    menu: {
      basic: 'Основной профиль',
      authentication: 'Аутентификация',
      audit: 'Аудит',
      security: 'Безопасность',
      connectedAccounts: 'Подключённые аккаунты',
      notifications: 'Уведомления',
      sessions: 'Сессии и устройства'
    },
    section: {
      personal: 'Основной профиль',
      personalDescription:
        'Просмотр и обновление контактных данных и личной информации.',
      authentication: 'Аутентификация',
      authenticationDescription:
        'Управление подключёнными методами входа и политиками безопасности.',
      audit: 'Аудит',
      auditDescription:
        'Просмотр недавней активности и событий безопасности вашего аккаунта.',
      security: 'Безопасность',
      notifications: 'Уведомления',
      notificationsDescription:
        'Управление уведомлениями и просмотр недавней активности.',
      connectedAccounts: 'Подключённые аккаунты',
      sessions: 'Сессии и устройства',
      sessionsDescription:
        'Просмотр активных сессий на ваших устройствах и отзыв доступа при необходимости.'
    },
    authentication: {
      mfa: {
        title: 'Многофакторная аутентификация',
        description:
          'Требует дополнительный шаг проверки при входе, чтобы лучше защитить аккаунт.',
        toggle: 'Включить MFA',
        regenerateBackupCodes: 'Перегенерировать резервные коды',
        downloadBackupCodes: 'Скачать резервные коды'
      },
      providers: {
        password: 'Пароль',
        google: 'Google',
        apple: 'Apple'
      },
      connectedAccounts: {
        title: 'Подключённые методы входа',
        disconnect: 'Отключить',
        required: 'Обязательно',
        link: 'Подключить',
        linkProvider: 'Подключить {{provider}}',
        setPassword: 'Установить пароль',
        notLinked: 'Не привязан'
      },
      setPassword: {
        title: 'Установить пароль',
        description: 'Создайте пароль, чтобы также входить по email и паролю.',
        newPassword: 'Новый пароль',
        confirmPassword: 'Подтвердите пароль',
        submit: 'Установить пароль',
        passwordRequired: 'Пароль обязателен',
        confirmRequired: 'Подтвердите пароль',
        passwordsMustMatch: 'Пароли не совпадают'
      },
      security: {
        title: 'Политика входа',
        allowPassword: 'Разрешить вход по паролю',
        allowSocial: 'Разрешить социальный вход',
        refreshTokenLifetimeDays: 'Срок жизни refresh-токена (дни)',
        trustedDeviceDays: 'Срок доверенного устройства (дни)'
      }
    },
    messages: {
      settingsSaved: 'Настройки безопасности обновлены',
      passwordSet: 'Пароль успешно установлен',
      providerLinked: 'Провайдер успешно подключён',
      providerUnlinked: 'Провайдер успешно отключён',
      outlookConnected: 'Outlook успешно подключён',
      outlookDisconnected: 'Outlook успешно отключён',
      gmailConnected: 'Gmail успешно подключён',
      gmailDisconnected: 'Gmail успешно отключён',
      sessionRevoked: 'Сессия отозвана',
      sessionsRevoked: 'Все остальные сессии отозваны',
      passkeyAdded: 'Passkey зарегистрирован',
      passkeyRemoved: 'Passkey удалён',
      passkeyAborted: 'Регистрация passkey отменена',
      passkeyAlreadyRegistered:
        'Это устройство уже зарегистрировано как passkey',
      recoveryRegenerated: 'Созданы новые коды восстановления',
      trustRevoked: 'Доверие к устройству отозвано'
    },
    securityCenter: {
      pageDescription:
        'Усильте защиту аккаунта: passkeys, резервные коды и доверенные устройства. Смена пароля относится к входу по email.',
      policyHint:
        'Доверенные устройства остаются распознанными {{days}} дней (также в разделе «Аутентификация» → «Политика входа», поле срока доверенного устройства).',
      passkeys: {
        title: 'Passkeys',
        description:
          'Passkeys позволяют входить без пароля с помощью биометрии или аппаратного ключа.',
        add: 'Добавить passkey',
        addTitle: 'Зарегистрировать passkey',
        nameLabel: 'Понятное имя',
        namePlaceholder: 'например MacBook Touch ID',
        delete: 'Удалить',
        deleteConfirm:
          'Удалить этот passkey? Вход с его помощью будет невозможен.',
        empty: 'Passkeys пока нет. Добавьте для более безопасного входа.',
        columns: {
          name: 'Имя',
          credential: 'Учётные данные',
          platform: 'Платформа',
          added: 'Добавлен',
          lastUsed: 'Последнее использование',
          actions: 'Действия'
        },
        platform: {
          web: 'Веб',
          mobile: 'Мобильное'
        }
      },
      recovery: {
        title: 'Коды восстановления',
        description:
          'Если потеряете доступ к MFA, используйте одноразовый код. Храните коды в надёжном месте; каждый действует один раз.',
        remaining: 'Осталось кодов: {{count}}',
        none: 'Коды восстановления ещё не созданы.',
        mfaDisabled:
          'Сначала включите двухфакторную аутентификацию, чтобы использовать коды восстановления.',
        regenerate: 'Создать новые коды',
        regenerateWarning:
          'Все текущие коды сразу перестанут действовать. Сохраните новые коды до закрытия окна.',
        modalTitle: 'Сохраните коды восстановления',
        modalDescription:
          'Эти коды больше не будут показаны. Скопируйте в менеджер паролей или распечатайте.',
        copy: 'Копировать все',
        download: 'Скачать',
        copied: 'Скопировано в буфер',
        done: 'Готово'
      },
      trustedDevices: {
        title: 'Доверенные устройства',
        description:
          'Отмеченные как доверенные устройства могут реже запрашивать MFA до истечения срока. Это отдельно от активных сессий.',
        columns: {
          device: 'Устройство',
          trustedAt: 'Доверие с',
          lastUsed: 'Последнее использование',
          actions: 'Действия'
        },
        revoke: 'Отозвать доверие',
        revokeConfirm:
          'При следующем входе устройству потребуется полная проверка. Продолжить?',
        unknownDevice: 'Неизвестное устройство',
        empty: 'Доверенных устройств нет.'
      },
      password: {
        title: 'Пароль',
        description:
          'Обновите пароль для входа по email. Из соображений безопасности мы подтверждаем запрос, прежде чем вы зададите новый пароль.',
        changeDescription: 'Введите текущий пароль и выберите новый.',
        currentPassword: 'Текущий пароль',
        newPassword: 'Новый пароль',
        confirmPassword: 'Подтвердите новый пароль',
        changeButton: 'Сменить пароль',
        currentPasswordRequired: 'Текущий пароль обязателен',
        passwordRequired: 'Пароль обязателен',
        confirmRequired: 'Подтвердите пароль',
        passwordsMustMatch: 'Пароли не совпадают',
        passwordChanged: 'Пароль успешно изменён',
        forgotPassword: 'Забыли пароль?',
        requestHint:
          'Мы отправим защищённую ссылку на почту. Может потребоваться подтверждение MFA.',
        requestButton: 'Отправить ссылку для сброса на email',
        requestSent:
          'Проверьте почту: в письме будет ссылка для завершения смены пароля.',
        noPasswordMethod:
          'У аккаунта нет пароля Skalx (например, вход только через соцсеть или SSO). Управляйте доступом у провайдера или добавьте email/пароль в разделе «Аутентификация».'
      }
    },
    avatar: {
      change: 'Сменить аватар',
      upload_title: 'Загрузить аватар',
      upload_description: 'Перетащите файлы сюда',
      upload_select: 'выберите',
      upload_hint: 'Поддерживается загрузка одного файла',
      save: 'Сохранить',
      delete: 'Удалить',
      only_images: 'Разрешены только файлы изображений',
      upload_success: 'Аватар успешно обновлён',
      delete_success: 'Аватар успешно удалён',
      card_title: 'Аватар',
      card_description: 'Загрузите фото профиля для вашего аккаунта.',
      zoom: 'Масштаб',
      rotate: 'Поворот',
      svg_no_crop: 'Векторные файлы загружаются как есть, без обрезки.'
    },
    notifications: {
      description:
        'Управляйте событиями аккаунта, о которых вы получаете уведомления.',
      activityTitle: 'Недавняя активность аккаунта',
      bell: {
        title: 'Уведомления',
        markAllRead: 'Отметить все как прочитанные',
        markedAllRead: 'Все уведомления отмечены как прочитанные',
        empty: 'Уведомлений пока нет'
      },
      preferences: {
        title: 'Предпочтения',
        categoryColumn: 'Категория',
        saveSuccess: 'Предпочтения сохранены',
        rows: {
          roleChanged: 'Изменение роли',
          roleReplaced: 'Замена роли',
          securityNotification: 'Оповещения безопасности',
          workspaceInvite: 'Приглашения в workspace',
          supportReply: 'Ответы поддержки',
          auditExport: 'Экспорт audit-логов',
          crmActivity: 'Активность в CRM',
          hrmActivity: 'Активность в HRM'
        },
        channels: {
          email: 'Email',
          push: 'Push',
          internal: 'В приложении'
        }
      }
    },
    audit: {
      description:
        'Просматривайте важные изменения на уровне аккаунта: подключённые провайдеры, обновления безопасности и действия с сессиями.',
      empty: 'Событий аудита пока нет.',
      noMatches: 'Нет событий, соответствующих текущим фильтрам.',
      actor: 'Кто',
      target: 'Объект',
      searchPlaceholder: 'Поиск событий',
      dateRangeLabel: 'Диапазон дат',
      filters: {
        allApplications: 'Приложение',
        allEventTypes: 'Тип события',
        allSeverities: 'Уровень',
        clear: 'Сбросить',
        startDate: 'Дата начала',
        endDate: 'Дата окончания'
      },
      toolbar: {
        events_one: '{{count}} событие',
        events_few: '{{count}} события',
        events_many: '{{count}} событий',
        events_other: '{{count}} событий',
        refresh: 'Обновить'
      },
      columns: {
        time: 'Время',
        event: 'Событие',
        application: 'Приложение',
        description: 'Описание',
        severity: 'Уровень',
        ip: 'IP'
      }
    },
    sessions: {
      description:
        'Просматривайте активные устройства и отзывайте сессии, которым больше не доверяете.',
      columns: {
        device: 'Устройство',
        workspace: 'Воркспейс',
        location: 'Локация',
        lastActive: 'Последняя активность',
        status: 'Статус',
        actions: 'Действия'
      },
      noWorkspace: 'Account',
      current: 'Текущая',
      currentHint:
        'Это ваша текущая сессия. Выйдите через меню в шапке страницы.',
      active: 'Активна',
      revoked: 'Отозвана',
      revoke: 'Отозвать',
      revokeConfirm:
        'Отозвать эту сессию? Устройство будет немедленно выведено из системы.',
      revokeCurrentConfirm:
        'Отозвать текущую сессию? Вы будете выведены из системы на этом устройстве.',
      revokeOidcConfirm:
        'Отозвать сессию для {{name}}? Потребуется заново войти из этого приложения.',
      revokeAllOther: 'Отозвать все остальные сессии',
      revokeAllOtherConfirm:
        'Отозвать все остальные сессии? Все другие устройства будут выведены из системы.',
      empty: 'Нет активных сессий',
      kind: {
        oidc: 'Стороннее приложение'
      },
      authMethod: {
        password: 'Пароль',
        google: 'Google',
        entraid: 'Microsoft',
        apple: 'Apple',
        email_otp: 'Код из email',
        passkey: 'Passkey',
        qr_login: 'QR-код'
      },
      messages: {
        revoked: 'Сессия отозвана',
        revokedAll: 'Все остальные сессии отозваны'
      }
    }
  },
  edit: 'Редактировать',
  personal_details: 'Личные данные',
  personal_details_description:
    'Ваша личная информация для целей выставления счета',
  phone: 'Телефон',
  address_information: 'Адресные данные',
  address_information_description: 'Детали вашего адреса для выставления счета',
  address: 'Адрес',
  country_state: 'Страна / Штат',
  town_city: 'Город',
  postal_code: 'Почтовый индекс',
  data_save_success: 'Данные успешно сохранены',
  save: 'Сохранить',
  please_input: 'Пожалуйста, заполните поле',
  cancel: 'Отмена',
  soon: 'Скоро',
  invalid_email: 'Неверный email',
  please_select_organization: 'Пожалуйста, выберите организацию',
  organizations: {
    header: 'Организации',
    users: 'пользователей'
  },
  created_on: 'Создано',
  roles: {
    admin: 'Администратор',
    employee: 'Сотрудник',
    owner: 'Владелец'
  },
  go_to_management_dashboard: 'Перейти к панели управления',
  no_results: 'Нет результатов',
  for_the: 'для',
  delete: 'Удалить',
  total: 'Всего',
  user: 'Пользователь',
  last_activity: 'Последняя активность',
  job_title: 'Должность',
  role: 'Роль',
  teams: 'Команды',
  all: 'Все',
  offline: 'Не в сети',
  online: 'В сети',
  search: 'Поиск',
  filters: 'Фильтры',
  more_filters: 'Больше фильтров',
  reset: 'Сбросить',
  apply: 'Применить',
  actions: 'Действия',
  filtering_by: 'Применённые фильтры',
  clear_all: 'Очистить все',
  entity_selected: 'Выбрано: {{count}} {{entity}}',
  count_selected: 'Выбрано: {{count}}',
  deselect: 'Снять выделение',
  clear_selection: 'Очистить выбор',
  more_actions: 'Ещё',
  view: 'Просмотр',
  contact_information: 'Контактная информация',
  contact_information_description: 'Сведения о контакте человека',
  personal_information: 'Личная информация',
  personal_information_description: 'Личные данные человека',
  role_information: 'Информация о роли',
  role_information_description: 'Детали о роли человека',
  position: 'Должность',
  about_me: 'О себе',
  linkedin_url: 'LinkedIn',
  role_information_updated: 'Информация о роли обновлена',
  profile: 'Профиль',
  change_password: 'Сменить пароль',
  new_password: 'Новый пароль',
  password_change_success: 'Пароль успешно изменён',
  current_password: 'Текущий пароль',
  information_updated_success: 'Информация успешно обновлена',
  enter_your_initial_email: 'Введите ваш исходный email',
  add_organization: 'Создать пространство',
  name: 'Название',
  domain_name: 'Доменное имя',
  input_placeholder: 'Введите здесь...',
  organization_add_success: 'Организация успешно добавлена',
  deleted_success: 'Успешно удалено',
  delete_organization_confirmation:
    'Вы уверены, что хотите удалить организацию?',
  confirm: 'Подтвердить',
  settings: 'Настройки',
  column_settings_title: 'Столбцы',
  column_settings_configure: 'Настроить столбцы',
  column_settings_customize: 'Настроить столбцы',
  table_settings: 'Настройки таблицы',
  column_settings_reset: 'Сброс',
  column_settings_search: 'Найти поле',
  column_settings_shown: 'Показаны',
  column_settings_hidden: 'Скрытые',
  column_settings_hide_all: 'Скрыть все',
  column_settings_show_all: 'Показать все',
  column_settings_not_found: 'Поля не найдены',
  column_settings_pin_left: 'Закрепить слева',
  column_settings_pin_right: 'Закрепить справа',
  column_settings_unpin: 'Открепить',
  column_settings_move: 'Переместить',
  apps: 'Приложения',
  workspaceSettingsTabs: {
    general: 'Общие',
    authorization: 'Авторизация',
    mockNotice:
      'Эта вкладка пока является mock-вариантом, основанным на паттернах настроек из примеров SaaS-приложений.',
    automation: {
      tab: 'Автоматизация',
      title: 'Автоматизация и provisioning',
      items: {
        provisioning: 'Автоматический provisioning пользователей (SCIM)',
        lifecycle: 'Политика жизненного цикла workspace',
        directory: 'Расписание синхронизации каталога'
      }
    },
    audit: {
      tab: 'Аудит и соответствие',
      title: 'Контроли аудита и соответствия',
      items: {
        retention: 'Политика хранения audit-логов',
        alerting: 'Оповещения о подозрительных входах',
        exports: 'Плановые экспортные выгрузки для compliance'
      }
    },
    generalDangerZone: {
      title: 'Опасная зона',
      description:
        'Удалить это рабочее пространство навсегда. Это действие нельзя отменить.',
      deleteAction: 'Удалить workspace'
    }
  },
  organization_info: 'Информация об организации',
  organization_info_description:
    'Основные сведения об организации, отображаемые в системе.',
  authMethods: {
    title: 'Методы аутентификации',
    description:
      'Управляйте паролем и социальным входом для организации, включайте шаблоны федерации по необходимости и добавляйте полностью кастомные провайдеры.',
    existingProvidersTitle: 'Провайдеры входа',
    existingProvidersDescription:
      'Встроенные методы синхронизируются с API организации. Шаблоны федерации и кастомные провайдеры используют локальное превью-хранилище до появления backend-эндпоинтов.',
    builtInProvidersSubtitle: 'Встроенные методы',
    federationProvidersSubtitle: 'Шаблоны федерации',
    federationProvidersDescription:
      'Предзаполненные шаблоны IdP. Включайте шаблон только когда он нужен, затем укажите учётные данные и endpoint’ы.',
    customProvidersCardTitle: 'Кастомные провайдеры',
    customProvidersCardDescription:
      'Добавляйте собственные подключения OIDC, OAuth2 или SAML 2.0. Каждый провайдер настраивается в drawer.',
    addCustomProviderTitle: 'Добавить кастомный провайдер',
    editCustomProviderTitle: 'Изменить кастомный провайдер',
    clientProvidersTitle: 'Пользовательские client-провайдеры',
    clientProvidersDescription:
      'Добавляйте внешние провайдеры авторизации, используемые клиентскими приложениями.',
    customProvider: 'Пользовательский провайдер',
    addProvider: 'Добавить провайдера',
    selectProviderPlaceholder: 'Выберите шаблон провайдера',
    addFromCatalog: 'Добавить выбранный провайдер',
    addCustomProvider: 'Добавить пользовательский провайдер',
    catalog: {
      google: 'Google',
      entra: 'Microsoft Entra ID',
      magicLink: 'Magic Link',
      github: 'GitHub',
      apple: 'Apple',
      oktaSaml: 'Okta SAML'
    },
    protocol: 'Протокол',
    scope: 'Scope',
    issuerUrl: 'Issuer URL',
    jwksUrl: 'JWKS URL',
    authorizeUrl: 'Authorize URL',
    tokenUrl: 'Token URL',
    additionalSettings: 'Дополнительные настройки авторизации',
    additionalSettingsDescription:
      'Эти параметры относятся к уровню client и сохраняются как конфигурация workspace.',
    enforceSso: 'Принудительно включить SSO для всех участников',
    enforceSsoHint:
      'Если включено, участники могут входить только через настроенный провайдер SSO. Вход по паролю и другие методы аутентификации отключены для всех, кроме владельцев workspace.',
    allowSelfServiceJoin: 'Разрешить self-service заявки на вступление',
    allowSelfServiceJoinHint:
      'Если включено, пользователи с подтверждённым email, совпадающим с доменом workspace, могут запросить вступление без приглашения. Администраторы по-прежнему одобряют каждую заявку.',
    autoProvisionUsers: 'Автопровиженинг пользователей из identity providers',
    autoProvisionUsersHint:
      'Если включено, учётные записи создаются автоматически при первом входе пользователя через настроенный identity provider, используя данные профиля из IdP.',
    defaultRole: 'Роль по умолчанию для новых пользователей',
    roles: {
      member: 'Участник',
      admin: 'Администратор',
      viewer: 'Наблюдатель'
    },
    password: 'Пароль',
    emailOtp: 'Email OTP',
    qrLogin: 'QR-код',
    google: 'Google',
    entraid: 'Entra ID',
    apple: 'Apple',
    passkey: 'Passkey / WebAuthn',
    setupInstructionsTitle: 'Инструкции по настройке',
    docsLabel: 'Документация по настройке:',
    openDocs: 'Открыть руководство',
    redirectUrlsTitle: 'Разрешённые redirect URL',
    accountAppRedirectUrls: 'Account UI',
    platformWebRedirectUrls: 'EBS Platform Web',
    backendApiRedirectUrls: 'Backend API (один URL подходит всем организациям)',
    mailboxRedirectUrls: 'Подключение ящика — интеграция Outlook',
    googleSetupHint:
      'Создайте OAuth 2.0 Client ID (Web application), затем вставьте ниже Client ID и Client secret.',
    entraidSetupHint:
      'Создайте регистрацию приложения в Microsoft Entra, затем вставьте ниже Client ID, Client secret и Tenant ID. Добавьте оба redirect URL в разделе платформы Web — второй нужен для интеграции почты Outlook.',
    clientId: 'Client ID',
    clientSecret: 'Секрет клиента',
    tenantId: 'Tenant ID',
    teamId: 'Team ID',
    keyId: 'Key ID',
    appleServiceId: 'Service ID',
    applePrivateKey: 'Private Key (PEM)',
    appleSetupHint:
      'Создайте Sign in with Apple Service ID в вашем Apple Developer аккаунте, затем вставьте ниже Service ID, приватный ключ (PEM), Team ID и Key ID.',
    leaveEmptyToKeep: 'Оставьте пустым, чтобы сохранить текущий секрет',
    leaveEmptyToKeepKey: 'Оставьте пустым, чтобы сохранить текущий ключ'
  },
  profileAuthMethods: {
    tab: 'Мои методы аутентификации',
    defaultMethods: 'Методы по умолчанию (системные)',
    defaultMethodsDescription:
      'Используются для входа в аккаунт независимо от организации.',
    perOrganization: 'По организациям',
    perOrganizationDescription:
      'Методы, включённые для каждой организации; привяжите, чтобы использовать их при входе.',
    no_organizations: 'У вас нет организаций.',
    linked: 'Привязан',
    not_linked: 'Не привязан',
    change_password: 'Сменить пароль',
    link: 'Привязать',
    unlink: 'Отвязать',
    unlinkConfirmTitle: 'Отвязать Google?',
    unlinkConfirmContent:
      'Вы больше не сможете входить через Google для этого аккаунта.',
    connectSuccess: 'Аккаунт Google успешно привязан.',
    connectCallbackMissingParams: 'Неверный ответ от Google. Попробуйте снова.',
    unlinkConfirmTitleEntraid: 'Отвязать Microsoft?',
    unlinkConfirmContentEntraid:
      'Вы больше не сможете входить через Microsoft для этого аккаунта.',
    connectSuccessEntraid: 'Аккаунт Microsoft успешно привязан.',
    unlinkConfirmTitleApple: 'Отвязать Apple?',
    unlinkConfirmContentApple:
      'Вы больше не сможете входить через Apple для этого аккаунта.',
    loadError:
      'Не удалось загрузить методы аутентификации для этой организации.',
    retry: 'Повторить',
    noMethodsConfigured:
      'Для этой организации пока не настроены методы аутентификации.',
    noEnabledMethods:
      'Для этой организации нет включённых методов аутентификации.',
    enabled: 'Включено',
    disabled: 'Отключено',
    managedByOrganization: 'Управляется настройками организации',
    connectSuccessApple: 'Аккаунт Apple успешно привязан.'
  },
  logo: 'Логотип',
  change: 'Изменить',
  organization_name: 'Название организации',
  disable_success: 'Успешно отключено',
  disable_user_confirmation: 'Вы уверены, что хотите отключить пользователя?',
  disable: 'Отключить',
  pagination: {
    total: '{{from}} - {{to}} из {{total}} результатов',
    range: '{{from}}–{{to}} из {{total}}'
  },
  organization_deleted: 'Организация успешно удалена',
  no_organization_apps:
    'Нет приложений для организации, для добавления приложения, пожалуйста, войдите в ',
  management_dashboard: 'панель управления.',
  only_upload_image: 'Вы можете загружать только изображения!',
  svgUpload: {
    tooLarge: 'SVG-файл должен быть меньше {{size}} МБ.',
    unreadable: 'Не удалось прочитать этот SVG как изображение.'
  },
  industry: 'Отрасль',
  select_for_example_data: 'Выберите для примера данных',
  please_select: 'Пожалуйста, выберите...',
  reset_data_in_applications: 'Сбросить данные в приложениях',
  do_you_want_to_reset: 'Вы хотите выполнить сброс?',
  do_you_want_to_reset_description:
    'Все данные во всех приложениях будут сброшены к состоянию по умолчанию (в соответствии с отраслью, если применимо). Это действие необратимо после подтверждения.',
  we_are_preparing_your_data:
    'Мы подготавливаем вашу панель, загружая данные, выполняя начальную настройку и обновляя информацию. Это не займет много времени, пожалуйста, подождите.',
  information: 'Информация',
  loading_data: 'Загружаем данные',
  we_are_setting:
    'Мы настраиваем систему для вас. Это не займет много времени!',
  show_details: 'Показать детали',
  hide_details: 'Скрыть детали',
  demoPresets_healthcare_title: 'Здравоохранение',
  demoPresets_healthcare_description:
    'Решения, предназначенные для клиник, больниц и медицинских служб.',
  demoPresets_noData_title: 'Нет данных',
  demoPresets_noData_description: 'Создаёт приложение без демо данных.',
  demoPresets_generic_title: 'Общий',
  demoPresets_generic_description:
    'Универсальный пресет, подходящий для разных отраслей.',
  demoPresets_education_title: 'Образование',
  demoPresets_education_description:
    'Инструменты и процессы для школ, университетов и учебных центров.',
  demoPresets_retail_title: 'Ритейл',
  demoPresets_retail_description: 'Решения для магазинов и торговых точек.',
  demoPresets_finance_title: 'Финансы',
  demoPresets_finance_description:
    'Рабочие процессы, ориентированные на банковские и финансовые услуги.',
  healthcare: 'Здравоохранение',
  no_data: 'Нет данных',
  generic: 'Общий',
  education: 'Образование',
  retail: 'Ритейл',
  finance: 'Финансы',
  go_to_organization: 'Перейти к workspace',
  something_went_wrong: 'Что-то пошло не так',
  please_try_again: 'Пожалуйста, попробуйте снова',
  retry: 'Повторить',
  setup_completed: 'Настройка завершена',
  setup_completed_description:
    'Настройка вашей организации завершена и готова к использованию.',
  in_progress: 'В процессе',
  show_more: 'Показать больше',
  show_less: 'Показать меньше',
  demoPresets_informationTechnology_title: 'Информационные технологии',
  demoPresets_informationTechnology_description:
    'Решения и инструменты для разработки программного обеспечения, систем и цифровой инфраструктуры.',
  information_technology: 'Информационные технологии'
}

export default ru
